import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BillableActivityArrayOrObject: any;
  JSON: any;
  JSONObject: any;
};

export type ActionDefinition = {
  __typename?: 'ActionDefinition';
  actions?: Maybe<Array<Scalars['JSONObject']>>;
  metadata?: Maybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type ActionDefinitionInput = {
  actions?: InputMaybe<Array<Scalars['JSONObject']>>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type ActionDocumentation = {
  __typename?: 'ActionDocumentation';
  relatedActions?: Maybe<Array<Scalars['String']>>;
  requiredServices?: Maybe<Array<Scalars['String']>>;
  usageNotes?: Maybe<Scalars['String']>;
};

export type ActionInfo = {
  __typename?: 'ActionInfo';
  availableScopes?: Maybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  description: Scalars['String'];
  documentation?: Maybe<ActionDocumentation>;
  metadata?: Maybe<ActionMetadata>;
  name: Scalars['String'];
  supportsNesting: Scalars['Boolean'];
  type: Scalars['String'];
};

export type ActionMetadata = {
  __typename?: 'ActionMetadata';
  example?: Maybe<Scalars['JSONObject']>;
  schema?: Maybe<Scalars['JSONObject']>;
};

export type ActionResult = {
  __typename?: 'ActionResult';
  log?: Maybe<Scalars['String']>;
  output?: Maybe<Scalars['JSON']>;
  report?: Maybe<Scalars['JSON']>;
  status: ActionStatus;
  type: Scalars['String'];
};

export enum ActionStatus {
  Complete = 'COMPLETE',
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type AdjustmentUploadDoneInput = {
  fileName: Scalars['String'];
  objectKey: Scalars['String'];
};

export type AdjustmentUploadUrl = {
  __typename?: 'AdjustmentUploadUrl';
  headers: Scalars['JSONObject'];
  objectKey: Scalars['String'];
  url: Scalars['String'];
};

export type AdjustmentUploadUrlInput = {
  fileCategory: Scalars['String'];
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
};

export type Admin = {
  __typename?: 'Admin';
  avatarUrl: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  role: Scalars['String'];
  uuid: Scalars['ID'];
};

export type AggregateHoldsV2ItemType = {
  __typename?: 'AggregateHoldsV2ItemType';
  contractId: Scalars['Int'];
  heldAmount: Scalars['Float'];
  holds: Scalars['String'];
  holdsCount: Scalars['Int'];
  maxFromDate: Scalars['String'];
  maxLastSeenAt: Scalars['String'];
  minFromDate: Scalars['String'];
};

export type AggregateHoldsV2Type = {
  __typename?: 'AggregateHoldsV2Type';
  items: Array<AggregateHoldsV2ItemType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type AssessedRule = {
  __typename?: 'AssessedRule';
  actionLog?: Maybe<Array<ActionResult>>;
  assertionLog?: Maybe<Scalars['JSON']>;
  status: AssessmentStatus;
};

export type AssessmentResult = {
  __typename?: 'AssessmentResult';
  actionsExecuted: Scalars['Float'];
  assertionPassed: Scalars['Float'];
  completed: Scalars['Float'];
  createdAt: Scalars['String'];
  errored: Scalars['Float'];
  id: Scalars['String'];
  ruleAssessmentResultId?: Maybe<Scalars['String']>;
};

export enum AssessmentStatus {
  ActionsExecuted = 'ACTIONS_EXECUTED',
  AssertionPassed = 'ASSERTION_PASSED',
  Completed = 'COMPLETED',
  Errored = 'ERRORED',
  TagCreated = 'TAG_CREATED'
}

export type AssessmentTask = {
  __typename?: 'AssessmentTask';
  actionsExecuted: Scalars['Float'];
  arguments: Scalars['JSON'];
  assertionPassed: Scalars['Float'];
  assessmentResults: Array<AssessmentResult>;
  completed: Scalars['Float'];
  createdAt: Scalars['String'];
  errored: Scalars['Float'];
  id: Scalars['ID'];
  remaining: Scalars['Float'];
  status: Scalars['String'];
  totalAssessments: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type AssessmentTaskList = {
  __typename?: 'AssessmentTaskList';
  assessmentTasks: Array<AssessmentTaskListItem>;
  limit: Scalars['Float'];
  total: Scalars['Float'];
};

export type AssessmentTaskListItem = {
  __typename?: 'AssessmentTaskListItem';
  actionsExecuted: Scalars['Float'];
  arguments: Scalars['JSON'];
  assertionPassed: Scalars['Float'];
  completed: Scalars['Float'];
  createdAt: Scalars['String'];
  errored: Scalars['Float'];
  id: Scalars['ID'];
  remaining: Scalars['Float'];
  status: Scalars['String'];
  totalAssessments: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type Association = {
  __typename?: 'Association';
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type BaseUser = {
  __typename?: 'BaseUser';
  bio?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pathwayProgramIndications?: Maybe<Array<Scalars['String']>>;
  phoneNumber?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type BatchClientInsurerType = {
  __typename?: 'BatchClientInsurerType';
  billingType?: Maybe<Scalars['String']>;
  client: ClientType;
  coreContractRule?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insurer: BatchInsurerType;
  isActive: Scalars['Boolean'];
  partnerships: Array<PartnershipType>;
  termDate?: Maybe<Scalars['String']>;
};

export type BatchContractClientInsurerInput = {
  clientId: Scalars['Int'];
  id: Scalars['Int'];
  insurerId: Scalars['Int'];
};

export type BatchContractResponse = {
  __typename?: 'BatchContractResponse';
  clientInsurerId: Scalars['Int'];
  error: Scalars['String'];
  newContract?: Maybe<ContractType>;
  oldContract?: Maybe<ContractType>;
  success: Scalars['Boolean'];
};

export type BatchCreateProgramCapInput = {
  programCaps: Array<BatchProgramCapItemInput>;
};

export type BatchInsurerType = {
  __typename?: 'BatchInsurerType';
  eligibilityRef: Scalars['String'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type BatchProgramCapItemInput = {
  cap: Scalars['Float'];
  clientId: Scalars['Int'];
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type BatchProgramCapResponseItem = {
  __typename?: 'BatchProgramCapResponseItem';
  clientId: Scalars['Int'];
  endDate: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  programCap?: Maybe<BatchProgramCapResult>;
  startDate: Scalars['String'];
  success: Scalars['Boolean'];
};

export type BatchProgramCapResult = {
  __typename?: 'BatchProgramCapResult';
  cap: Scalars['Float'];
  clientId: Scalars['Int'];
  endDate: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  lastModifiedBy: Scalars['String'];
  startDate: Scalars['String'];
};

export enum BillStatusEnum {
  Archived = 'ARCHIVED',
  NonSubmittable = 'NON_SUBMITTABLE',
  Submittable = 'SUBMITTABLE',
  SubmittableWithBypass = 'SUBMITTABLE_WITH_BYPASS'
}

export type BillSubmissionsType = {
  __typename?: 'BillSubmissionsType';
  baseCharge: Scalars['Float'];
  billAmount?: Maybe<Scalars['Float']>;
  claimIdentifier: Scalars['String'];
  contractId?: Maybe<Scalars['Int']>;
  coverageId?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  engagementEvent?: Maybe<EngagementBaseType>;
  eventUuid?: Maybe<Scalars['String']>;
  fromDate: Scalars['String'];
  id: Scalars['Float'];
  internalHolds: Array<InternalHoldBaseType>;
  pathwayId?: Maybe<Scalars['Float']>;
  paymentType: Scalars['String'];
  source: Scalars['String'];
  sourceId: Scalars['Float'];
  status: Scalars['String'];
  submissions: Array<SubmissionRemitsType>;
  subscriptionPackageId?: Maybe<Scalars['Float']>;
  toDate?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type BillableActivityType = {
  __typename?: 'BillableActivityType';
  createdAt: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  engagementTypeId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type BillingModelType = {
  __typename?: 'BillingModelType';
  createdAt: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type BillingType = {
  __typename?: 'BillingType';
  value: Scalars['String'];
};

export type BillsPaginatedType = {
  __typename?: 'BillsPaginatedType';
  items: Array<PaginatedBillType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type BlacklistType = {
  __typename?: 'BlacklistType';
  engagementTypes?: Maybe<Array<Scalars['JSONObject']>>;
  packages?: Maybe<Array<Scalars['String']>>;
};

export type BulkEligibilityCheckInput = {
  billIds: Array<Scalars['Int']>;
  mode: EligibilitySearchDepthEnum;
  note?: InputMaybe<Scalars['String']>;
};

export type BulkUpdateBillingTypeInput = {
  billingType?: InputMaybe<Scalars['String']>;
  contractIds: Array<Scalars['Int']>;
};

export type BulkUpdateBillingTypeResponse = {
  __typename?: 'BulkUpdateBillingTypeResponse';
  contractsUpdated: Scalars['Int'];
};

export type BulkUpdateBillsInput = {
  billIds: Array<Scalars['Int']>;
  clientInsurerId?: InputMaybe<Scalars['Int']>;
  contractId?: InputMaybe<Scalars['Int']>;
  note: Scalars['String'];
  statusChange: BillStatusEnum;
};

export type BulkUpdateBillsResponse = {
  __typename?: 'BulkUpdateBillsResponse';
  details: Scalars['String'];
};

export type BulkUpdateSubmissionsInput = {
  ids: Array<Scalars['Int']>;
  netsuiteId: Scalars['String'];
  note: Scalars['String'];
};

export type BulkUpdateSubmissionsResponse = {
  __typename?: 'BulkUpdateSubmissionsResponse';
  ids: Array<Scalars['Int']>;
};

export type BulkVoidSubmissionsInput = {
  ids: Array<Scalars['Int']>;
  note: Scalars['String'];
  status: Scalars['String'];
};

export type BulkVoidSubscriptionsInput = {
  ids: Array<Scalars['Int']>;
  note: Scalars['String'];
};

export type ClearHoldsInput = {
  billIds: Array<Scalars['Int']>;
  holdTypes?: Array<ClearableHoldTypes>;
};

export type ClearHoldsResponse = {
  __typename?: 'ClearHoldsResponse';
  details: Scalars['String'];
};

export enum ClearableHoldTypes {
  ManualHold = 'MANUAL_HOLD'
}

export type ClientInsurerByClientType = {
  __typename?: 'ClientInsurerByClientType';
  clientsInsurers: Array<ClientInsurerDetailsType>;
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type ClientInsurerDetailsType = {
  __typename?: 'ClientInsurerDetailsType';
  billingType?: Maybe<Scalars['String']>;
  client: ClientType;
  id: Scalars['Int'];
  insurer: InsurerBasicType;
  isActive: Scalars['Boolean'];
  partnerships: Array<PartnershipType>;
  termDate?: Maybe<Scalars['String']>;
};

export type ClientInsurerType = {
  __typename?: 'ClientInsurerType';
  billingType?: Maybe<Scalars['String']>;
  client: ClientType;
  coreContractRule?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insurer: InsurerType;
  isActive: Scalars['Boolean'];
  partnerships: Array<PartnershipType>;
  termDate?: Maybe<Scalars['String']>;
};

export type ClientType = {
  __typename?: 'ClientType';
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type ConsultResultType = {
  __typename?: 'ConsultResultType';
  consultMessage?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  hhUuid: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type ContractPackagesInput = {
  billableActivityTypes?: InputMaybe<Scalars['BillableActivityArrayOrObject']>;
  billingEnabled?: InputMaybe<Scalars['Boolean']>;
  billingModelId?: InputMaybe<Scalars['Int']>;
  billingTypeOverride?: InputMaybe<Scalars['String']>;
  contractId?: InputMaybe<Scalars['Int']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  costShareOptions?: InputMaybe<CostShareOptionInputType>;
  id?: InputMaybe<Scalars['Int']>;
  packageId: Scalars['Int'];
  price?: InputMaybe<Scalars['Float']>;
  rules?: InputMaybe<Scalars['JSON']>;
  startDate?: InputMaybe<Scalars['String']>;
  void?: InputMaybe<Scalars['Boolean']>;
};

export type ContractPackagesType = {
  __typename?: 'ContractPackagesType';
  billableActivityTypes: Array<BillableActivityType>;
  billingEnabled: Scalars['Boolean'];
  billingModel: BillingModelType;
  billingModelId: Scalars['Int'];
  billingTypeOverride?: Maybe<Scalars['String']>;
  contractId: Scalars['Int'];
  contractTemplateId?: Maybe<Scalars['Int']>;
  costShareOptions?: Maybe<CostShareOptionsType>;
  createdAt: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  package: PackageType;
  packageId: Scalars['Int'];
  price: Scalars['Float'];
  rules?: Maybe<Scalars['JSON']>;
  startDate?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  void: Scalars['Boolean'];
};

export type ContractTemplateType = {
  __typename?: 'ContractTemplateType';
  contract: Array<ContractTypeUnion>;
  contractType?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  partnershipId?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['String'];
};

export type ContractTermSummary = {
  __typename?: 'ContractTermSummary';
  numAdminFeeClaims: Scalars['Float'];
  numFeeForServiceEvents: Scalars['Float'];
  numSubmissions: Scalars['Float'];
  numSubscriptions: Scalars['Float'];
  sumSubmissionAmount: Scalars['Float'];
};

export type ContractType = {
  __typename?: 'ContractType';
  acutePrice?: Maybe<Scalars['Float']>;
  billableActivityTypes: Array<BillableActivityType>;
  billingType?: Maybe<Scalars['String']>;
  chronicPrice?: Maybe<Scalars['Float']>;
  clientId: Scalars['Float'];
  clientsInsurerId: Scalars['Float'];
  contract?: Maybe<Array<ContractTypeUnion>>;
  contractPackages: Array<ContractPackagesType>;
  contractTemplateId?: Maybe<Scalars['Float']>;
  contractType?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  globalDailyEngagementCap?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  insurerId: Scalars['Float'];
  lastModifiedBy: Scalars['String'];
  packageEnabled: Scalars['Boolean'];
  partnershipId?: Maybe<Scalars['Float']>;
  startDate: Scalars['String'];
  updatedAt: Scalars['String'];
  userAnnualCap?: Maybe<Scalars['Float']>;
  void: Scalars['Boolean'];
};

export type ContractTypeUnion = EngagementContractType | IndividualMilestonesType | MilestonesType;

export type ContractsPaginatedType = {
  __typename?: 'ContractsPaginatedType';
  items: Array<ContractType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type CorrectionBaseType = {
  __typename?: 'CorrectionBaseType';
  correctionAmount: Scalars['Float'];
  correctionsType: CorrectionTypeEnum;
  createdAt: Scalars['String'];
  lastModifiedBy: Scalars['String'];
  netsuiteId: Scalars['String'];
  submissionId?: Maybe<Scalars['Int']>;
};

export enum CorrectionTypeEnum {
  CreditMemo = 'CREDIT_MEMO',
  InvoiceCorrection = 'INVOICE_CORRECTION'
}

export type CostShareOptionInputType = {
  cadence: Scalars['String'];
  deductionTiming: Scalars['String'];
};

export type CostShareOptionsType = {
  __typename?: 'CostShareOptionsType';
  cadence: Scalars['String'];
  contractPackageId: Scalars['Int'];
  createdAt: Scalars['String'];
  deductionTiming: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type CostShareSetupOptionType = {
  __typename?: 'CostShareSetupOptionType';
  cadence: Array<Scalars['String']>;
  deductionTiming: Array<Scalars['String']>;
};

export type CptCodes = {
  __typename?: 'CptCodes';
  acuteCptCodes?: Maybe<Array<Scalars['String']>>;
};

export type CreateAssessmentTaskInput = {
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  resourceType?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type CreateAssociationInput = {
  type: Scalars['String'];
  typeId: Scalars['String'];
};

export type CreateBatchContractInput = {
  billingType?: InputMaybe<Scalars['String']>;
  clientInsurers: Array<BatchContractClientInsurerInput>;
  contractPackages?: InputMaybe<Array<ContractPackagesInput>>;
  currency?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  globalDailyEngagementCap?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['String'];
  userAnnualCap: Scalars['Float'];
};

export type CreateConfigurationInput = {
  actions: Array<Scalars['JSONObject']>;
  dataProvider: Scalars['String'];
  definition: Scalars['JSONObject'];
  name: Scalars['String'];
};

export type CreateContractInput = {
  acutePrice?: InputMaybe<Scalars['Float']>;
  billableActivityTypes?: InputMaybe<Scalars['BillableActivityArrayOrObject']>;
  billingType?: InputMaybe<Scalars['String']>;
  chronicPrice?: InputMaybe<Scalars['Float']>;
  clientId: Scalars['Float'];
  clientsInsurerId: Scalars['Float'];
  contract?: InputMaybe<Array<Scalars['JSONObject']>>;
  contractPackages?: InputMaybe<Array<ContractPackagesInput>>;
  contractTemplateId?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  globalDailyEngagementCap?: InputMaybe<Scalars['Int']>;
  insurerId: Scalars['Float'];
  packageEnabled?: InputMaybe<Scalars['Boolean']>;
  partnershipId?: InputMaybe<Scalars['Float']>;
  startDate: Scalars['String'];
  userAnnualCap?: InputMaybe<Scalars['Float']>;
};

export type CreateCvsFeeScheduleInput = {
  charge: Scalars['String'];
  daysSupply: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  upc: Scalars['String'];
};

export type CreateDiscountInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<Scalars['Float']>;
  discountType: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<ScopeInput>>;
  startDate: Scalars['String'];
  suppressEmptyCharges: Scalars['Boolean'];
  vbdTiers?: InputMaybe<Array<VbdTierInput>>;
};

export type CreateEsiFeeScheduleInput = {
  description?: InputMaybe<Scalars['String']>;
  paymentType: Scalars['String'];
  price: Scalars['Float'];
  program?: InputMaybe<Scalars['String']>;
  upc: Scalars['String'];
};

export type CreateFacetInput = {
  associations?: InputMaybe<Array<CreateAssociationInput>>;
  description: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CreateFeeScheduleInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityId: Scalars['Int'];
  entityType: FeeScheduleEntityType;
  notes?: InputMaybe<Scalars['String']>;
  paymentSystem: PaymentSystemType;
  paymentType: Scalars['String'];
  price: Scalars['Float'];
};

export type CreateIcdCodeInput = {
  endDate: Scalars['String'];
  indication: Scalars['String'];
  leftCode?: InputMaybe<Scalars['String']>;
  rightCode?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
  universalCode: Scalars['String'];
};

export type CreatePackageInput = {
  name: Scalars['String'];
  packageOffering: PackageOfferingEnum;
  productId?: InputMaybe<Scalars['Int']>;
  programIndications?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateProcedureCodeInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  cptCode: Scalars['String'];
  insurerId?: InputMaybe<Scalars['Int']>;
  modifier1?: InputMaybe<Scalars['String']>;
  modifier2?: InputMaybe<Scalars['String']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  paymentTypeId: Scalars['Int'];
};

export type CreateProgramCapInput = {
  cap: Scalars['Float'];
  clientId: Scalars['Int'];
  endDate: Scalars['String'];
  lockDate?: InputMaybe<Scalars['String']>;
  lockPrice?: InputMaybe<Scalars['Float']>;
  startDate: Scalars['String'];
};

export type CreateRevenueShareInput = {
  applyToPrice: Scalars['Boolean'];
  clientId?: InputMaybe<Scalars['Int']>;
  discount: Scalars['Float'];
  effectiveYear: Scalars['Int'];
  partnershipId?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<ScopeInput>>;
};

export type CreateRuleAssessmentInput = {
  resource: Scalars['String'];
  resourceId: Scalars['String'];
  resourceType?: InputMaybe<Scalars['String']>;
  ruleIds?: InputMaybe<Array<Scalars['String']>>;
  source: Scalars['String'];
  userId: Scalars['String'];
};

export type CreateRuleInput = {
  actions?: InputMaybe<Array<ActionDefinitionInput>>;
  definition: RuleDefinitionInput;
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
  source: Scalars['String'];
};

export type CreateSubscriptionEstimateInput = {
  contractId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['String']>;
  grossAmount: Scalars['Float'];
  reserveAmount: Scalars['Float'];
  startDate: Scalars['String'];
};

export type CreateTagInput = {
  description: Scalars['String'];
  name: Scalars['String'];
};

export type CreateUserTagInput = {
  occurredAt: Scalars['String'];
  resourceId: Scalars['String'];
  source: Scalars['String'];
  tagName: Scalars['String'];
  userId: Scalars['String'];
};

export type CurrencyCodeType = {
  __typename?: 'CurrencyCodeType';
  value: Scalars['String'];
};

export type CvsFeeScheduleType = {
  __typename?: 'CvsFeeScheduleType';
  charge: Scalars['String'];
  createdAt: Scalars['String'];
  daysSupply: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  paymentType?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  upc: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type CvsResponseType = {
  __typename?: 'CvsResponseType';
  errors?: Maybe<Scalars['JSONObject']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  upstreamResponseContent: Scalars['JSONObject'];
};

export type DagRunRequestInput = {
  conf: Scalars['JSONObject'];
  note?: InputMaybe<Scalars['String']>;
};

export type DagRunResponseType = {
  __typename?: 'DagRunResponseType';
  dagId: Scalars['String'];
  dagRunId: Scalars['String'];
  logicalDate: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  state: Scalars['String'];
};

export type DefaultConfigType = {
  __typename?: 'DefaultConfigType';
  engagement: Scalars['String'];
  package: Scalars['String'];
  price: Scalars['Float'];
};

export type DiscountDetail = {
  __typename?: 'DiscountDetail';
  clientId?: Maybe<Scalars['Int']>;
  discount: Scalars['Int'];
  discountDefinitionId: Scalars['Int'];
  discountDetailId: Scalars['Int'];
  discountType: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  insurerId?: Maybe<Scalars['Int']>;
  milestoneDiscount?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  partnershipId?: Maybe<Scalars['Int']>;
  scopes: Array<Scope>;
  startDate: Scalars['String'];
  subscriptionTier: Array<Maybe<Scalars['Int']>>;
  suppressEmptyCharges: Scalars['Boolean'];
  tier: Scalars['Int'];
};

export type DiscountDetailItem = {
  __typename?: 'DiscountDetailItem';
  discount: Scalars['Int'];
  id: Scalars['Int'];
  milestoneDiscount?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  subscriptionTier: Array<Maybe<Scalars['Int']>>;
  tier: Scalars['Int'];
};

export type DiscountUsage = {
  __typename?: 'DiscountUsage';
  discountDetailId?: Maybe<Scalars['Float']>;
  discountPercent?: Maybe<Scalars['Float']>;
  discountSum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Float'];
};

export type DiscountWithDetails = {
  __typename?: 'DiscountWithDetails';
  clientId?: Maybe<Scalars['Int']>;
  discountDetails: Array<DiscountDetailItem>;
  discountType: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insurerId?: Maybe<Scalars['Int']>;
  partnershipId?: Maybe<Scalars['Int']>;
  scopes: Array<Scope>;
  startDate: Scalars['String'];
  suppressEmptyCharges: Scalars['Boolean'];
};

export type DiscountWithDetailsPaginatedType = {
  __typename?: 'DiscountWithDetailsPaginatedType';
  items: Array<DiscountWithDetails>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export enum EligibilitySearchDepthEnum {
  Deep = 'DEEP',
  Standard = 'STANDARD'
}

export type EngagementBaseType = {
  __typename?: 'EngagementBaseType';
  billableCount: Scalars['Int'];
  createdAt: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  eventId?: Maybe<Scalars['Int']>;
  eventType: Scalars['String'];
  eventUuid?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  occurredAt: Scalars['String'];
  pathwayUuid: Scalars['String'];
  programId?: Maybe<Scalars['Int']>;
  programIndication: Scalars['String'];
  queuedAt: Scalars['String'];
  sourceType: Scalars['String'];
  userUuid: Scalars['String'];
};

export type EngagementContractType = {
  __typename?: 'EngagementContractType';
  activityTypes: Array<Scalars['String']>;
  educationalTypes: Array<Scalars['String']>;
  engagementRules: Array<Scalars['JSONObject']>;
  matchType: Scalars['String'];
};

export type EngagementType = {
  __typename?: 'EngagementType';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type EngagementsPaginationType = {
  __typename?: 'EngagementsPaginationType';
  items: Array<EngagementBaseType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type EnrollUsersInput = {
  patientUuids: Array<Scalars['ID']>;
  workflowType: Scalars['String'];
};

export type EnrollUsersModel = {
  __typename?: 'EnrollUsersModel';
  enrolledUuids: Array<Scalars['String']>;
  failedUuids: Array<Scalars['String']>;
};

export type EsiFeeScheduleType = {
  __typename?: 'EsiFeeScheduleType';
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  paymentType: Scalars['String'];
  price: Scalars['Float'];
  program?: Maybe<Scalars['String']>;
  upc: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type Facet = {
  __typename?: 'Facet';
  associations?: Maybe<Array<Association>>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
  value: Scalars['String'];
};

export type FacetsList = {
  __typename?: 'FacetsList';
  count: Scalars['Float'];
  facets: Array<Facet>;
};

export type FeeForServiceEvent = {
  __typename?: 'FeeForServiceEvent';
  adminUuid?: Maybe<Scalars['String']>;
  contractId: Scalars['Int'];
  contractPackageId: Scalars['Int'];
  createdAt: Scalars['String'];
  engagementEventId: Scalars['Int'];
  id: Scalars['Float'];
  lastModifiedBy: Scalars['String'];
  occurredAt: Scalars['String'];
  pathwayUuid: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['Int'];
  userUuid: Scalars['String'];
  void: Scalars['Boolean'];
};

export type FeeForServiceEventPaginated = {
  __typename?: 'FeeForServiceEventPaginated';
  items: Array<FeeForServiceEvent>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export enum FeeScheduleEntityType {
  Client = 'CLIENT',
  Partnership = 'PARTNERSHIP'
}

export type FeeScheduleType = {
  __typename?: 'FeeScheduleType';
  createdAt: Scalars['String'];
  enabled: Scalars['Boolean'];
  entityId: Scalars['Int'];
  entityType: FeeScheduleEntityType;
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  paymentSystem: PaymentSystemType;
  paymentType: Scalars['String'];
  price: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type FeeSchedulesPaginatedType = {
  __typename?: 'FeeSchedulesPaginatedType';
  items: Array<FeeScheduleType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type FileConfigurationInput = {
  bucket: Scalars['String'];
  columnMappings: Scalars['JSONObject'];
  description: Scalars['String'];
  encodingDetection: Scalars['Boolean'];
  entityTags: Scalars['JSONObject'];
  fileOperations?: InputMaybe<Array<Scalars['JSONObject']>>;
  groupOperations?: InputMaybe<Array<Scalars['JSONObject']>>;
  individualOperations: Array<Scalars['JSONObject']>;
  name: Scalars['String'];
  parser: Scalars['JSONObject'];
  pgpEncrypted?: InputMaybe<Scalars['Boolean']>;
  provider: Scalars['String'];
  regex: Scalars['String'];
};

export type FileDetails = {
  __typename?: 'FileDetails';
  schemas: Scalars['JSONObject'];
};

export type FileUploadStatus = {
  __typename?: 'FileUploadStatus';
  status: Scalars['String'];
};

export type GenerateProgramCapReportInput = {
  programCapId: Scalars['Int'];
};

export type GetCvsEligibilityInput = {
  clientCode: Scalars['String'];
  dateOfBirth: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender: Scalars['String'];
  inquiryDate?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Float']>;
};

export type GetFileConfigurationFrontendResponse = {
  __typename?: 'GetFileConfigurationFrontendResponse';
  bucket: Scalars['String'];
  columnMappings: Scalars['JSONObject'];
  description: Scalars['String'];
  encodingDetection: Scalars['Boolean'];
  entityTags: Scalars['JSONObject'];
  fileOperations: Array<Scalars['JSONObject']>;
  groupOperations: Array<Scalars['JSONObject']>;
  individualOperations: Array<Scalars['JSONObject']>;
  name: Scalars['String'];
  parser: Scalars['JSONObject'];
  provider: Scalars['String'];
  regex: Scalars['String'];
};

export type GetFileConfigurationsResponseType = {
  __typename?: 'GetFileConfigurationsResponseType';
  items: Array<Scalars['JSONObject']>;
  page: Scalars['Float'];
  pages: Scalars['Float'];
  size: Scalars['Float'];
  total: Scalars['Float'];
};

export type GetIndividualOperationsInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type GoogleFileInputType = {
  fileCategory: Scalars['String'];
  fileLink: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type HealthRecord = {
  __typename?: 'HealthRecord';
  createdAt: Scalars['String'];
  data: Scalars['JSONObject'];
  id: Scalars['ID'];
  origin?: Maybe<Scalars['String']>;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  source: Scalars['String'];
  userId: Scalars['String'];
};

export type HealthRecordLinks = {
  __typename?: 'HealthRecordLinks';
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
};

export type HealthRecordMetadata = {
  __typename?: 'HealthRecordMetadata';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  origin?: Maybe<Scalars['String']>;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  source: Scalars['String'];
  userId: Scalars['String'];
};

export type HealthRecordSources = {
  __typename?: 'HealthRecordSources';
  count: Scalars['Float'];
  sources: Array<Scalars['String']>;
};

export type HealthRecordsList = {
  __typename?: 'HealthRecordsList';
  count: Scalars['Float'];
  healthRecords: Array<HealthRecordMetadata>;
  links: HealthRecordLinks;
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
};

export type HoldDetailsType = {
  __typename?: 'HoldDetailsType';
  clearedAt?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['JSON']>;
  holdType: Scalars['String'];
  insurerId?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
};

export type IcdCode = {
  __typename?: 'IcdCode';
  createdAt: Scalars['String'];
  endDate: Scalars['String'];
  id: Scalars['Int'];
  indication: Scalars['String'];
  lastModifiedBy: Scalars['String'];
  leftCode?: Maybe<Scalars['String']>;
  rightCode?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  universalCode: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type IcdCodesPaginated = {
  __typename?: 'IcdCodesPaginated';
  items: Array<IcdCode>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type IndividualMilestonesType = {
  __typename?: 'IndividualMilestonesType';
  billableActivityTypes: Array<Scalars['String']>;
  conditions: Array<MilestoneConditionType>;
  name: Scalars['String'];
  payment: Scalars['Float'];
};

export type InsurerBasicType = {
  __typename?: 'InsurerBasicType';
  eligibilityRef: Scalars['String'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type InsurerType = {
  __typename?: 'InsurerType';
  eligibilityRef: Scalars['String'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type InternalHoldBaseType = {
  __typename?: 'InternalHoldBaseType';
  billId: Scalars['Float'];
  clearedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  details?: Maybe<Scalars['JSON']>;
  holdType: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type InternalHoldType = {
  __typename?: 'InternalHoldType';
  value: Scalars['String'];
};

export type ListAssessmentTasksInput = {
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type ListBatchesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<PdgFileParsingBatchStatus>;
};

export type ListConfigurationsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  dataProvider?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PdgConfigurationStatus>;
};

export type ListFacetsInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
};

export type ListHealthRecordsInput = {
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  next?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type ListIngestionsInput = {
  createdAfter?: InputMaybe<Scalars['String']>;
  createdBefore?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  dataProvider?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<PdgFileProcessingStatus>;
};

export type ListRecordsInput = {
  batchId: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListRuleAssessmentsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type ListRulesInput = {
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RuleStatus>;
};

export type ListTagsInput = {
  deleted?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ListUserTagsInput = {
  facetName?: InputMaybe<Scalars['String']>;
  occurredFrom?: InputMaybe<Scalars['String']>;
  occurredTo?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['String']>;
};

export type ManualHoldInput = {
  billIds: Array<Scalars['Int']>;
  note: Scalars['String'];
};

export type ManualHoldResponse = {
  __typename?: 'ManualHoldResponse';
  details: Scalars['String'];
};

export type MappingType = {
  __typename?: 'MappingType';
  options: Array<Scalars['JSONObject']>;
  values: Scalars['JSONObject'];
};

export type MilestoneConditionType = {
  __typename?: 'MilestoneConditionType';
  function: Scalars['String'];
  threshold?: Maybe<Scalars['Float']>;
};

export type MilestoneDiscountInput = {
  c1: Scalars['Float'];
  c2: Scalars['Float'];
  c3: Scalars['Float'];
};

export type MilestonesType = {
  __typename?: 'MilestonesType';
  billableActivityTypes: Array<Scalars['String']>;
  conditions: Array<MilestoneConditionType>;
  dateOfServiceOffset: Scalars['Float'];
  dayRange: Array<Scalars['Int']>;
  name: Scalars['String'];
  payment: Scalars['Float'];
};

export type ModuleType = {
  __typename?: 'ModuleType';
  description: Scalars['String'];
  id: Scalars['Float'];
  identifier: Scalars['String'];
  name: Scalars['String'];
  schema: Scalars['JSONObject'];
  version: Scalars['Float'];
};

export type ModulesResponse = {
  __typename?: 'ModulesResponse';
  items: Array<ModuleType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adjustmentUploadDone: TaskBase;
  batchCreateProgramCap: Array<BatchProgramCapResponseItem>;
  bulkEligibilityCheck: WorkflowBase;
  bulkUpdateBillingType: BulkUpdateBillingTypeResponse;
  bulkUpdateBills: BulkUpdateBillsResponse;
  bulkUpdateSubmissions: BulkUpdateSubmissionsResponse;
  bulkVoidSubmissions: Array<Scalars['Int']>;
  bulkVoidSubscriptions: Array<Scalars['Int']>;
  clearHolds: ClearHoldsResponse;
  createAssessmentTask: AssessmentTask;
  createBatchContract: Array<BatchContractResponse>;
  createContract: ContractType;
  createContractPackage: ContractPackagesType;
  createCvsFeeSchedule: CvsFeeScheduleType;
  createDiscount: Array<DiscountDetail>;
  createEsiFeeSchedule: EsiFeeScheduleType;
  createFacet: Facet;
  createFeeSchedule: FeeScheduleType;
  createFileConfiguration: UpsertFileConfigurationResponseType;
  createIcdCode: IcdCode;
  createManualHold: ManualHoldResponse;
  createPackage: PackageType;
  createPackageContract: ContractType;
  createProcedureCode: ProcedureCode;
  createProgramCap: ProgramCap;
  createRevenueShare: Array<RevenueShareDetail>;
  createRule: Rule;
  createRuleAssessment: RuleAssessment;
  createSubscriptionEstimate: SubscriptionEstimateType;
  createTag: Tag;
  createUserTag: UserTag;
  deleteCvsFeeSchedule: Scalars['Boolean'];
  deleteEsiFeeSchedule: Scalars['Boolean'];
  deleteFeeSchedule: Scalars['Boolean'];
  deleteIcdCode: Scalars['Boolean'];
  deletePackage: Scalars['Boolean'];
  deleteProcedureCode: Scalars['Boolean'];
  deleteRule: Rule;
  deleteTag: Tag;
  deleteUserTag: UserTag;
  enrollUsers: EnrollUsersModel;
  generateProgramCapReport: Scalars['Boolean'];
  getAdjustmentUploadUrl: AdjustmentUploadUrl;
  googleFileUpload: TaskBase;
  pdgControlIngestion: PdgControlResult;
  pdgCreateConfiguration: PdgConfiguration;
  pdgUpdateConfiguration: PdgConfiguration;
  pdgUpdateConfigurationStatus: PdgConfiguration;
  processCopayment: ProcessCopaymentResponse;
  runClaimsManualWebDag: DagRunResponseType;
  setPhoneForUser: Scalars['Boolean'];
  updateAssessmentTask: AssessmentTask;
  updateContract: ContractType;
  updateContractPackage: ContractPackagesType;
  updateCvsFeeSchedule: CvsFeeScheduleType;
  updateDiscount: Array<DiscountDetail>;
  updateEsiFeeSchedule: EsiFeeScheduleType;
  updateFeeSchedule: FeeScheduleType;
  updateFileConfiguration: UpsertFileConfigurationResponseType;
  updateIcdCode: IcdCode;
  updatePackage: PackageType;
  updateProcedureCode: ProcedureCode;
  updateProgramCap: ProgramCap;
  updateRevenueShare: Array<RevenueShareDetail>;
  updateRule: Rule;
  updateSubscriptionEstimate: SubscriptionEstimateType;
};


export type MutationAdjustmentUploadDoneArgs = {
  input: AdjustmentUploadDoneInput;
};


export type MutationBatchCreateProgramCapArgs = {
  batchCreateProgramCapInput: BatchCreateProgramCapInput;
  dryRun?: Scalars['Boolean'];
};


export type MutationBulkEligibilityCheckArgs = {
  bulkEligibilityCheckInput: BulkEligibilityCheckInput;
};


export type MutationBulkUpdateBillingTypeArgs = {
  input: BulkUpdateBillingTypeInput;
};


export type MutationBulkUpdateBillsArgs = {
  bulkUpdateBillsInput: BulkUpdateBillsInput;
};


export type MutationBulkUpdateSubmissionsArgs = {
  bulkUpdateSubmissionsInput: BulkUpdateSubmissionsInput;
};


export type MutationBulkVoidSubmissionsArgs = {
  bulkVoidSubmissionsInput: BulkVoidSubmissionsInput;
};


export type MutationBulkVoidSubscriptionsArgs = {
  bulkVoidSubscriptionsInput: BulkVoidSubscriptionsInput;
};


export type MutationClearHoldsArgs = {
  clearHoldsInput: ClearHoldsInput;
};


export type MutationCreateAssessmentTaskArgs = {
  createAssessmentTaskInput: CreateAssessmentTaskInput;
};


export type MutationCreateBatchContractArgs = {
  batchContractInput: CreateBatchContractInput;
};


export type MutationCreateContractArgs = {
  contractInput: CreateContractInput;
};


export type MutationCreateContractPackageArgs = {
  contractPackageInput: ContractPackagesInput;
};


export type MutationCreateCvsFeeScheduleArgs = {
  cvsFeeScheduleInput: CreateCvsFeeScheduleInput;
};


export type MutationCreateDiscountArgs = {
  discountInput: CreateDiscountInput;
};


export type MutationCreateEsiFeeScheduleArgs = {
  esiFeeScheduleInput: CreateEsiFeeScheduleInput;
};


export type MutationCreateFacetArgs = {
  createFacetInput: CreateFacetInput;
};


export type MutationCreateFeeScheduleArgs = {
  feeScheduleInput: CreateFeeScheduleInput;
};


export type MutationCreateFileConfigurationArgs = {
  createFileConfigurationInput: FileConfigurationInput;
};


export type MutationCreateIcdCodeArgs = {
  icdCodeInput: CreateIcdCodeInput;
};


export type MutationCreateManualHoldArgs = {
  manualHoldInput: ManualHoldInput;
};


export type MutationCreatePackageArgs = {
  packageInput: CreatePackageInput;
};


export type MutationCreatePackageContractArgs = {
  contractInput: CreateContractInput;
};


export type MutationCreateProcedureCodeArgs = {
  procedureCodeInput: CreateProcedureCodeInput;
};


export type MutationCreateProgramCapArgs = {
  createProgramCapInput: CreateProgramCapInput;
};


export type MutationCreateRevenueShareArgs = {
  revenueShareInput: CreateRevenueShareInput;
};


export type MutationCreateRuleArgs = {
  createRuleInput: CreateRuleInput;
};


export type MutationCreateRuleAssessmentArgs = {
  createRuleAssessmentInput: CreateRuleAssessmentInput;
};


export type MutationCreateSubscriptionEstimateArgs = {
  input: CreateSubscriptionEstimateInput;
};


export type MutationCreateTagArgs = {
  createTagInput: CreateTagInput;
};


export type MutationCreateUserTagArgs = {
  createUserTagInput: CreateUserTagInput;
};


export type MutationDeleteCvsFeeScheduleArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteEsiFeeScheduleArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteFeeScheduleArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteIcdCodeArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePackageArgs = {
  packageId: Scalars['Int'];
};


export type MutationDeleteProcedureCodeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRuleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserTagArgs = {
  id: Scalars['String'];
};


export type MutationEnrollUsersArgs = {
  input: EnrollUsersInput;
};


export type MutationGenerateProgramCapReportArgs = {
  generateProgramCapReportInput: GenerateProgramCapReportInput;
};


export type MutationGetAdjustmentUploadUrlArgs = {
  input: AdjustmentUploadUrlInput;
};


export type MutationGoogleFileUploadArgs = {
  fileInput: GoogleFileInputType;
};


export type MutationPdgControlIngestionArgs = {
  action: PdgControlAction;
  eventId: Scalars['String'];
};


export type MutationPdgCreateConfigurationArgs = {
  input: CreateConfigurationInput;
};


export type MutationPdgUpdateConfigurationArgs = {
  id: Scalars['String'];
  input: UpdateConfigurationInput;
};


export type MutationPdgUpdateConfigurationStatusArgs = {
  id: Scalars['String'];
  status: PdgConfigurationStatus;
};


export type MutationProcessCopaymentArgs = {
  processCopaymentInput: ProcessCopaymentInput;
};


export type MutationRunClaimsManualWebDagArgs = {
  dagRunRequestInput: DagRunRequestInput;
};


export type MutationSetPhoneForUserArgs = {
  hhUuid: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationUpdateAssessmentTaskArgs = {
  id: Scalars['String'];
  updateAssessmentTaskInput: UpdateAssessmentTaskInput;
};


export type MutationUpdateContractArgs = {
  contractId: Scalars['Int'];
  contractInput: UpdateContractInput;
};


export type MutationUpdateContractPackageArgs = {
  contractPackageId: Scalars['Int'];
  contractPackageInput: ContractPackagesInput;
};


export type MutationUpdateCvsFeeScheduleArgs = {
  cvsFeeScheduleInput: UpdateCvsFeeScheduleInput;
  id: Scalars['Int'];
};


export type MutationUpdateDiscountArgs = {
  discountInput: UpdateDiscountInput;
};


export type MutationUpdateEsiFeeScheduleArgs = {
  esiFeeScheduleInput: UpdateEsiFeeScheduleInput;
  id: Scalars['Int'];
};


export type MutationUpdateFeeScheduleArgs = {
  feeScheduleInput: UpdateFeeScheduleInput;
  id: Scalars['Int'];
};


export type MutationUpdateFileConfigurationArgs = {
  id: Scalars['Float'];
  updateFileConfigurationInput: FileConfigurationInput;
};


export type MutationUpdateIcdCodeArgs = {
  icdCodeInput: UpdateIcdCodeInput;
  id: Scalars['Int'];
};


export type MutationUpdatePackageArgs = {
  packageId: Scalars['Int'];
  packageInput: UpdatePackageInput;
};


export type MutationUpdateProcedureCodeArgs = {
  id: Scalars['Int'];
  procedureCodeInput: UpdateProcedureCodeInput;
};


export type MutationUpdateProgramCapArgs = {
  updateProgramCapInput: UpdateProgramCapInput;
};


export type MutationUpdateRevenueShareArgs = {
  revenueShareInput: UpdateRevenueShareInput;
};


export type MutationUpdateRuleArgs = {
  id: Scalars['String'];
  updateRuleInput: UpdateRuleInput;
};


export type MutationUpdateSubscriptionEstimateArgs = {
  id: Scalars['Int'];
  input: UpdateSubscriptionEstimateInput;
};

export enum PackageOfferingEnum {
  Product = 'PRODUCT',
  ProgramIndication = 'PROGRAM_INDICATION'
}

export type PackageOfferingsType = {
  __typename?: 'PackageOfferingsType';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  packageId: Scalars['Int'];
  packageOffering: Scalars['String'];
  productId?: Maybe<Scalars['Int']>;
  programIndication?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type PackageRulesType = {
  __typename?: 'PackageRulesType';
  billingModels: Scalars['JSONObject'];
};

export type PackageType = {
  __typename?: 'PackageType';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  isEditable?: Maybe<Scalars['Boolean']>;
  lastModifiedBy: Scalars['String'];
  name: Scalars['String'];
  packageOfferings: Array<PackageOfferingsType>;
  updatedAt: Scalars['String'];
};

export type PaginatedBillType = {
  __typename?: 'PaginatedBillType';
  baseCharge: Scalars['Float'];
  billAmount?: Maybe<Scalars['Float']>;
  billId: Scalars['Float'];
  claimId: Scalars['String'];
  contractId?: Maybe<Scalars['Float']>;
  dateOfService: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  holdDetails?: Maybe<HoldDetailsType>;
  netsuiteId?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  sourceId: Scalars['Float'];
  status: Scalars['String'];
  submissionAmount?: Maybe<Scalars['Float']>;
  submissionDate?: Maybe<Scalars['String']>;
  submissionId?: Maybe<Scalars['Float']>;
  submissionStatus?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
  userUuid: Scalars['String'];
};

export type PaginatedSubmissionType = {
  __typename?: 'PaginatedSubmissionType';
  baseCharge: Scalars['Float'];
  billAmount?: Maybe<Scalars['Float']>;
  billId: Scalars['Float'];
  clientPrice?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  coverageId?: Maybe<Scalars['Float']>;
  dateOfService: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  netsuiteId?: Maybe<Scalars['String']>;
  paymentType: Scalars['String'];
  source: Scalars['String'];
  sourceId: Scalars['Float'];
  submissionAmount?: Maybe<Scalars['Float']>;
  submissionDate?: Maybe<Scalars['String']>;
  submissionId: Scalars['Float'];
  submissionStatus?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
  userUuid?: Maybe<Scalars['String']>;
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Float']>;
};

export type PartnershipType = {
  __typename?: 'PartnershipType';
  allowCohortExpansion: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  partnershipType: Scalars['String'];
  requiresStateCredentials: Scalars['Boolean'];
};

export type Pathway = {
  __typename?: 'Pathway';
  indication: Scalars['String'];
  program: Scalars['String'];
  screening: Screening;
  totalPoints: Scalars['Float'];
};

export enum PaymentSystemType {
  Alight = 'ALIGHT',
  Bcbsal = 'BCBSAL',
  Bcbsma = 'BCBSMA',
  Cvs = 'CVS',
  Esi = 'ESI',
  Netsuite = 'NETSUITE',
  Stonebrook = 'STONEBROOK',
  Waystar = 'WAYSTAR'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  code: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PdgActionTypeDefinition = {
  __typename?: 'PdgActionTypeDefinition';
  description: Scalars['String'];
  fields: Array<Scalars['JSONObject']>;
  label: Scalars['String'];
  scopes: Array<Scalars['String']>;
  type: Scalars['String'];
};

export type PdgActionsCatalog = {
  __typename?: 'PdgActionsCatalog';
  actionTypes: Array<PdgActionTypeDefinition>;
};

export type PdgAssessmentMatch = {
  __typename?: 'PdgAssessmentMatch';
  configurationId: Scalars['String'];
  configurationName: Scalars['String'];
  configurationStatus: Scalars['String'];
  createdAt: Scalars['String'];
  eventId: Scalars['String'];
  id: Scalars['String'];
  matched: Scalars['Boolean'];
  report?: Maybe<Scalars['JSONObject']>;
};

export type PdgAssessmentsList = {
  __typename?: 'PdgAssessmentsList';
  items: Array<PdgAssessmentMatch>;
};

export type PdgBatchHeatmapCell = {
  __typename?: 'PdgBatchHeatmapCell';
  batchId: Scalars['String'];
  byteOffsetEnd: Scalars['String'];
  byteOffsetStart: Scalars['String'];
  createdAt: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  rowCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['String']>;
  status: PdgFileParsingBatchStatus;
  updatedAt: Scalars['String'];
};

export type PdgBatchTotals = {
  __typename?: 'PdgBatchTotals';
  completed: Scalars['Int'];
  failed: Scalars['Int'];
  inProgress: Scalars['Int'];
  pending: Scalars['Int'];
  skipped: Scalars['Int'];
  total: Scalars['Int'];
};

export type PdgBatchesList = {
  __typename?: 'PdgBatchesList';
  items: Array<PdgBatchHeatmapCell>;
  pageInfo: PdgPageInfo;
  totals: PdgBatchTotals;
};

export type PdgChildWorkflowProgress = {
  __typename?: 'PdgChildWorkflowProgress';
  cachedCount?: Maybe<Scalars['Int']>;
  outboxEventsEmitted?: Maybe<Scalars['Int']>;
  pendingCount: Scalars['Int'];
  resolvedCount: Scalars['Int'];
};

export type PdgChildWorkflowSummary = {
  __typename?: 'PdgChildWorkflowSummary';
  endedAt?: Maybe<Scalars['String']>;
  progress?: Maybe<PdgChildWorkflowProgress>;
  startedAt: Scalars['String'];
  status: Scalars['String'];
  workflowId: Scalars['String'];
  workflowType: Scalars['String'];
};

export type PdgConfiguration = {
  __typename?: 'PdgConfiguration';
  actions: Array<Scalars['JSONObject']>;
  createdAt: Scalars['String'];
  dataProvider: Scalars['String'];
  definition: Scalars['JSONObject'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: PdgConfigurationStatus;
  updatedAt: Scalars['String'];
};

export enum PdgConfigurationStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type PdgConfigurationsList = {
  __typename?: 'PdgConfigurationsList';
  items: Array<PdgConfiguration>;
  pageInfo: PdgPageInfo;
};

export enum PdgControlAction {
  Cancel = 'CANCEL',
  Pause = 'PAUSE',
  Resume = 'RESUME'
}

export type PdgControlResult = {
  __typename?: 'PdgControlResult';
  action: PdgControlAction;
  eventId: Scalars['String'];
  status: PdgFileProcessingStatus;
};

export type PdgDataProvidersList = {
  __typename?: 'PdgDataProvidersList';
  items: Array<Scalars['String']>;
};

export enum PdgFileParsingBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Skipped = 'SKIPPED'
}

export enum PdgFileProcessingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Finalizing = 'FINALIZING',
  Parsing = 'PARSING',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Resolving = 'RESOLVING',
  Validating = 'VALIDATING'
}

export type PdgFileRecordPreview = {
  __typename?: 'PdgFileRecordPreview';
  batchId: Scalars['String'];
  createdAt: Scalars['String'];
  eventId: Scalars['String'];
  id: Scalars['String'];
  originalRowIndex: Scalars['Int'];
  rawData: Scalars['JSONObject'];
};

export type PdgIngestionDetail = {
  __typename?: 'PdgIngestionDetail';
  bucket?: Maybe<Scalars['String']>;
  childWorkflow?: Maybe<PdgChildWorkflowSummary>;
  completedAt?: Maybe<Scalars['String']>;
  completedBatches: Scalars['Int'];
  createdAt: Scalars['String'];
  dataProvider?: Maybe<Scalars['String']>;
  eTag?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  eventTime?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  liveProgress?: Maybe<PdgWorkflowProgress>;
  liveProgressSource: Scalars['String'];
  recordMapping: PdgRecordMappingCounts;
  s3Key: Scalars['String'];
  sourceResolution: PdgSourceResolutionCounts;
  stageHistory: Array<PdgStageHistoryEntry>;
  status: PdgFileProcessingStatus;
  temporalWorkflowId: Scalars['String'];
  totalBatches: Scalars['Int'];
  totalRowsParsed: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PdgIngestionSummary = {
  __typename?: 'PdgIngestionSummary';
  bucket?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  completedBatches: Scalars['Int'];
  createdAt: Scalars['String'];
  dataProvider?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  fileExtension?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  s3Key: Scalars['String'];
  status: PdgFileProcessingStatus;
  totalBatches: Scalars['Int'];
  totalRowsParsed: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PdgIngestionSummaryStats = {
  __typename?: 'PdgIngestionSummaryStats';
  byStatus: Scalars['JSONObject'];
  totalRowsParsed: Scalars['String'];
  window: PdgSummaryWindow;
};

export type PdgIngestionsList = {
  __typename?: 'PdgIngestionsList';
  items: Array<PdgIngestionSummary>;
  pageInfo: PdgPageInfo;
};

export type PdgPageInfo = {
  __typename?: 'PdgPageInfo';
  hasNextPage: Scalars['Boolean'];
  nextCursor?: Maybe<Scalars['String']>;
};

export type PdgQuarantinedCounts = {
  __typename?: 'PdgQuarantinedCounts';
  ambiguous: Scalars['String'];
  noMatch: Scalars['String'];
  total: Scalars['String'];
};

export type PdgRecordMappingCounts = {
  __typename?: 'PdgRecordMappingCounts';
  finalized: PdgRecordMappingFinalized;
  live: PdgRecordMappingLive;
};

export type PdgRecordMappingFinalized = {
  __typename?: 'PdgRecordMappingFinalized';
  dropped: Scalars['String'];
  failed: Scalars['String'];
  mapped: Scalars['String'];
};

export type PdgRecordMappingLive = {
  __typename?: 'PdgRecordMappingLive';
  byFailureReason: Scalars['JSONObject'];
  dropped: Scalars['String'];
  failed: Scalars['String'];
  mapped: Scalars['String'];
  pending: Scalars['String'];
  source: Scalars['String'];
};

export type PdgRecordsList = {
  __typename?: 'PdgRecordsList';
  items: Array<PdgFileRecordPreview>;
  pageInfo: PdgPageInfo;
};

export type PdgSourceResolutionCounts = {
  __typename?: 'PdgSourceResolutionCounts';
  failed: Scalars['String'];
  quarantined: PdgQuarantinedCounts;
  resolved: Scalars['String'];
};

export type PdgStageHistoryEntry = {
  __typename?: 'PdgStageHistoryEntry';
  durationMs?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['String']>;
  stage: Scalars['String'];
  startedAt: Scalars['String'];
  status: Scalars['String'];
};

export type PdgSummaryWindow = {
  __typename?: 'PdgSummaryWindow';
  hours: Scalars['Int'];
  since: Scalars['String'];
};

export type PdgValidationReport = {
  __typename?: 'PdgValidationReport';
  createdAt: Scalars['String'];
  eventId: Scalars['String'];
  id: Scalars['String'];
  report: Scalars['JSONObject'];
  status: Scalars['String'];
};

export type PdgWorkflowProgress = {
  __typename?: 'PdgWorkflowProgress';
  completedBatches: Scalars['Int'];
  currentBatchIndex: Scalars['Int'];
  eventId: Scalars['String'];
  failedBatches: Scalars['Int'];
  isCancelled: Scalars['Boolean'];
  isPaused: Scalars['Boolean'];
  percentComplete: Scalars['Float'];
  status: Scalars['String'];
  totalBatches: Scalars['Int'];
  totalRowsFailed: Scalars['Int'];
  totalRowsParsed: Scalars['Int'];
  validationStatus?: Maybe<Scalars['String']>;
};

export type ProcedureCode = {
  __typename?: 'ProcedureCode';
  clientId?: Maybe<Scalars['Int']>;
  cptCode: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  insurerId?: Maybe<Scalars['Int']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  modifier1?: Maybe<Scalars['String']>;
  modifier2?: Maybe<Scalars['String']>;
  partnershipId?: Maybe<Scalars['Int']>;
  paymentType?: Maybe<PaymentType>;
  paymentTypeId: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type ProcedureCodesPaginated = {
  __typename?: 'ProcedureCodesPaginated';
  items: Array<ProcedureCode>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type ProcessCopaymentInput = {
  billIds: Array<Scalars['Int']>;
  copayAmount: Scalars['Float'];
};

export type ProcessCopaymentResponse = {
  __typename?: 'ProcessCopaymentResponse';
  workflowIds: Array<Scalars['String']>;
};

export type ProductOffering = {
  __typename?: 'ProductOffering';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  name: Scalars['String'];
  productId: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type ProductType = {
  __typename?: 'ProductType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ProgramCap = {
  __typename?: 'ProgramCap';
  cap: Scalars['Float'];
  clientId: Scalars['Int'];
  correctedUserBasedLockPrice?: Maybe<Scalars['Float']>;
  correctedUserBasedLockPriceCalculatedAt?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  lockDate?: Maybe<Scalars['String']>;
  lockPrice?: Maybe<Scalars['Float']>;
  startDate: Scalars['String'];
};

export type ProgramCapPaginated = {
  __typename?: 'ProgramCapPaginated';
  items: Array<ProgramCap>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type ProgramCapRefund = {
  __typename?: 'ProgramCapRefund';
  averageStickerPrice: Scalars['Float'];
  cap: Scalars['Float'];
  clientId: Scalars['Float'];
  endDate: Scalars['String'];
  lockDate?: Maybe<Scalars['String']>;
  lockPrice?: Maybe<Scalars['Float']>;
  numMembers: Scalars['Float'];
  programCapId: Scalars['Float'];
  refundPerMember: Scalars['Float'];
  reportLink?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  sumAmount: Scalars['Float'];
  totalRefundAmount: Scalars['Float'];
};

export type ProgramIndicationType = {
  __typename?: 'ProgramIndicationType';
  id: Scalars['Int'];
  identifier: Scalars['String'];
  indicationName: Scalars['String'];
  programId: Scalars['Int'];
  programName: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  aggregateHoldsV2: AggregateHoldsV2Type;
  getAllClients: Array<ClientType>;
  getAllEngagementTypes: Array<EngagementType>;
  getAllInsurers: Array<InsurerType>;
  getAllInternalHoldTypes: Array<InternalHoldType>;
  getAllPackages: Array<PackageType>;
  getAllProducts: Array<ProductType>;
  getAssessmentTask: AssessmentTask;
  getBillById: BillSubmissionsType;
  getBillingModels: Array<BillingModelType>;
  getBillingTypes: Array<BillingType>;
  getBills: BillsPaginatedType;
  getBillsByFeeForServiceEventId: Array<BillSubmissionsType>;
  getBillsBySubscriptionId: Array<BillSubmissionsType>;
  getClaimsManualWebDagRunStatus: DagRunResponseType;
  getClientInsurerById: ClientInsurerType;
  getClientInsurersByClient: ClientInsurerByClientType;
  getClientInsurersByIds: Array<BatchClientInsurerType>;
  getColumnMappings: MappingType;
  getConsultResultById: ConsultResultType;
  getContractIds: Array<Scalars['Int']>;
  getContractTemplates: Array<ContractTemplateType>;
  getContractTermSummary: ContractTermSummary;
  getContractsV2: ContractsPaginatedType;
  getCostShareSetupOptions: CostShareSetupOptionType;
  getCurrencyCodes: Array<CurrencyCodeType>;
  getCvsEligibility: CvsResponseType;
  getCvsFeeSchedules: Array<CvsFeeScheduleType>;
  getDiscountUsage: Array<DiscountUsage>;
  getDiscounts: Array<DiscountDetail>;
  getDiscountsPaginated: DiscountWithDetailsPaginatedType;
  getEngagementsByUserUuid: EngagementsPaginationType;
  getEsiFeeSchedules: Array<EsiFeeScheduleType>;
  getFacet: Facet;
  getFeeForServiceEngagements: EngagementsPaginationType;
  getFeeForServiceEvents: FeeForServiceEventPaginated;
  getFeeScheduleById: FeeScheduleType;
  getFeeSchedules: FeeSchedulesPaginatedType;
  getFileConfiguration: GetFileConfigurationFrontendResponse;
  getFileConfigurations: GetFileConfigurationsResponseType;
  getFileDetails: FileDetails;
  getFileUploadStatus: FileUploadStatus;
  getHealthRecord: HealthRecord;
  getIcdCodes: IcdCodesPaginated;
  getIndividualOperations: Array<ModuleType>;
  getPackageRules: PackageRulesType;
  getParserModules: ModulesResponse;
  getPartnerships: Array<PartnershipType>;
  getPaymentTypes: Array<PaymentType>;
  getPhoneStatusForUser: UserPhoneStatus;
  getProcedureCodes: ProcedureCodesPaginated;
  getProgramCapRefundById: ProgramCapRefund;
  getProgramCaps: ProgramCapPaginated;
  getProgramIndicationsById: Array<ProgramIndicationType>;
  getResolvedProcedureCodes: Array<ProcedureCode>;
  getRevenueShares: Array<RevenueShareDetail>;
  getRule: Rule;
  getRuleAssessment: RuleAssessment;
  getSubmissions: SubmissionsPaginatedType;
  getSubscriptionEngagements: EngagementsPaginationType;
  getSubscriptionHoldsByUser: Array<SubscriptionHoldType>;
  getSubscriptions: SubscriptionsPaginationType;
  getSupportedActions: SupportedActionsResult;
  getTask: TaskInformation;
  getTemporalWorkflow: TemporalWorkflowInformation;
  getUnbilledBills: UnbilledBillsPaginatedType;
  getUserTag: UserTag;
  getUserUuidById: UserLimitedType;
  getValidContractsForHoldRelease: Array<ContractType>;
  getWorkflowsByFilter: WorkflowListPayload;
  listAssessmentTasks: AssessmentTaskList;
  listFacets: FacetsList;
  listHealthRecordSources: HealthRecordSources;
  listHealthRecords: HealthRecordsList;
  listHealthRecordsAtCursor: HealthRecordsList;
  listRuleAssessments: RuleAssessmentsList;
  listRules: RulesList;
  listTags: TagsList;
  listUserTags: UserTagsList;
  pdgActionsCatalog: PdgActionsCatalog;
  pdgConfiguration: PdgConfiguration;
  pdgConfigurations: PdgConfigurationsList;
  pdgDataProviders: PdgDataProvidersList;
  pdgIngestion: PdgIngestionDetail;
  pdgIngestionAssessments: PdgAssessmentsList;
  pdgIngestionBatches: PdgBatchesList;
  pdgIngestionRecords: PdgRecordsList;
  pdgIngestionSummary: PdgIngestionSummaryStats;
  pdgIngestionValidation: PdgValidationReport;
  pdgIngestions: PdgIngestionsList;
  productOfferings: Array<ProductOffering>;
  subscriptionEstimates: Array<SubscriptionEstimateType>;
};


export type QueryAggregateHoldsV2Args = {
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  fromDate?: InputMaybe<Scalars['String']>;
  holdTypes?: InputMaybe<Array<Scalars['String']>>;
  minHeldAmount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetAssessmentTaskArgs = {
  id: Scalars['String'];
};


export type QueryGetBillByIdArgs = {
  billId: Scalars['Int'];
};


export type QueryGetBillsArgs = {
  billAmount?: InputMaybe<Scalars['Float']>;
  billIds?: InputMaybe<Array<Scalars['Int']>>;
  billStatuses?: InputMaybe<Array<BillStatusEnum>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['String']>;
  held?: InputMaybe<Scalars['Boolean']>;
  internalHoldTypes?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  paymentTypes?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Array<Array<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceEndDate?: InputMaybe<Scalars['String']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceStartDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  submissionStatuses?: InputMaybe<Array<SubmissionStatusEnum>>;
  submitted?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  userUuids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetBillsByFeeForServiceEventIdArgs = {
  feeForServiceEventId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetBillsBySubscriptionIdArgs = {
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetClaimsManualWebDagRunStatusArgs = {
  dagRunId: Scalars['String'];
};


export type QueryGetClientInsurerByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetClientInsurersByClientArgs = {
  id: Scalars['String'];
};


export type QueryGetClientInsurersByIdsArgs = {
  billingType?: InputMaybe<Scalars['String']>;
  billingTypes?: InputMaybe<Array<Scalars['String']>>;
  clientIdentifier?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  insurerIds?: InputMaybe<Array<Scalars['Int']>>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  scope?: InputMaybe<ScopeType>;
};


export type QueryGetConsultResultByIdArgs = {
  consultId: Scalars['String'];
};


export type QueryGetContractIdsArgs = {
  billingTypes?: InputMaybe<Array<Scalars['String']>>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  clientsInsurerIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['String']>;
  includeVoided?: InputMaybe<Scalars['Boolean']>;
  insurerIds?: InputMaybe<Array<Scalars['Int']>>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetContractTemplatesArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetContractTermSummaryArgs = {
  contractId: Scalars['Int'];
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type QueryGetContractsV2Args = {
  billingTypes?: InputMaybe<Array<Scalars['String']>>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  clientsInsurerIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  contractType?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  includeVoided?: InputMaybe<Scalars['Boolean']>;
  insurerIds?: InputMaybe<Array<Scalars['Int']>>;
  packageEnabled?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  requireBillingTypeOverrideMatch?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetCvsEligibilityArgs = {
  getCvsEligibilityInput: GetCvsEligibilityInput;
};


export type QueryGetDiscountUsageArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  discountDetailIds?: InputMaybe<Array<Scalars['Int']>>;
  partnershipId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDiscountsArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  discountDefinitionId?: InputMaybe<Scalars['Int']>;
  discountDetailId?: InputMaybe<Scalars['Int']>;
  discountType?: InputMaybe<Scalars['String']>;
  inquiryDate?: InputMaybe<Scalars['String']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  scopeType?: InputMaybe<ScopeType>;
};


export type QueryGetDiscountsPaginatedArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  discountDefinitionId?: InputMaybe<Scalars['Int']>;
  discountDetailId?: InputMaybe<Scalars['Int']>;
  discountType?: InputMaybe<Scalars['String']>;
  filterPackages?: InputMaybe<Scalars['Boolean']>;
  inquiryDate?: InputMaybe<Scalars['String']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  scopeType?: InputMaybe<ScopeType>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetEngagementsByUserUuidArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['String'];
  uuid: Scalars['String'];
};


export type QueryGetFacetArgs = {
  id: Scalars['String'];
};


export type QueryGetFeeForServiceEngagementsArgs = {
  feeForServiceEventId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFeeForServiceEventsArgs = {
  contractId?: InputMaybe<Scalars['Int']>;
  includeVoid?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  userUuids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetFeeScheduleByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetFeeSchedulesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityIds?: InputMaybe<Array<Scalars['Int']>>;
  entityType: FeeScheduleEntityType;
  page?: InputMaybe<Scalars['Int']>;
  paymentSystems?: InputMaybe<Array<PaymentSystemType>>;
  paymentTypes?: InputMaybe<Array<Scalars['String']>>;
  priceMax?: InputMaybe<Scalars['Float']>;
  priceMin?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFileConfigurationArgs = {
  id: Scalars['Float'];
};


export type QueryGetFileConfigurationsArgs = {
  paginationInput: PaginationInput;
};


export type QueryGetFileUploadStatusArgs = {
  taskId: Scalars['String'];
};


export type QueryGetHealthRecordArgs = {
  id: Scalars['String'];
};


export type QueryGetIcdCodesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetIndividualOperationsArgs = {
  getIndividualOperationsInput: GetIndividualOperationsInput;
};


export type QueryGetPartnershipsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGetPhoneStatusForUserArgs = {
  hhUuid: Scalars['String'];
};


export type QueryGetProcedureCodesArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  paymentType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProgramCapRefundByIdArgs = {
  programCapId: Scalars['Int'];
};


export type QueryGetProgramCapsArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  programCapIds?: InputMaybe<Array<Scalars['Int']>>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProgramIndicationsByIdArgs = {
  programIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetResolvedProcedureCodesArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetRevenueSharesArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  effectiveYear?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  revenueShareDefinitionId?: InputMaybe<Scalars['Int']>;
  scopeType?: InputMaybe<ScopeType>;
};


export type QueryGetRuleArgs = {
  id: Scalars['String'];
};


export type QueryGetRuleAssessmentArgs = {
  id: Scalars['String'];
};


export type QueryGetSubmissionsArgs = {
  billIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  creditMemoIds?: InputMaybe<Array<Scalars['String']>>;
  netsuiteIds?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sourceEndDate?: InputMaybe<Scalars['String']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceStartDate?: InputMaybe<Scalars['String']>;
  submissionEndDate?: InputMaybe<Scalars['String']>;
  submissionIds?: InputMaybe<Array<Scalars['Int']>>;
  submissionStartDate?: InputMaybe<Scalars['String']>;
  submissionStatuses?: InputMaybe<Array<SubmissionStatusEnum>>;
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetSubscriptionEngagementsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  subscriptionId: Scalars['Int'];
};


export type QueryGetSubscriptionHoldsByUserArgs = {
  userId?: InputMaybe<Scalars['Int']>;
  userUuid?: InputMaybe<Scalars['String']>;
};


export type QueryGetSubscriptionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeVoid?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
  userUuid?: InputMaybe<Scalars['String']>;
};


export type QueryGetTaskArgs = {
  taskId: Scalars['String'];
};


export type QueryGetTemporalWorkflowArgs = {
  workflowId: Scalars['String'];
};


export type QueryGetUnbilledBillsArgs = {
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  paymentTypes?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserTagArgs = {
  id: Scalars['String'];
};


export type QueryGetUserUuidByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetValidContractsForHoldReleaseArgs = {
  clientsInsurerId: Scalars['Int'];
  maxDateOfService: Scalars['String'];
  minDateOfService: Scalars['String'];
};


export type QueryGetWorkflowsByFilterArgs = {
  workflowFiltersInputDto: WorkflowListFiltersInputDto;
  workflowType?: InputMaybe<Scalars['String']>;
};


export type QueryListAssessmentTasksArgs = {
  listAssessmentTasksInput?: InputMaybe<ListAssessmentTasksInput>;
};


export type QueryListFacetsArgs = {
  listFacetsInput?: InputMaybe<ListFacetsInput>;
};


export type QueryListHealthRecordsArgs = {
  listHealthRecordsInput: ListHealthRecordsInput;
};


export type QueryListHealthRecordsAtCursorArgs = {
  cursorPath: Scalars['String'];
};


export type QueryListRuleAssessmentsArgs = {
  listRuleAssessmentsInput?: InputMaybe<ListRuleAssessmentsInput>;
};


export type QueryListRulesArgs = {
  listRulesInput?: InputMaybe<ListRulesInput>;
};


export type QueryListTagsArgs = {
  listTagsInput?: InputMaybe<ListTagsInput>;
};


export type QueryListUserTagsArgs = {
  listUserTagsInput: ListUserTagsInput;
};


export type QueryPdgConfigurationArgs = {
  id: Scalars['String'];
};


export type QueryPdgConfigurationsArgs = {
  input?: InputMaybe<ListConfigurationsInput>;
};


export type QueryPdgIngestionArgs = {
  eventId: Scalars['String'];
};


export type QueryPdgIngestionAssessmentsArgs = {
  eventId: Scalars['String'];
};


export type QueryPdgIngestionBatchesArgs = {
  eventId: Scalars['String'];
  input?: InputMaybe<ListBatchesInput>;
};


export type QueryPdgIngestionRecordsArgs = {
  eventId: Scalars['String'];
  input: ListRecordsInput;
};


export type QueryPdgIngestionSummaryArgs = {
  windowHours?: InputMaybe<Scalars['Int']>;
};


export type QueryPdgIngestionValidationArgs = {
  eventId: Scalars['String'];
};


export type QueryPdgIngestionsArgs = {
  input?: InputMaybe<ListIngestionsInput>;
};


export type QuerySubscriptionEstimatesArgs = {
  contractId?: InputMaybe<Scalars['Int']>;
};

export type RemitBaseType = {
  __typename?: 'RemitBaseType';
  createdAt: Scalars['String'];
  icn?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  patientPaymentAmount: Scalars['Float'];
  payer: Scalars['String'];
  paymentAmount: Scalars['Float'];
  paymentDate?: Maybe<Scalars['String']>;
  paymentNumber?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  responseDate: Scalars['String'];
  sourceOfRecord: Scalars['String'];
};

export type RevenueShareDetail = {
  __typename?: 'RevenueShareDetail';
  applyToPrice: Scalars['Boolean'];
  clientId?: Maybe<Scalars['Int']>;
  discount: Scalars['Float'];
  effectiveYear: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  partnershipId?: Maybe<Scalars['Int']>;
  revenueShareDefinitionId: Scalars['Int'];
  revenueShareDetailId: Scalars['Int'];
  scopes: Array<Scope>;
  subscriptionTier: Array<Maybe<Scalars['Int']>>;
  tier: Scalars['Int'];
};

export type Rule = {
  __typename?: 'Rule';
  actions?: Maybe<Array<ActionDefinition>>;
  createdAt: Scalars['String'];
  definition: RuleDefinition;
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  resourceTypes?: Maybe<Array<Scalars['String']>>;
  source: Scalars['String'];
  status: RuleStatus;
  updatedAt: Scalars['String'];
  version: Scalars['Float'];
};

export type RuleAssessment = {
  __typename?: 'RuleAssessment';
  assessedRules: Array<AssessedRule>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  resourceId: Scalars['String'];
  resourceType?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['String'];
};

export type RuleAssessmentsList = {
  __typename?: 'RuleAssessmentsList';
  ruleAssessments: Array<RuleAssessment>;
  total: Scalars['Float'];
};

export type RuleDefinition = {
  __typename?: 'RuleDefinition';
  criteria: Array<Scalars['JSONObject']>;
  name: Scalars['String'];
  operator: Scalars['String'];
};

export type RuleDefinitionInput = {
  criteria: Array<Scalars['JSONObject']>;
  name: Scalars['String'];
  operator: Scalars['String'];
};

export enum RuleStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type RulesList = {
  __typename?: 'RulesList';
  rules: Array<Rule>;
  total: Scalars['Float'];
};

export type RulesType = {
  __typename?: 'RulesType';
  countPerContract?: Maybe<Scalars['Float']>;
  disabledBefore?: Maybe<Scalars['String']>;
  offeringsType: Scalars['String'];
  schema?: Maybe<Scalars['String']>;
};

export type Scope = {
  __typename?: 'Scope';
  scopeableId?: Maybe<Scalars['Int']>;
  scopeableType: ScopeableType;
};

export type ScopeInput = {
  scopeableId?: InputMaybe<Scalars['Int']>;
  scopeableType: ScopeableType;
};

export enum ScopeType {
  Exclusive = 'EXCLUSIVE',
  Inclusive = 'INCLUSIVE'
}

export enum ScopeableType {
  Global = 'GLOBAL',
  Package = 'PACKAGE',
  ProductOffering = 'PRODUCT_OFFERING',
  Program = 'PROGRAM'
}

export type Screening = {
  __typename?: 'Screening';
  id: Scalars['String'];
};

export type SubmissionRemitsType = {
  __typename?: 'SubmissionRemitsType';
  billId: Scalars['Float'];
  corrections: Array<CorrectionBaseType>;
  coverageId?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  id: Scalars['Float'];
  netsuiteId?: Maybe<Scalars['String']>;
  remits: Array<RemitBaseType>;
  status: Scalars['String'];
  submissionAmount: Scalars['Float'];
  submissionDate: Scalars['String'];
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum SubmissionStatusEnum {
  Accepted = 'ACCEPTED',
  Denied = 'DENIED',
  Duplicate = 'DUPLICATE',
  Reversal = 'REVERSAL',
  Submitted = 'SUBMITTED',
  Unknown = 'UNKNOWN',
  Void = 'VOID'
}

export type SubmissionsPaginatedType = {
  __typename?: 'SubmissionsPaginatedType';
  items: Array<PaginatedSubmissionType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type SubscriptionEstimateType = {
  __typename?: 'SubscriptionEstimateType';
  contractId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  grossAmount: Scalars['Float'];
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  reserveAmount: Scalars['Float'];
  startDate: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type SubscriptionHoldType = {
  __typename?: 'SubscriptionHoldType';
  clearedAt?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['JSONObject']>;
  firstSeenAt: Scalars['String'];
  hitCount: Scalars['Float'];
  id: Scalars['Float'];
  lastSeenAt: Scalars['String'];
  programId?: Maybe<Scalars['Float']>;
  reason: Scalars['String'];
  userId: Scalars['Float'];
  userUuid: Scalars['String'];
};

export type SubscriptionPackageType = {
  __typename?: 'SubscriptionPackageType';
  contractPackageId: Scalars['Float'];
  createdAt: Scalars['String'];
  eventUuid: Scalars['String'];
  id: Scalars['Float'];
  packageCap: Scalars['Float'];
  startsAt: Scalars['String'];
  subscriptionId: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type SubscriptionTierInput = {
  lower?: InputMaybe<Scalars['Int']>;
  upper?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionType = {
  __typename?: 'SubscriptionType';
  contractId: Scalars['Float'];
  createdAt: Scalars['String'];
  endsAt: Scalars['String'];
  id: Scalars['Float'];
  pathwayId: Scalars['Float'];
  pathwayUuid: Scalars['String'];
  programId?: Maybe<Scalars['Float']>;
  startsAt: Scalars['String'];
  subscriptionPackages?: Maybe<Array<SubscriptionPackageType>>;
  termDate?: Maybe<Scalars['String']>;
  userId: Scalars['Float'];
  userUuid: Scalars['String'];
  void: Scalars['Boolean'];
  yearCount: Scalars['Float'];
};

export type SubscriptionsPaginationType = {
  __typename?: 'SubscriptionsPaginationType';
  items: Array<SubscriptionType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type SupportedActionsResult = {
  __typename?: 'SupportedActionsResult';
  actions: Array<ActionInfo>;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type TagsList = {
  __typename?: 'TagsList';
  count: Scalars['Float'];
  tags: Array<Tag>;
};

export type Task = {
  __typename?: 'Task';
  adminUuid?: Maybe<Scalars['ID']>;
  completedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  dueDate?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  selection?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type TaskBase = {
  __typename?: 'TaskBase';
  taskId: Scalars['String'];
};

export type TaskInformation = {
  __typename?: 'TaskInformation';
  name?: Maybe<TaskName>;
  result?: Maybe<Scalars['JSON']>;
  status: Scalars['String'];
};

export enum TaskName {
  EligibilityRecheckTask = 'ELIGIBILITY_RECHECK_TASK',
  MonitorTask = 'MONITOR_TASK',
  RegenerateBillTask = 'REGENERATE_BILL_TASK',
  UploadFileTask = 'UPLOAD_FILE_TASK',
  UploadFromGsheetsTask = 'UPLOAD_FROM_GSHEETS_TASK'
}

export type TemporalWorkflowInformation = {
  __typename?: 'TemporalWorkflowInformation';
  failureMessage?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSON']>;
  status: Scalars['String'];
  workflowId: Scalars['String'];
  workflowType: Scalars['String'];
};

export type UnbilledBillType = {
  __typename?: 'UnbilledBillType';
  billsCount: Scalars['Float'];
  contractId: Scalars['Float'];
  unbilled?: Maybe<Scalars['Float']>;
};

export type UnbilledBillsPaginatedType = {
  __typename?: 'UnbilledBillsPaginatedType';
  items: Array<UnbilledBillType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type UpdateAssessmentTaskInput = {
  status: Scalars['String'];
};

export type UpdateConfigurationInput = {
  actions?: InputMaybe<Array<Scalars['JSONObject']>>;
  dataProvider?: InputMaybe<Scalars['String']>;
  definition?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateContractInput = {
  acutePrice?: InputMaybe<Scalars['Float']>;
  billableActivityTypes?: InputMaybe<Scalars['BillableActivityArrayOrObject']>;
  billingType?: InputMaybe<Scalars['String']>;
  chronicPrice?: InputMaybe<Scalars['Float']>;
  clientId?: InputMaybe<Scalars['Float']>;
  clientsInsurerId?: InputMaybe<Scalars['Float']>;
  contract?: InputMaybe<Array<Scalars['JSONObject']>>;
  contractPackages?: InputMaybe<Array<ContractPackagesInput>>;
  contractTemplateId?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  globalDailyEngagementCap?: InputMaybe<Scalars['Int']>;
  insurerId?: InputMaybe<Scalars['Float']>;
  packageEnabled?: InputMaybe<Scalars['Boolean']>;
  partnershipId?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['String']>;
  userAnnualCap?: InputMaybe<Scalars['Float']>;
  void?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCvsFeeScheduleInput = {
  charge?: InputMaybe<Scalars['String']>;
  daysSupply?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  upc?: InputMaybe<Scalars['String']>;
};

export type UpdateDiscountInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<Scalars['Float']>;
  discountDefinitionId: Scalars['Int'];
  discountType?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<ScopeInput>>;
  startDate?: InputMaybe<Scalars['String']>;
  suppressEmptyCharges?: InputMaybe<Scalars['Boolean']>;
  vbdTiers?: InputMaybe<Array<VbdTierInput>>;
};

export type UpdateEsiFeeScheduleInput = {
  description?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  program?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<Scalars['String']>;
};

export type UpdateFeeScheduleInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<FeeScheduleEntityType>;
  notes?: InputMaybe<Scalars['String']>;
  paymentSystem?: InputMaybe<PaymentSystemType>;
  paymentType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
};

export type UpdateIcdCodeInput = {
  endDate?: InputMaybe<Scalars['String']>;
  indication?: InputMaybe<Scalars['String']>;
  leftCode?: InputMaybe<Scalars['String']>;
  rightCode?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  universalCode?: InputMaybe<Scalars['String']>;
};

export type UpdatePackageInput = {
  name?: InputMaybe<Scalars['String']>;
  packageOffering?: InputMaybe<PackageOfferingEnum>;
  productId?: InputMaybe<Scalars['Int']>;
  programIndications?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateProcedureCodeInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  cptCode?: InputMaybe<Scalars['String']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  modifier1?: InputMaybe<Scalars['String']>;
  modifier2?: InputMaybe<Scalars['String']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  paymentTypeId?: InputMaybe<Scalars['Int']>;
};

export type UpdateProgramCapInput = {
  cap?: InputMaybe<Scalars['Float']>;
  clientId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lockDate?: InputMaybe<Scalars['String']>;
  lockPrice?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type UpdateRevenueShareInput = {
  applyToPrice?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Float']>;
  effectiveYear?: InputMaybe<Scalars['Int']>;
  revenueShareDefinitionId: Scalars['Int'];
  scopes?: InputMaybe<Array<ScopeInput>>;
};

export type UpdateRuleInput = {
  actions?: InputMaybe<Array<ActionDefinitionInput>>;
  definition?: InputMaybe<RuleDefinitionInput>;
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RuleStatus>;
};

export type UpdateSubscriptionEstimateInput = {
  endDate?: InputMaybe<Scalars['String']>;
  grossAmount?: InputMaybe<Scalars['Float']>;
  reserveAmount?: InputMaybe<Scalars['Float']>;
};

export type UpsertFileConfigurationResponseType = {
  __typename?: 'UpsertFileConfigurationResponseType';
  created_at: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
  updated_at: Scalars['String'];
};

export type UserLimitedType = {
  __typename?: 'UserLimitedType';
  uuid?: Maybe<Scalars['ID']>;
};

export type UserPhoneStatus = {
  __typename?: 'UserPhoneStatus';
  auth0: Array<Scalars['String']>;
  hhUuid: Scalars['String'];
  userService: Array<Scalars['String']>;
};

export type UserTag = {
  __typename?: 'UserTag';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  resourceId: Scalars['String'];
  source: Scalars['String'];
  tagId: Scalars['Float'];
  tagName: Scalars['String'];
  userId: Scalars['String'];
};

export type UserTagsList = {
  __typename?: 'UserTagsList';
  count: Scalars['Float'];
  userTags: Array<UserTag>;
};

export type VbdTierInput = {
  discount: Scalars['Float'];
  milestoneDiscount: MilestoneDiscountInput;
  subscriptionTier: SubscriptionTierInput;
  tier: Scalars['Int'];
};

export type WorkflowBase = {
  __typename?: 'WorkflowBase';
  workflowId: Scalars['String'];
};

export type WorkflowError = {
  __typename?: 'WorkflowError';
  error: Scalars['String'];
  fieldName: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type WorkflowListFiltersInputDto = {
  adminUuids?: InputMaybe<Array<Scalars['ID']>>;
  excludeStates?: InputMaybe<Array<Scalars['String']>>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
  patientUuids?: InputMaybe<Array<Scalars['ID']>>;
  useCoverage?: InputMaybe<Scalars['Boolean']>;
};

export type WorkflowListPayload = {
  __typename?: 'WorkflowListPayload';
  errors: Array<WorkflowError>;
  id: Scalars['String'];
  pageNumber: Scalars['Float'];
  pageSize: Scalars['Float'];
  workflows: Array<WorkflowPayload>;
};

export type WorkflowPayload = {
  __typename?: 'WorkflowPayload';
  adminUuids?: Maybe<Array<Scalars['ID']>>;
  coveringAdmins?: Maybe<Array<Admin>>;
  cptCodes?: Maybe<CptCodes>;
  createdAt: Scalars['String'];
  customFields?: Maybe<Scalars['JSONObject']>;
  id: Scalars['Float'];
  isPastDue?: Maybe<Scalars['Boolean']>;
  lastCompletedAt?: Maybe<Scalars['String']>;
  latestTaskDate?: Maybe<Scalars['String']>;
  latestTaskId?: Maybe<Scalars['Float']>;
  pathway?: Maybe<Pathway>;
  patient?: Maybe<BaseUser>;
  patientUuid: Scalars['String'];
  priority?: Maybe<Scalars['Int']>;
  progress?: Maybe<Array<Scalars['Float']>>;
  referenceEventId?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  tasks?: Maybe<Array<Task>>;
  type: Scalars['String'];
  updatedAt: Scalars['String'];
  viewed: Scalars['Boolean'];
};

export type GetAdjustmentUploadUrlMutationVariables = Exact<{
  input: AdjustmentUploadUrlInput;
}>;


export type GetAdjustmentUploadUrlMutation = { __typename?: 'Mutation', getAdjustmentUploadUrl: { __typename?: 'AdjustmentUploadUrl', url: string, objectKey: string, headers: any } };

export type AdjustmentUploadDoneMutationVariables = Exact<{
  input: AdjustmentUploadDoneInput;
}>;


export type AdjustmentUploadDoneMutation = { __typename?: 'Mutation', adjustmentUploadDone: { __typename?: 'TaskBase', taskId: string } };

export type RunClaimsManualWebDagMutationVariables = Exact<{
  dagRunRequestInput: DagRunRequestInput;
}>;


export type RunClaimsManualWebDagMutation = { __typename?: 'Mutation', runClaimsManualWebDag: { __typename?: 'DagRunResponseType', dagId: string, dagRunId: string, note?: string | null, state: string, logicalDate: string } };

export type BulkUpdateBillsMutationVariables = Exact<{
  bulkUpdateBillsInput: BulkUpdateBillsInput;
}>;


export type BulkUpdateBillsMutation = { __typename?: 'Mutation', bulkUpdateBills: { __typename?: 'BulkUpdateBillsResponse', details: string } };

export type ClearHoldsMutationVariables = Exact<{
  clearHoldsInput: ClearHoldsInput;
}>;


export type ClearHoldsMutation = { __typename?: 'Mutation', clearHolds: { __typename?: 'ClearHoldsResponse', details: string } };

export type BulkVoidSubmissionsMutationVariables = Exact<{
  bulkVoidSubmissionsInput: BulkVoidSubmissionsInput;
}>;


export type BulkVoidSubmissionsMutation = { __typename?: 'Mutation', bulkVoidSubmissions: Array<number> };

export type BulkEligibilityCheckMutationVariables = Exact<{
  bulkEligibilityCheckInput: BulkEligibilityCheckInput;
}>;


export type BulkEligibilityCheckMutation = { __typename?: 'Mutation', bulkEligibilityCheck: { __typename?: 'WorkflowBase', workflowId: string } };

export type BulkUpdateSubmissionsMutationVariables = Exact<{
  bulkUpdateSubmissionsInput: BulkUpdateSubmissionsInput;
}>;


export type BulkUpdateSubmissionsMutation = { __typename?: 'Mutation', bulkUpdateSubmissions: { __typename?: 'BulkUpdateSubmissionsResponse', ids: Array<number> } };

export type CreateManualHoldMutationVariables = Exact<{
  input: ManualHoldInput;
}>;


export type CreateManualHoldMutation = { __typename?: 'Mutation', createManualHold: { __typename?: 'ManualHoldResponse', details: string } };

export type ProcessCopaymentMutationVariables = Exact<{
  processCopaymentInput: ProcessCopaymentInput;
}>;


export type ProcessCopaymentMutation = { __typename?: 'Mutation', processCopayment: { __typename?: 'ProcessCopaymentResponse', workflowIds: Array<string> } };

export type CreatePackageMutationVariables = Exact<{
  packageInput: CreatePackageInput;
}>;


export type CreatePackageMutation = { __typename?: 'Mutation', createPackage: { __typename?: 'PackageType', id: number, name: string, isEditable?: boolean | null, packageOfferings: Array<{ __typename?: 'PackageOfferingsType', id: number, programIndication?: string | null, packageId: number, packageOffering: string, productId?: number | null }> } };

export type UpdatePackageMutationVariables = Exact<{
  packageId: Scalars['Int'];
  packageInput: UpdatePackageInput;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', updatePackage: { __typename?: 'PackageType', id: number, name: string, isEditable?: boolean | null, packageOfferings: Array<{ __typename?: 'PackageOfferingsType', id: number, programIndication?: string | null, packageId: number, packageOffering: string, productId?: number | null }> } };

export type DeletePackageMutationVariables = Exact<{
  packageId: Scalars['Int'];
}>;


export type DeletePackageMutation = { __typename?: 'Mutation', deletePackage: boolean };

export type CreateContractMutationVariables = Exact<{
  contractInput: CreateContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'ContractType', id: number, clientId: number, insurerId: number, contractTemplateId?: number | null, clientsInsurerId: number, currency?: string | null, chronicPrice?: number | null, acutePrice?: number | null, startDate: string, endDate?: string | null, packageEnabled: boolean, partnershipId?: number | null, globalDailyEngagementCap?: number | null, contract?: Array<{ __typename?: 'EngagementContractType', educationalTypes: Array<string>, activityTypes: Array<string>, matchType: string, engagementRules: Array<any> } | { __typename?: 'IndividualMilestonesType', name: string, payment: number, billableActivityTypes: Array<string>, conditions: Array<{ __typename?: 'MilestoneConditionType', function: string, threshold?: number | null }> } | { __typename?: 'MilestonesType', name: string, payment: number, dateOfServiceOffset: number, billableActivityTypes: Array<string>, dayRange: Array<number>, conditions: Array<{ __typename?: 'MilestoneConditionType', function: string, threshold?: number | null }> }> | null, billableActivityTypes: Array<{ __typename?: 'BillableActivityType', id: number, name: string, engagementTypeId: number }>, contractPackages: Array<{ __typename?: 'ContractPackagesType', billingEnabled: boolean, billingModelId: number, contractTemplateId?: number | null, price: number, startDate?: string | null, void: boolean }> } };

export type CreatePackageContractMutationVariables = Exact<{
  contractInput: CreateContractInput;
}>;


export type CreatePackageContractMutation = { __typename?: 'Mutation', createPackageContract: { __typename?: 'ContractType', id: number, clientId: number, insurerId: number, clientsInsurerId: number, startDate: string, endDate?: string | null, currency?: string | null, packageEnabled: boolean, partnershipId?: number | null, globalDailyEngagementCap?: number | null, contractPackages: Array<{ __typename?: 'ContractPackagesType', billingEnabled: boolean, billingModelId: number, contractTemplateId?: number | null, price: number, startDate?: string | null, rules?: any | null, void: boolean, billingTypeOverride?: string | null, costShareOptions?: { __typename?: 'CostShareOptionsType', id: number, contractPackageId: number, deductionTiming: string, cadence: string } | null }> } };

export type UpdateContractMutationVariables = Exact<{
  contractId: Scalars['Int'];
  contractInput: UpdateContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: { __typename?: 'ContractType', id: number, clientId: number, insurerId: number, contractTemplateId?: number | null, clientsInsurerId: number, chronicPrice?: number | null, acutePrice?: number | null, startDate: string, endDate?: string | null, void: boolean, partnershipId?: number | null, globalDailyEngagementCap?: number | null, contract?: Array<{ __typename?: 'EngagementContractType', educationalTypes: Array<string>, activityTypes: Array<string>, matchType: string, engagementRules: Array<any> } | { __typename?: 'IndividualMilestonesType', name: string, payment: number, billableActivityTypes: Array<string>, conditions: Array<{ __typename?: 'MilestoneConditionType', function: string, threshold?: number | null }> } | { __typename?: 'MilestonesType', name: string, payment: number, dateOfServiceOffset: number, billableActivityTypes: Array<string>, dayRange: Array<number>, conditions: Array<{ __typename?: 'MilestoneConditionType', function: string, threshold?: number | null }> }> | null, billableActivityTypes: Array<{ __typename?: 'BillableActivityType', id: number, name: string, engagementTypeId: number }>, contractPackages: Array<{ __typename?: 'ContractPackagesType', id: number, packageId: number, billingEnabled: boolean, billingModelId: number, contractTemplateId?: number | null, price: number, startDate?: string | null, void: boolean, billingTypeOverride?: string | null, costShareOptions?: { __typename?: 'CostShareOptionsType', id: number, contractPackageId: number, deductionTiming: string, cadence: string } | null }> } };

export type CreateBatchContractMutationVariables = Exact<{
  batchContractInput: CreateBatchContractInput;
}>;


export type CreateBatchContractMutation = { __typename?: 'Mutation', createBatchContract: Array<{ __typename?: 'BatchContractResponse', clientInsurerId: number, error: string, success: boolean, newContract?: { __typename?: 'ContractType', startDate: string, endDate?: string | null } | null, oldContract?: { __typename?: 'ContractType', startDate: string, endDate?: string | null } | null }> };

export type BulkUpdateBillingTypeMutationVariables = Exact<{
  input: BulkUpdateBillingTypeInput;
}>;


export type BulkUpdateBillingTypeMutation = { __typename?: 'Mutation', bulkUpdateBillingType: { __typename?: 'BulkUpdateBillingTypeResponse', contractsUpdated: number } };

export type UpdateContractPackageMutationVariables = Exact<{
  contractPackageId: Scalars['Int'];
  contractPackageInput: ContractPackagesInput;
}>;


export type UpdateContractPackageMutation = { __typename?: 'Mutation', updateContractPackage: { __typename?: 'ContractPackagesType', id: number, packageId: number, billingModelId: number, price: number, startDate?: string | null, billingEnabled: boolean, void: boolean, contractId: number, billingTypeOverride?: string | null, costShareOptions?: { __typename?: 'CostShareOptionsType', id: number, contractPackageId: number, deductionTiming: string, cadence: string } | null, package: { __typename?: 'PackageType', id: number, name: string, packageOfferings: Array<{ __typename?: 'PackageOfferingsType', id: number, packageId: number, packageOffering: string, productId?: number | null, programIndication?: string | null }> }, billingModel: { __typename?: 'BillingModelType', id: number, name: string }, billableActivityTypes: Array<{ __typename?: 'BillableActivityType', id: number, name: string, engagementTypeId: number }> } };

export type CreateCvsFeeScheduleMutationVariables = Exact<{
  cvsFeeScheduleInput: CreateCvsFeeScheduleInput;
}>;


export type CreateCvsFeeScheduleMutation = { __typename?: 'Mutation', createCvsFeeSchedule: { __typename?: 'CvsFeeScheduleType', id: number, paymentType?: string | null, price: number, upc: string, charge: string, daysSupply: string, description?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string } };

export type UpdateCvsFeeScheduleMutationVariables = Exact<{
  id: Scalars['Int'];
  cvsFeeScheduleInput: UpdateCvsFeeScheduleInput;
}>;


export type UpdateCvsFeeScheduleMutation = { __typename?: 'Mutation', updateCvsFeeSchedule: { __typename?: 'CvsFeeScheduleType', id: number, paymentType?: string | null, price: number, upc: string, charge: string, daysSupply: string, description?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string } };

export type DeleteCvsFeeScheduleMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCvsFeeScheduleMutation = { __typename?: 'Mutation', deleteCvsFeeSchedule: boolean };

export type CreateDiscountMutationVariables = Exact<{
  discountInput: CreateDiscountInput;
}>;


export type CreateDiscountMutation = { __typename?: 'Mutation', createDiscount: Array<{ __typename?: 'DiscountDetail', clientId?: number | null, partnershipId?: number | null, discount: number, discountType: string, endDate?: string | null, startDate: string, suppressEmptyCharges: boolean, scopes: Array<{ __typename?: 'Scope', scopeableType: ScopeableType, scopeableId?: number | null }> }> };

export type UpdateDiscountMutationVariables = Exact<{
  discountInput: UpdateDiscountInput;
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount: Array<{ __typename?: 'DiscountDetail', clientId?: number | null, partnershipId?: number | null, discountDefinitionId: number, discount: number, discountType: string, endDate?: string | null, startDate: string, suppressEmptyCharges: boolean, scopes: Array<{ __typename?: 'Scope', scopeableType: ScopeableType, scopeableId?: number | null }> }> };

export type CreateEsiFeeScheduleMutationVariables = Exact<{
  esiFeeScheduleInput: CreateEsiFeeScheduleInput;
}>;


export type CreateEsiFeeScheduleMutation = { __typename?: 'Mutation', createEsiFeeSchedule: { __typename?: 'EsiFeeScheduleType', id: number, program?: string | null, paymentType: string, price: number, upc: string, description?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string } };

export type UpdateEsiFeeScheduleMutationVariables = Exact<{
  id: Scalars['Int'];
  esiFeeScheduleInput: UpdateEsiFeeScheduleInput;
}>;


export type UpdateEsiFeeScheduleMutation = { __typename?: 'Mutation', updateEsiFeeSchedule: { __typename?: 'EsiFeeScheduleType', id: number, program?: string | null, paymentType: string, price: number, upc: string, description?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string } };

export type DeleteEsiFeeScheduleMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteEsiFeeScheduleMutation = { __typename?: 'Mutation', deleteEsiFeeSchedule: boolean };

export type CreateFeeScheduleMutationVariables = Exact<{
  feeScheduleInput: CreateFeeScheduleInput;
}>;


export type CreateFeeScheduleMutation = { __typename?: 'Mutation', createFeeSchedule: { __typename?: 'FeeScheduleType', id: number, entityType: FeeScheduleEntityType, entityId: number, paymentSystem: PaymentSystemType, paymentType: string, price: number, enabled: boolean, notes?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string } };

export type UpdateFeeScheduleMutationVariables = Exact<{
  id: Scalars['Int'];
  feeScheduleInput: UpdateFeeScheduleInput;
}>;


export type UpdateFeeScheduleMutation = { __typename?: 'Mutation', updateFeeSchedule: { __typename?: 'FeeScheduleType', id: number, entityType: FeeScheduleEntityType, entityId: number, paymentSystem: PaymentSystemType, paymentType: string, price: number, enabled: boolean, notes?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string } };

export type DeleteFeeScheduleMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteFeeScheduleMutation = { __typename?: 'Mutation', deleteFeeSchedule: boolean };

export type GoogleFileUploadMutationVariables = Exact<{
  fileInput: GoogleFileInputType;
}>;


export type GoogleFileUploadMutation = { __typename?: 'Mutation', googleFileUpload: { __typename?: 'TaskBase', taskId: string } };

export type CreateIcdCodeMutationVariables = Exact<{
  icdCodeInput: CreateIcdCodeInput;
}>;


export type CreateIcdCodeMutation = { __typename?: 'Mutation', createIcdCode: { __typename?: 'IcdCode', id: number, indication: string, universalCode: string, rightCode?: string | null, leftCode?: string | null, startDate: string, endDate: string, createdAt: string, updatedAt: string, lastModifiedBy: string } };

export type UpdateIcdCodeMutationVariables = Exact<{
  id: Scalars['Int'];
  icdCodeInput: UpdateIcdCodeInput;
}>;


export type UpdateIcdCodeMutation = { __typename?: 'Mutation', updateIcdCode: { __typename?: 'IcdCode', id: number, indication: string, universalCode: string, rightCode?: string | null, leftCode?: string | null, startDate: string, endDate: string, createdAt: string, updatedAt: string, lastModifiedBy: string } };

export type DeleteIcdCodeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteIcdCodeMutation = { __typename?: 'Mutation', deleteIcdCode: boolean };

export type CreateProcedureCodeMutationVariables = Exact<{
  procedureCodeInput: CreateProcedureCodeInput;
}>;


export type CreateProcedureCodeMutation = { __typename?: 'Mutation', createProcedureCode: { __typename?: 'ProcedureCode', id: number, paymentTypeId: number, cptCode: string, modifier1?: string | null, modifier2?: string | null, partnershipId?: number | null, insurerId?: number | null, clientId?: number | null, lastModifiedBy?: string | null, createdAt: string, updatedAt: string } };

export type UpdateProcedureCodeMutationVariables = Exact<{
  id: Scalars['Int'];
  procedureCodeInput: UpdateProcedureCodeInput;
}>;


export type UpdateProcedureCodeMutation = { __typename?: 'Mutation', updateProcedureCode: { __typename?: 'ProcedureCode', id: number, paymentTypeId: number, cptCode: string, modifier1?: string | null, modifier2?: string | null, partnershipId?: number | null, insurerId?: number | null, clientId?: number | null, lastModifiedBy?: string | null, createdAt: string, updatedAt: string } };

export type DeleteProcedureCodeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteProcedureCodeMutation = { __typename?: 'Mutation', deleteProcedureCode: boolean };

export type CreateProgramCapMutationVariables = Exact<{
  createProgramCapInput: CreateProgramCapInput;
}>;


export type CreateProgramCapMutation = { __typename?: 'Mutation', createProgramCap: { __typename?: 'ProgramCap', id: number, clientId: number, startDate: string, endDate: string, cap: number, lockDate?: string | null, lockPrice?: number | null } };

export type UpdateProgramCapMutationVariables = Exact<{
  updateProgramCapInput: UpdateProgramCapInput;
}>;


export type UpdateProgramCapMutation = { __typename?: 'Mutation', updateProgramCap: { __typename?: 'ProgramCap', id: number, clientId: number, startDate: string, endDate: string, cap: number, lockDate?: string | null, lockPrice?: number | null } };

export type GenerateProgramCapReportMutationVariables = Exact<{
  generateProgramCapReportInput: GenerateProgramCapReportInput;
}>;


export type GenerateProgramCapReportMutation = { __typename?: 'Mutation', generateProgramCapReport: boolean };

export type BatchCreateProgramCapMutationVariables = Exact<{
  batchCreateProgramCapInput: BatchCreateProgramCapInput;
  dryRun?: InputMaybe<Scalars['Boolean']>;
}>;


export type BatchCreateProgramCapMutation = { __typename?: 'Mutation', batchCreateProgramCap: Array<{ __typename?: 'BatchProgramCapResponseItem', clientId: number, startDate: string, endDate: string, success: boolean, error?: string | null, programCap?: { __typename?: 'BatchProgramCapResult', id?: number | null, clientId: number, cap: number, startDate: string, endDate: string, lastModifiedBy: string } | null }> };

export type CreateRevenueShareMutationVariables = Exact<{
  revenueShareInput: CreateRevenueShareInput;
}>;


export type CreateRevenueShareMutation = { __typename?: 'Mutation', createRevenueShare: Array<{ __typename?: 'RevenueShareDetail', revenueShareDetailId: number, revenueShareDefinitionId: number, clientId?: number | null, partnershipId?: number | null, name?: string | null, tier: number, discount: number, subscriptionTier: Array<number | null>, applyToPrice: boolean, effectiveYear: number, scopes: Array<{ __typename?: 'Scope', scopeableType: ScopeableType, scopeableId?: number | null }> }> };

export type UpdateRevenueShareMutationVariables = Exact<{
  revenueShareInput: UpdateRevenueShareInput;
}>;


export type UpdateRevenueShareMutation = { __typename?: 'Mutation', updateRevenueShare: Array<{ __typename?: 'RevenueShareDetail', revenueShareDetailId: number, revenueShareDefinitionId: number, clientId?: number | null, partnershipId?: number | null, name?: string | null, tier: number, discount: number, subscriptionTier: Array<number | null>, applyToPrice: boolean, effectiveYear: number, scopes: Array<{ __typename?: 'Scope', scopeableType: ScopeableType, scopeableId?: number | null }> }> };

export type BulkVoidSubscriptionsMutationVariables = Exact<{
  bulkVoidSubscriptionsInput: BulkVoidSubscriptionsInput;
}>;


export type BulkVoidSubscriptionsMutation = { __typename?: 'Mutation', bulkVoidSubscriptions: Array<number> };

export type GetClaimsManualWebDagRunStatusQueryVariables = Exact<{
  dagRunId: Scalars['String'];
}>;


export type GetClaimsManualWebDagRunStatusQuery = { __typename?: 'Query', getClaimsManualWebDagRunStatus: { __typename?: 'DagRunResponseType', dagId: string, dagRunId: string, note?: string | null, state: string, logicalDate: string } };

export type GetBillingTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingTypesQuery = { __typename?: 'Query', getBillingTypes: Array<{ __typename?: 'BillingType', value: string }> };

export type GetBillsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  internalHoldTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  contractIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  billStatuses?: InputMaybe<Array<BillStatusEnum> | BillStatusEnum>;
  held?: InputMaybe<Scalars['Boolean']>;
  submitted?: InputMaybe<Scalars['Boolean']>;
  submissionStatuses?: InputMaybe<Array<SubmissionStatusEnum> | SubmissionStatusEnum>;
  sortBy?: InputMaybe<Array<Array<Scalars['String']> | Scalars['String']> | Array<Scalars['String']> | Scalars['String']>;
  paymentTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  userUuids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  billIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  sourceStartDate?: InputMaybe<Scalars['String']>;
  sourceEndDate?: InputMaybe<Scalars['String']>;
}>;


export type GetBillsQuery = { __typename?: 'Query', getBills: { __typename?: 'BillsPaginatedType', page: number, pages?: number | null, total?: number | null, size: number, items: Array<{ __typename?: 'PaginatedBillType', baseCharge: number, billId: number, claimId: string, billAmount?: number | null, status: string, userId?: number | null, userUuid: string, source: string, sourceId: number, dateOfService: string, contractId?: number | null, paymentType?: string | null, netsuiteId?: string | null, submissionId?: number | null, submissionStatus?: string | null, submissionDate?: string | null, submissionAmount?: number | null, transactionId?: string | null, details?: any | null, holdDetails?: { __typename?: 'HoldDetailsType', holdType: string, note?: string | null, details?: any | null, clientId?: number | null, insurerId?: number | null, createdAt?: string | null, clearedAt?: string | null } | null }> } };

export type GetAllInternalHoldTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInternalHoldTypesQuery = { __typename?: 'Query', getAllInternalHoldTypes: Array<{ __typename?: 'InternalHoldType', value: string }> };

export type GetUnbilledQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  contractIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  paymentTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetUnbilledQuery = { __typename?: 'Query', getUnbilledBills: { __typename?: 'UnbilledBillsPaginatedType', page: number, size: number, total?: number | null, pages?: number | null, items: Array<{ __typename?: 'UnbilledBillType', contractId: number, unbilled?: number | null, billsCount: number }> } };

export type GetBillDetailsByIdQueryVariables = Exact<{
  billId: Scalars['Int'];
}>;


export type GetBillDetailsByIdQuery = { __typename?: 'Query', getBillById: { __typename: 'BillSubmissionsType', baseCharge: number, billAmount?: number | null, claimIdentifier: string, contractId?: number | null, coverageId?: number | null, createdAt: string, eventUuid?: string | null, fromDate: string, id: number, pathwayId?: number | null, paymentType: string, source: string, sourceId: number, status: string, subscriptionPackageId?: number | null, toDate?: string | null, updatedAt: string, details?: any | null, engagementEvent?: { __typename?: 'EngagementBaseType', id: number, eventId?: number | null, eventUuid?: string | null, eventType: string, occurredAt: string, userUuid: string, pathwayUuid: string, programId?: number | null, programIndication: string, sourceType: string, billableCount: number, details?: any | null, queuedAt: string, createdAt: string } | null, internalHolds: Array<{ __typename?: 'InternalHoldBaseType', billId: number, createdAt: string, clearedAt?: string | null, holdType: string, note?: string | null, details?: any | null }>, submissions: Array<{ __typename?: 'SubmissionRemitsType', id: number, billId: number, transactionId?: string | null, status: string, submissionAmount: number, submissionDate: string, createdAt: string, remits: Array<{ __typename?: 'RemitBaseType', id: number, patientPaymentAmount: number, paymentAmount: number, payer: string, sourceOfRecord: string, paymentDate?: string | null, icn?: string | null, responseDate: string, createdAt: string }>, corrections: Array<{ __typename?: 'CorrectionBaseType', correctionAmount: number, createdAt: string, correctionsType: CorrectionTypeEnum, netsuiteId: string, lastModifiedBy: string }> }> } };

export type GetFileDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFileDetailsQuery = { __typename?: 'Query', getFileDetails: { __typename?: 'FileDetails', schemas: any } };

export type GetFileUploadStatusQueryVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type GetFileUploadStatusQuery = { __typename?: 'Query', getFileUploadStatus: { __typename?: 'FileUploadStatus', status: string } };

export type GetAggregateHoldsV2QueryVariables = Exact<{
  contractIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  holdTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
  minHeldAmount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetAggregateHoldsV2Query = { __typename?: 'Query', aggregateHoldsV2: { __typename?: 'AggregateHoldsV2Type', total?: number | null, page: number, size: number, pages?: number | null, items: Array<{ __typename?: 'AggregateHoldsV2ItemType', contractId: number, holds: string, minFromDate: string, maxFromDate: string, maxLastSeenAt: string, holdsCount: number, heldAmount: number }> } };

export type GetTaskQueryVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type GetTaskQuery = { __typename?: 'Query', getTask: { __typename?: 'TaskInformation', status: string, name?: TaskName | null, result?: any | null } };

export type GetContractTermSummaryQueryVariables = Exact<{
  contractId: Scalars['Int'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type GetContractTermSummaryQuery = { __typename?: 'Query', getContractTermSummary: { __typename?: 'ContractTermSummary', numSubscriptions: number, numSubmissions: number, numFeeForServiceEvents: number, numAdminFeeClaims: number, sumSubmissionAmount: number } };

export type GetSubmissionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  submissionIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  billIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  userIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  transactionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  netsuiteIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  creditMemoIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  submissionStatuses?: InputMaybe<Array<SubmissionStatusEnum> | SubmissionStatusEnum>;
  submissionStartDate?: InputMaybe<Scalars['String']>;
  submissionEndDate?: InputMaybe<Scalars['String']>;
  contractIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  sourceStartDate?: InputMaybe<Scalars['String']>;
  sourceEndDate?: InputMaybe<Scalars['String']>;
}>;


export type GetSubmissionsQuery = { __typename?: 'Query', getSubmissions: { __typename?: 'SubmissionsPaginatedType', page: number, size: number, total?: number | null, pages?: number | null, items: Array<{ __typename?: 'PaginatedSubmissionType', baseCharge: number, submissionId: number, billId: number, userId?: number | null, userUuid?: string | null, transactionId?: string | null, netsuiteId?: string | null, submissionStatus?: string | null, submissionAmount?: number | null, submissionDate?: string | null, clientPrice?: number | null, coverageId?: number | null, source: string, sourceId: number, dateOfService: string, contractId?: number | null, paymentType: string, billAmount?: number | null, details?: any | null }> } };

export type GetTemporalWorkflowQueryVariables = Exact<{
  workflowId: Scalars['String'];
}>;


export type GetTemporalWorkflowQuery = { __typename?: 'Query', getTemporalWorkflow: { __typename?: 'TemporalWorkflowInformation', status: string, workflowId: string, workflowType: string, failureMessage?: string | null, result?: any | null } };

export type GetClientInsurerByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetClientInsurerByIdQuery = { __typename?: 'Query', getClientInsurerById: { __typename?: 'ClientInsurerType', billingType?: string | null, coreContractRule?: string | null, id: number, isActive: boolean, termDate?: string | null, client: { __typename?: 'ClientType', id: number, identifier: string, name: string }, insurer: { __typename?: 'InsurerType', eligibilityRef: string, id: number, identifier: string, name: string }, partnerships: Array<{ __typename?: 'PartnershipType', allowCohortExpansion: boolean, id: number, name: string, partnershipType: string, requiresStateCredentials: boolean }> } };

export type GetClientInsurersByIdsQueryVariables = Exact<{
  billingType?: InputMaybe<Scalars['String']>;
  billingTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  clientIdentifier?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insurerIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  scope?: InputMaybe<ScopeType>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetClientInsurersByIdsQuery = { __typename?: 'Query', getClientInsurersByIds: Array<{ __typename?: 'BatchClientInsurerType', id: number, billingType?: string | null, isActive: boolean, termDate?: string | null, coreContractRule?: string | null, effectiveDate?: string | null, insurer: { __typename?: 'BatchInsurerType', id: number, identifier: string, name: string, eligibilityRef: string }, client: { __typename?: 'ClientType', id: number, identifier: string, name: string }, partnerships: Array<{ __typename?: 'PartnershipType', id: number, name: string, partnershipType: string, allowCohortExpansion: boolean, requiresStateCredentials: boolean }> }> };

export type GetClientInsurersByClientQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetClientInsurersByClientQuery = { __typename?: 'Query', getClientInsurersByClient: { __typename?: 'ClientInsurerByClientType', id: number, identifier: string, name: string, clientsInsurers: Array<{ __typename?: 'ClientInsurerDetailsType', id: number, billingType?: string | null, isActive: boolean, termDate?: string | null, client: { __typename?: 'ClientType', id: number, identifier: string, name: string }, insurer: { __typename?: 'InsurerBasicType', eligibilityRef: string, id: number, identifier: string, name: string }, partnerships: Array<{ __typename?: 'PartnershipType', allowCohortExpansion: boolean, id: number, name: string, partnershipType: string, requiresStateCredentials: boolean }> }> } };

export type GetAllClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientsQuery = { __typename?: 'Query', getAllClients: Array<{ __typename?: 'ClientType', id: number, identifier: string, name: string }> };

export type GetAllEngagementTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEngagementTypesQuery = { __typename?: 'Query', getAllEngagementTypes: Array<{ __typename?: 'EngagementType', id: number, name: string, createdAt: string, updatedAt: string }> };

export type GetAllPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPackagesQuery = { __typename?: 'Query', getAllPackages: Array<{ __typename?: 'PackageType', id: number, name: string, isEditable?: boolean | null, createdAt: string, updatedAt: string, lastModifiedBy: string, packageOfferings: Array<{ __typename?: 'PackageOfferingsType', id: number, programIndication?: string | null, packageId: number, packageOffering: string, productId?: number | null, createdAt: string, updatedAt: string, lastModifiedBy: string }> }> };

export type GetAllProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductsQuery = { __typename?: 'Query', getAllProducts: Array<{ __typename?: 'ProductType', id: number, name: string }> };

export type GetBillingModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingModelsQuery = { __typename?: 'Query', getBillingModels: Array<{ __typename?: 'BillingModelType', id: number, name: string, createdAt: string, updatedAt: string }> };

export type GetCurrencyCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencyCodesQuery = { __typename?: 'Query', getCurrencyCodes: Array<{ __typename?: 'CurrencyCodeType', value: string }> };

export type GetCostShareSetupOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCostShareSetupOptionsQuery = { __typename?: 'Query', getCostShareSetupOptions: { __typename?: 'CostShareSetupOptionType', deductionTiming: Array<string>, cadence: Array<string> } };

export type GetContractTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractTemplatesQuery = { __typename?: 'Query', getContractTemplates: Array<{ __typename?: 'ContractTemplateType', id: number, isActive: boolean, name: string, partnershipId?: number | null, createdAt: string, updatedAt: string, contractType?: string | null, contract: Array<{ __typename?: 'EngagementContractType', educationalTypes: Array<string>, activityTypes: Array<string>, matchType: string, engagementRules: Array<any> } | { __typename?: 'IndividualMilestonesType', name: string, payment: number, billableActivityTypes: Array<string>, conditions: Array<{ __typename?: 'MilestoneConditionType', function: string, threshold?: number | null }> } | { __typename?: 'MilestonesType', name: string, payment: number, dateOfServiceOffset: number, billableActivityTypes: Array<string>, dayRange: Array<number>, conditions: Array<{ __typename?: 'MilestoneConditionType', function: string, threshold?: number | null }> }> }> };

export type GetContractsV2QueryVariables = Exact<{
  contractIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  clientsInsurerIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  clientIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insurerIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  includeVoided?: InputMaybe<Scalars['Boolean']>;
  contractType?: InputMaybe<Scalars['String']>;
  packageEnabled?: InputMaybe<Scalars['Boolean']>;
  billingTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  requireBillingTypeOverrideMatch?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetContractsV2Query = { __typename?: 'Query', getContractsV2: { __typename?: 'ContractsPaginatedType', total?: number | null, page: number, size: number, items: Array<{ __typename?: 'ContractType', id: number, clientId: number, insurerId: number, contractTemplateId?: number | null, userAnnualCap?: number | null, currency?: string | null, clientsInsurerId: number, chronicPrice?: number | null, acutePrice?: number | null, startDate: string, endDate?: string | null, void: boolean, contractType?: string | null, packageEnabled: boolean, partnershipId?: number | null, lastModifiedBy: string, billingType?: string | null, globalDailyEngagementCap?: number | null, createdAt: string, updatedAt: string, contract?: Array<{ __typename?: 'EngagementContractType', educationalTypes: Array<string>, activityTypes: Array<string>, matchType: string, engagementRules: Array<any> } | { __typename?: 'IndividualMilestonesType', name: string, payment: number, billableActivityTypes: Array<string>, conditions: Array<{ __typename?: 'MilestoneConditionType', function: string, threshold?: number | null }> } | { __typename?: 'MilestonesType', name: string, payment: number, dateOfServiceOffset: number, billableActivityTypes: Array<string>, dayRange: Array<number>, conditions: Array<{ __typename?: 'MilestoneConditionType', function: string, threshold?: number | null }> }> | null, billableActivityTypes: Array<{ __typename?: 'BillableActivityType', id: number, name: string, createdAt: string, updatedAt: string, details?: any | null, engagementTypeId: number }>, contractPackages: Array<{ __typename?: 'ContractPackagesType', id: number, packageId: number, billingModelId: number, contractTemplateId?: number | null, price: number, startDate?: string | null, billingEnabled: boolean, createdAt: string, updatedAt: string, lastModifiedBy: string, billingTypeOverride?: string | null, rules?: any | null, void: boolean, contractId: number, billableActivityTypes: Array<{ __typename?: 'BillableActivityType', id: number, name: string, createdAt: string, updatedAt: string, details?: any | null, engagementTypeId: number }>, package: { __typename?: 'PackageType', id: number, name: string, createdAt: string, updatedAt: string, lastModifiedBy: string, packageOfferings: Array<{ __typename?: 'PackageOfferingsType', id: number, packageId: number, packageOffering: string, productId?: number | null, programIndication?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string }> }, billingModel: { __typename?: 'BillingModelType', id: number, name: string, createdAt: string, updatedAt: string }, costShareOptions?: { __typename?: 'CostShareOptionsType', id: number, contractPackageId: number, deductionTiming: string, cadence: string, updatedAt: string, createdAt: string } | null }> }> } };

export type GetValidContractsForHoldReleaseQueryVariables = Exact<{
  clientsInsurerId: Scalars['Int'];
  minDateOfService: Scalars['String'];
  maxDateOfService: Scalars['String'];
}>;


export type GetValidContractsForHoldReleaseQuery = { __typename?: 'Query', getValidContractsForHoldRelease: Array<{ __typename?: 'ContractType', id: number, clientsInsurerId: number, partnershipId?: number | null, billingType?: string | null, startDate: string, endDate?: string | null, void: boolean }> };

export type GetContractIdsQueryVariables = Exact<{
  clientsInsurerIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  clientIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insurerIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  includeVoided?: InputMaybe<Scalars['Boolean']>;
  billingTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetContractIdsQuery = { __typename?: 'Query', getContractIds: Array<number> };

export type GetCvsFeeSchedulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCvsFeeSchedulesQuery = { __typename?: 'Query', getCvsFeeSchedules: Array<{ __typename?: 'CvsFeeScheduleType', id: number, paymentType?: string | null, price: number, upc: string, charge: string, daysSupply: string, description?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string }> };

export type GetDiscountsPaginatedQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['Int']>;
  discountDetailId?: InputMaybe<Scalars['Int']>;
  discountType?: InputMaybe<Scalars['String']>;
  inquiryDate?: InputMaybe<Scalars['String']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  scopeType?: InputMaybe<ScopeType>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetDiscountsPaginatedQuery = { __typename?: 'Query', getDiscountsPaginated: { __typename?: 'DiscountWithDetailsPaginatedType', total?: number | null, page: number, size: number, items: Array<{ __typename?: 'DiscountWithDetails', id: number, clientId?: number | null, insurerId?: number | null, partnershipId?: number | null, discountType: string, suppressEmptyCharges: boolean, startDate: string, endDate?: string | null, scopes: Array<{ __typename?: 'Scope', scopeableType: ScopeableType, scopeableId?: number | null }>, discountDetails: Array<{ __typename?: 'DiscountDetailItem', id: number, name?: string | null, tier: number, milestoneDiscount?: any | null, discount: number, subscriptionTier: Array<number | null> }> }> } };

export type GetDiscountUsageQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['Int']>;
  discountDetailIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
}>;


export type GetDiscountUsageQuery = { __typename?: 'Query', getDiscountUsage: Array<{ __typename?: 'DiscountUsage', discountDetailId?: number | null, discountSum?: number | null, discountPercent?: number | null, totalCount: number }> };

export type GetEngagementsByUserUuidQueryVariables = Exact<{
  uuid: Scalars['String'];
  startDate: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetEngagementsByUserUuidQuery = { __typename?: 'Query', getEngagementsByUserUuid: { __typename?: 'EngagementsPaginationType', page: number, pages?: number | null, size: number, total?: number | null, items: Array<{ __typename?: 'EngagementBaseType', id: number, eventId?: number | null, programId?: number | null, billableCount: number, eventUuid?: string | null, eventType: string, userUuid: string, programIndication: string, sourceType: string, details?: any | null, queuedAt: string, occurredAt: string, createdAt: string }> } };

export type GetEsiFeeSchedulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEsiFeeSchedulesQuery = { __typename?: 'Query', getEsiFeeSchedules: Array<{ __typename?: 'EsiFeeScheduleType', id: number, program?: string | null, paymentType: string, price: number, upc: string, description?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string }> };

export type GetFeeForServiceEventsQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  userUuids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeVoid?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetFeeForServiceEventsQuery = { __typename?: 'Query', getFeeForServiceEvents: { __typename?: 'FeeForServiceEventPaginated', page: number, pages?: number | null, size: number, total?: number | null, items: Array<{ __typename?: 'FeeForServiceEvent', id: number, userId: number, userUuid: string, pathwayUuid: string, contractPackageId: number, contractId: number, engagementEventId: number, occurredAt: string, createdAt: string, updatedAt: string, void: boolean, adminUuid?: string | null }> } };

export type GetBillsByFeeForServiceEventIdQueryVariables = Exact<{
  feeForServiceEventId?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
}>;


export type GetBillsByFeeForServiceEventIdQuery = { __typename?: 'Query', getBillsByFeeForServiceEventId: Array<{ __typename?: 'BillSubmissionsType', baseCharge: number, billAmount?: number | null, claimIdentifier: string, details?: any | null, coverageId?: number | null, createdAt: string, fromDate: string, id: number, pathwayId?: number | null, paymentType: string, source: string, sourceId: number, status: string, toDate?: string | null, updatedAt: string, submissions: Array<{ __typename?: 'SubmissionRemitsType', billId: number, coverageId?: number | null, createdAt: string, id: number, netsuiteId?: string | null, status: string, submissionAmount: number, submissionDate: string, transactionId?: string | null, updatedAt?: string | null, corrections: Array<{ __typename?: 'CorrectionBaseType', correctionAmount: number, correctionsType: CorrectionTypeEnum, createdAt: string, lastModifiedBy: string, netsuiteId: string, submissionId?: number | null }>, remits: Array<{ __typename?: 'RemitBaseType', createdAt: string, icn?: string | null, id: number, patientPaymentAmount: number, payer: string, paymentAmount: number, paymentDate?: string | null, paymentNumber?: string | null, paymentType?: string | null, responseDate: string, sourceOfRecord: string }> }>, internalHolds: Array<{ __typename?: 'InternalHoldBaseType', billId: number, holdType: string, note?: string | null, clearedAt?: string | null, createdAt: string }> }> };

export type GetFeeForServiceEngagementsQueryVariables = Exact<{
  feeForServiceEventId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetFeeForServiceEngagementsQuery = { __typename?: 'Query', getFeeForServiceEngagements: { __typename?: 'EngagementsPaginationType', page: number, pages?: number | null, size: number, total?: number | null, items: Array<{ __typename?: 'EngagementBaseType', id: number, eventId?: number | null, programId?: number | null, billableCount: number, eventUuid?: string | null, eventType: string, userUuid: string, programIndication: string, sourceType: string, details?: any | null, queuedAt: string, occurredAt: string, createdAt: string }> } };

export type GetFeeSchedulesQueryVariables = Exact<{
  entityType: FeeScheduleEntityType;
  entityIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  paymentSystems?: InputMaybe<Array<PaymentSystemType> | PaymentSystemType>;
  paymentTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  priceMin?: InputMaybe<Scalars['Float']>;
  priceMax?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetFeeSchedulesQuery = { __typename?: 'Query', getFeeSchedules: { __typename?: 'FeeSchedulesPaginatedType', total?: number | null, page: number, size: number, pages?: number | null, items: Array<{ __typename?: 'FeeScheduleType', id: number, entityType: FeeScheduleEntityType, entityId: number, paymentSystem: PaymentSystemType, paymentType: string, price: number, enabled: boolean, notes?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string }> } };

export type GetFeeScheduleByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetFeeScheduleByIdQuery = { __typename?: 'Query', getFeeScheduleById: { __typename?: 'FeeScheduleType', id: number, entityType: FeeScheduleEntityType, entityId: number, paymentSystem: PaymentSystemType, paymentType: string, price: number, enabled: boolean, notes?: string | null, createdAt: string, updatedAt: string, lastModifiedBy: string } };

export type GetIcdCodesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetIcdCodesQuery = { __typename?: 'Query', getIcdCodes: { __typename?: 'IcdCodesPaginated', total?: number | null, page: number, size: number, pages?: number | null, items: Array<{ __typename?: 'IcdCode', id: number, indication: string, universalCode: string, rightCode?: string | null, leftCode?: string | null, startDate: string, endDate: string, createdAt: string }> } };

export type GetAllInsurersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInsurersQuery = { __typename?: 'Query', getAllInsurers: Array<{ __typename?: 'InsurerType', id: number, identifier: string, name: string }> };

export type GetPackageRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPackageRulesQuery = { __typename?: 'Query', getPackageRules: { __typename?: 'PackageRulesType', billingModels: any } };

export type GetPartnershipsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type GetPartnershipsQuery = { __typename?: 'Query', getPartnerships: Array<{ __typename?: 'PartnershipType', id: number, name: string, partnershipType: string, allowCohortExpansion: boolean, requiresStateCredentials: boolean }> };

export type GetPaymentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentTypesQuery = { __typename?: 'Query', getPaymentTypes: Array<{ __typename?: 'PaymentType', id: number, code: string, name: string, createdAt: string, updatedAt: string }> };

export type GetProcedureCodesQueryVariables = Exact<{
  partnershipId?: InputMaybe<Scalars['Int']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  clientId?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetProcedureCodesQuery = { __typename?: 'Query', getProcedureCodes: { __typename?: 'ProcedureCodesPaginated', total?: number | null, page: number, size: number, pages?: number | null, items: Array<{ __typename?: 'ProcedureCode', id: number, paymentTypeId: number, cptCode: string, modifier1?: string | null, modifier2?: string | null, partnershipId?: number | null, insurerId?: number | null, clientId?: number | null, lastModifiedBy?: string | null, createdAt: string, updatedAt: string }> } };

export type ProductOfferingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductOfferingsQuery = { __typename?: 'Query', productOfferings: Array<{ __typename?: 'ProductOffering', id: number, name: string, productId: number }> };

export type GetProgramCapsQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['Int']>;
  programCapIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  page: Scalars['Int'];
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetProgramCapsQuery = { __typename?: 'Query', getProgramCaps: { __typename?: 'ProgramCapPaginated', page: number, pages?: number | null, size: number, total?: number | null, items: Array<{ __typename?: 'ProgramCap', id: number, clientId: number, cap: number, startDate: string, endDate: string, lockDate?: string | null, lockPrice?: number | null, correctedUserBasedLockPrice?: number | null }> } };

export type GetProgramCapRefundByIdQueryVariables = Exact<{
  programCapId: Scalars['Int'];
}>;


export type GetProgramCapRefundByIdQuery = { __typename?: 'Query', getProgramCapRefundById: { __typename?: 'ProgramCapRefund', clientId: number, cap: number, sumAmount: number, numMembers: number, averageStickerPrice: number, refundPerMember: number, totalRefundAmount: number, startDate: string, endDate: string, lockDate?: string | null, lockPrice?: number | null, programCapId: number, reportLink?: string | null } };

export type GetAllProgramIndicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProgramIndicationsQuery = { __typename?: 'Query', getProgramIndicationsById: Array<{ __typename?: 'ProgramIndicationType', id: number, identifier: string, indicationName: string, programName: string, programId: number }> };

export type GetResolvedProcedureCodesQueryVariables = Exact<{
  partnershipId?: InputMaybe<Scalars['Int']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  clientId?: InputMaybe<Scalars['Int']>;
}>;


export type GetResolvedProcedureCodesQuery = { __typename?: 'Query', getResolvedProcedureCodes: Array<{ __typename?: 'ProcedureCode', id: number, paymentTypeId: number, cptCode: string, modifier1?: string | null, modifier2?: string | null, partnershipId?: number | null, insurerId?: number | null, clientId?: number | null, lastModifiedBy?: string | null, createdAt: string, updatedAt: string }> };

export type GetRevenueSharesQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  effectiveYear?: InputMaybe<Scalars['Int']>;
  revenueShareDefinitionId?: InputMaybe<Scalars['Int']>;
  scopeType?: InputMaybe<ScopeType>;
}>;


export type GetRevenueSharesQuery = { __typename?: 'Query', getRevenueShares: Array<{ __typename?: 'RevenueShareDetail', revenueShareDetailId: number, revenueShareDefinitionId: number, clientId?: number | null, partnershipId?: number | null, name?: string | null, tier: number, discount: number, subscriptionTier: Array<number | null>, applyToPrice: boolean, effectiveYear: number, scopes: Array<{ __typename?: 'Scope', scopeableType: ScopeableType, scopeableId?: number | null }> }> };

export type GetSubscriptionsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
  userUuid?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  includeVoid?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSubscriptionsQuery = { __typename?: 'Query', getSubscriptions: { __typename?: 'SubscriptionsPaginationType', page: number, pages?: number | null, size: number, total?: number | null, items: Array<{ __typename?: 'SubscriptionType', contractId: number, createdAt: string, endsAt: string, id: number, pathwayId: number, pathwayUuid: string, programId?: number | null, startsAt: string, termDate?: string | null, userId: number, userUuid: string, void: boolean, yearCount: number, subscriptionPackages?: Array<{ __typename?: 'SubscriptionPackageType', id: number, contractPackageId: number, subscriptionId: number, packageCap: number, startsAt: string, eventUuid: string, createdAt: string, updatedAt: string }> | null }> } };

export type GetSubscriptionEngagementsQueryVariables = Exact<{
  subscriptionId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetSubscriptionEngagementsQuery = { __typename?: 'Query', getSubscriptionEngagements: { __typename?: 'EngagementsPaginationType', page: number, pages?: number | null, size: number, total?: number | null, items: Array<{ __typename?: 'EngagementBaseType', id: number, eventId?: number | null, programId?: number | null, billableCount: number, eventUuid?: string | null, eventType: string, userUuid: string, programIndication: string, sourceType: string, details?: any | null, queuedAt: string, occurredAt: string, createdAt: string }> } };

export type GetSubscriptionHoldsByUserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
  userUuid?: InputMaybe<Scalars['String']>;
}>;


export type GetSubscriptionHoldsByUserQuery = { __typename?: 'Query', getSubscriptionHoldsByUser: Array<{ __typename?: 'SubscriptionHoldType', id: number, clearedAt?: string | null, firstSeenAt: string, hitCount: number, lastSeenAt: string, programId?: number | null, reason: string, userId: number, userUuid: string, details?: any | null }> };

export type GetBillsBySubscriptionIdQueryVariables = Exact<{
  source: Scalars['String'];
  sourceId: Scalars['Int'];
}>;


export type GetBillsBySubscriptionIdQuery = { __typename?: 'Query', getBillsBySubscriptionId: Array<{ __typename?: 'BillSubmissionsType', baseCharge: number, billAmount?: number | null, claimIdentifier: string, details?: any | null, coverageId?: number | null, createdAt: string, fromDate: string, id: number, pathwayId?: number | null, paymentType: string, source: string, sourceId: number, status: string, toDate?: string | null, updatedAt: string, submissions: Array<{ __typename?: 'SubmissionRemitsType', billId: number, coverageId?: number | null, createdAt: string, id: number, netsuiteId?: string | null, status: string, submissionAmount: number, submissionDate: string, transactionId?: string | null, updatedAt?: string | null, corrections: Array<{ __typename?: 'CorrectionBaseType', correctionAmount: number, correctionsType: CorrectionTypeEnum, createdAt: string, lastModifiedBy: string, netsuiteId: string, submissionId?: number | null }>, remits: Array<{ __typename?: 'RemitBaseType', createdAt: string, icn?: string | null, id: number, patientPaymentAmount: number, payer: string, paymentAmount: number, paymentDate?: string | null, paymentNumber?: string | null, paymentType?: string | null, responseDate: string, sourceOfRecord: string }> }>, internalHolds: Array<{ __typename?: 'InternalHoldBaseType', billId: number, holdType: string, note?: string | null, clearedAt?: string | null, createdAt: string }> }> };

export type GetUserUuidByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetUserUuidByIdQuery = { __typename?: 'Query', getUserUuidById: { __typename?: 'UserLimitedType', uuid?: string | null } };


export const GetAdjustmentUploadUrlDocument = gql`
    mutation getAdjustmentUploadUrl($input: AdjustmentUploadUrlInput!) {
  getAdjustmentUploadUrl(input: $input) {
    url
    objectKey
    headers
  }
}
    `;
export type GetAdjustmentUploadUrlMutationFn = Apollo.MutationFunction<GetAdjustmentUploadUrlMutation, GetAdjustmentUploadUrlMutationVariables>;

/**
 * __useGetAdjustmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetAdjustmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAdjustmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAdjustmentUploadUrlMutation, { data, loading, error }] = useGetAdjustmentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAdjustmentUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetAdjustmentUploadUrlMutation, GetAdjustmentUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAdjustmentUploadUrlMutation, GetAdjustmentUploadUrlMutationVariables>(GetAdjustmentUploadUrlDocument, options);
      }
export type GetAdjustmentUploadUrlMutationHookResult = ReturnType<typeof useGetAdjustmentUploadUrlMutation>;
export type GetAdjustmentUploadUrlMutationResult = Apollo.MutationResult<GetAdjustmentUploadUrlMutation>;
export type GetAdjustmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetAdjustmentUploadUrlMutation, GetAdjustmentUploadUrlMutationVariables>;
export const AdjustmentUploadDoneDocument = gql`
    mutation adjustmentUploadDone($input: AdjustmentUploadDoneInput!) {
  adjustmentUploadDone(input: $input) {
    taskId
  }
}
    `;
export type AdjustmentUploadDoneMutationFn = Apollo.MutationFunction<AdjustmentUploadDoneMutation, AdjustmentUploadDoneMutationVariables>;

/**
 * __useAdjustmentUploadDoneMutation__
 *
 * To run a mutation, you first call `useAdjustmentUploadDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustmentUploadDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustmentUploadDoneMutation, { data, loading, error }] = useAdjustmentUploadDoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdjustmentUploadDoneMutation(baseOptions?: Apollo.MutationHookOptions<AdjustmentUploadDoneMutation, AdjustmentUploadDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustmentUploadDoneMutation, AdjustmentUploadDoneMutationVariables>(AdjustmentUploadDoneDocument, options);
      }
export type AdjustmentUploadDoneMutationHookResult = ReturnType<typeof useAdjustmentUploadDoneMutation>;
export type AdjustmentUploadDoneMutationResult = Apollo.MutationResult<AdjustmentUploadDoneMutation>;
export type AdjustmentUploadDoneMutationOptions = Apollo.BaseMutationOptions<AdjustmentUploadDoneMutation, AdjustmentUploadDoneMutationVariables>;
export const RunClaimsManualWebDagDocument = gql`
    mutation runClaimsManualWebDag($dagRunRequestInput: DagRunRequestInput!) {
  runClaimsManualWebDag(dagRunRequestInput: $dagRunRequestInput) {
    dagId
    dagRunId
    note
    state
    logicalDate
  }
}
    `;
export type RunClaimsManualWebDagMutationFn = Apollo.MutationFunction<RunClaimsManualWebDagMutation, RunClaimsManualWebDagMutationVariables>;

/**
 * __useRunClaimsManualWebDagMutation__
 *
 * To run a mutation, you first call `useRunClaimsManualWebDagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunClaimsManualWebDagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runClaimsManualWebDagMutation, { data, loading, error }] = useRunClaimsManualWebDagMutation({
 *   variables: {
 *      dagRunRequestInput: // value for 'dagRunRequestInput'
 *   },
 * });
 */
export function useRunClaimsManualWebDagMutation(baseOptions?: Apollo.MutationHookOptions<RunClaimsManualWebDagMutation, RunClaimsManualWebDagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunClaimsManualWebDagMutation, RunClaimsManualWebDagMutationVariables>(RunClaimsManualWebDagDocument, options);
      }
export type RunClaimsManualWebDagMutationHookResult = ReturnType<typeof useRunClaimsManualWebDagMutation>;
export type RunClaimsManualWebDagMutationResult = Apollo.MutationResult<RunClaimsManualWebDagMutation>;
export type RunClaimsManualWebDagMutationOptions = Apollo.BaseMutationOptions<RunClaimsManualWebDagMutation, RunClaimsManualWebDagMutationVariables>;
export const BulkUpdateBillsDocument = gql`
    mutation bulkUpdateBills($bulkUpdateBillsInput: BulkUpdateBillsInput!) {
  bulkUpdateBills(bulkUpdateBillsInput: $bulkUpdateBillsInput) {
    details
  }
}
    `;
export type BulkUpdateBillsMutationFn = Apollo.MutationFunction<BulkUpdateBillsMutation, BulkUpdateBillsMutationVariables>;

/**
 * __useBulkUpdateBillsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateBillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBillsMutation, { data, loading, error }] = useBulkUpdateBillsMutation({
 *   variables: {
 *      bulkUpdateBillsInput: // value for 'bulkUpdateBillsInput'
 *   },
 * });
 */
export function useBulkUpdateBillsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateBillsMutation, BulkUpdateBillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateBillsMutation, BulkUpdateBillsMutationVariables>(BulkUpdateBillsDocument, options);
      }
export type BulkUpdateBillsMutationHookResult = ReturnType<typeof useBulkUpdateBillsMutation>;
export type BulkUpdateBillsMutationResult = Apollo.MutationResult<BulkUpdateBillsMutation>;
export type BulkUpdateBillsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateBillsMutation, BulkUpdateBillsMutationVariables>;
export const ClearHoldsDocument = gql`
    mutation clearHolds($clearHoldsInput: ClearHoldsInput!) {
  clearHolds(clearHoldsInput: $clearHoldsInput) {
    details
  }
}
    `;
export type ClearHoldsMutationFn = Apollo.MutationFunction<ClearHoldsMutation, ClearHoldsMutationVariables>;

/**
 * __useClearHoldsMutation__
 *
 * To run a mutation, you first call `useClearHoldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearHoldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearHoldsMutation, { data, loading, error }] = useClearHoldsMutation({
 *   variables: {
 *      clearHoldsInput: // value for 'clearHoldsInput'
 *   },
 * });
 */
export function useClearHoldsMutation(baseOptions?: Apollo.MutationHookOptions<ClearHoldsMutation, ClearHoldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearHoldsMutation, ClearHoldsMutationVariables>(ClearHoldsDocument, options);
      }
export type ClearHoldsMutationHookResult = ReturnType<typeof useClearHoldsMutation>;
export type ClearHoldsMutationResult = Apollo.MutationResult<ClearHoldsMutation>;
export type ClearHoldsMutationOptions = Apollo.BaseMutationOptions<ClearHoldsMutation, ClearHoldsMutationVariables>;
export const BulkVoidSubmissionsDocument = gql`
    mutation bulkVoidSubmissions($bulkVoidSubmissionsInput: BulkVoidSubmissionsInput!) {
  bulkVoidSubmissions(bulkVoidSubmissionsInput: $bulkVoidSubmissionsInput)
}
    `;
export type BulkVoidSubmissionsMutationFn = Apollo.MutationFunction<BulkVoidSubmissionsMutation, BulkVoidSubmissionsMutationVariables>;

/**
 * __useBulkVoidSubmissionsMutation__
 *
 * To run a mutation, you first call `useBulkVoidSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkVoidSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkVoidSubmissionsMutation, { data, loading, error }] = useBulkVoidSubmissionsMutation({
 *   variables: {
 *      bulkVoidSubmissionsInput: // value for 'bulkVoidSubmissionsInput'
 *   },
 * });
 */
export function useBulkVoidSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<BulkVoidSubmissionsMutation, BulkVoidSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkVoidSubmissionsMutation, BulkVoidSubmissionsMutationVariables>(BulkVoidSubmissionsDocument, options);
      }
export type BulkVoidSubmissionsMutationHookResult = ReturnType<typeof useBulkVoidSubmissionsMutation>;
export type BulkVoidSubmissionsMutationResult = Apollo.MutationResult<BulkVoidSubmissionsMutation>;
export type BulkVoidSubmissionsMutationOptions = Apollo.BaseMutationOptions<BulkVoidSubmissionsMutation, BulkVoidSubmissionsMutationVariables>;
export const BulkEligibilityCheckDocument = gql`
    mutation bulkEligibilityCheck($bulkEligibilityCheckInput: BulkEligibilityCheckInput!) {
  bulkEligibilityCheck(bulkEligibilityCheckInput: $bulkEligibilityCheckInput) {
    workflowId
  }
}
    `;
export type BulkEligibilityCheckMutationFn = Apollo.MutationFunction<BulkEligibilityCheckMutation, BulkEligibilityCheckMutationVariables>;

/**
 * __useBulkEligibilityCheckMutation__
 *
 * To run a mutation, you first call `useBulkEligibilityCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEligibilityCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEligibilityCheckMutation, { data, loading, error }] = useBulkEligibilityCheckMutation({
 *   variables: {
 *      bulkEligibilityCheckInput: // value for 'bulkEligibilityCheckInput'
 *   },
 * });
 */
export function useBulkEligibilityCheckMutation(baseOptions?: Apollo.MutationHookOptions<BulkEligibilityCheckMutation, BulkEligibilityCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkEligibilityCheckMutation, BulkEligibilityCheckMutationVariables>(BulkEligibilityCheckDocument, options);
      }
export type BulkEligibilityCheckMutationHookResult = ReturnType<typeof useBulkEligibilityCheckMutation>;
export type BulkEligibilityCheckMutationResult = Apollo.MutationResult<BulkEligibilityCheckMutation>;
export type BulkEligibilityCheckMutationOptions = Apollo.BaseMutationOptions<BulkEligibilityCheckMutation, BulkEligibilityCheckMutationVariables>;
export const BulkUpdateSubmissionsDocument = gql`
    mutation bulkUpdateSubmissions($bulkUpdateSubmissionsInput: BulkUpdateSubmissionsInput!) {
  bulkUpdateSubmissions(bulkUpdateSubmissionsInput: $bulkUpdateSubmissionsInput) {
    ids
  }
}
    `;
export type BulkUpdateSubmissionsMutationFn = Apollo.MutationFunction<BulkUpdateSubmissionsMutation, BulkUpdateSubmissionsMutationVariables>;

/**
 * __useBulkUpdateSubmissionsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateSubmissionsMutation, { data, loading, error }] = useBulkUpdateSubmissionsMutation({
 *   variables: {
 *      bulkUpdateSubmissionsInput: // value for 'bulkUpdateSubmissionsInput'
 *   },
 * });
 */
export function useBulkUpdateSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateSubmissionsMutation, BulkUpdateSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateSubmissionsMutation, BulkUpdateSubmissionsMutationVariables>(BulkUpdateSubmissionsDocument, options);
      }
export type BulkUpdateSubmissionsMutationHookResult = ReturnType<typeof useBulkUpdateSubmissionsMutation>;
export type BulkUpdateSubmissionsMutationResult = Apollo.MutationResult<BulkUpdateSubmissionsMutation>;
export type BulkUpdateSubmissionsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateSubmissionsMutation, BulkUpdateSubmissionsMutationVariables>;
export const CreateManualHoldDocument = gql`
    mutation createManualHold($input: ManualHoldInput!) {
  createManualHold(manualHoldInput: $input) {
    details
  }
}
    `;
export type CreateManualHoldMutationFn = Apollo.MutationFunction<CreateManualHoldMutation, CreateManualHoldMutationVariables>;

/**
 * __useCreateManualHoldMutation__
 *
 * To run a mutation, you first call `useCreateManualHoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualHoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualHoldMutation, { data, loading, error }] = useCreateManualHoldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualHoldMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualHoldMutation, CreateManualHoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualHoldMutation, CreateManualHoldMutationVariables>(CreateManualHoldDocument, options);
      }
export type CreateManualHoldMutationHookResult = ReturnType<typeof useCreateManualHoldMutation>;
export type CreateManualHoldMutationResult = Apollo.MutationResult<CreateManualHoldMutation>;
export type CreateManualHoldMutationOptions = Apollo.BaseMutationOptions<CreateManualHoldMutation, CreateManualHoldMutationVariables>;
export const ProcessCopaymentDocument = gql`
    mutation processCopayment($processCopaymentInput: ProcessCopaymentInput!) {
  processCopayment(processCopaymentInput: $processCopaymentInput) {
    workflowIds
  }
}
    `;
export type ProcessCopaymentMutationFn = Apollo.MutationFunction<ProcessCopaymentMutation, ProcessCopaymentMutationVariables>;

/**
 * __useProcessCopaymentMutation__
 *
 * To run a mutation, you first call `useProcessCopaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessCopaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processCopaymentMutation, { data, loading, error }] = useProcessCopaymentMutation({
 *   variables: {
 *      processCopaymentInput: // value for 'processCopaymentInput'
 *   },
 * });
 */
export function useProcessCopaymentMutation(baseOptions?: Apollo.MutationHookOptions<ProcessCopaymentMutation, ProcessCopaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessCopaymentMutation, ProcessCopaymentMutationVariables>(ProcessCopaymentDocument, options);
      }
export type ProcessCopaymentMutationHookResult = ReturnType<typeof useProcessCopaymentMutation>;
export type ProcessCopaymentMutationResult = Apollo.MutationResult<ProcessCopaymentMutation>;
export type ProcessCopaymentMutationOptions = Apollo.BaseMutationOptions<ProcessCopaymentMutation, ProcessCopaymentMutationVariables>;
export const CreatePackageDocument = gql`
    mutation createPackage($packageInput: CreatePackageInput!) {
  createPackage(packageInput: $packageInput) {
    id
    name
    isEditable
    packageOfferings {
      id
      programIndication
      packageId
      packageOffering
      productId
    }
  }
}
    `;
export type CreatePackageMutationFn = Apollo.MutationFunction<CreatePackageMutation, CreatePackageMutationVariables>;

/**
 * __useCreatePackageMutation__
 *
 * To run a mutation, you first call `useCreatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageMutation, { data, loading, error }] = useCreatePackageMutation({
 *   variables: {
 *      packageInput: // value for 'packageInput'
 *   },
 * });
 */
export function useCreatePackageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageMutation, CreatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageMutation, CreatePackageMutationVariables>(CreatePackageDocument, options);
      }
export type CreatePackageMutationHookResult = ReturnType<typeof useCreatePackageMutation>;
export type CreatePackageMutationResult = Apollo.MutationResult<CreatePackageMutation>;
export type CreatePackageMutationOptions = Apollo.BaseMutationOptions<CreatePackageMutation, CreatePackageMutationVariables>;
export const UpdatePackageDocument = gql`
    mutation updatePackage($packageId: Int!, $packageInput: UpdatePackageInput!) {
  updatePackage(packageId: $packageId, packageInput: $packageInput) {
    id
    name
    isEditable
    packageOfferings {
      id
      programIndication
      packageId
      packageOffering
      productId
    }
  }
}
    `;
export type UpdatePackageMutationFn = Apollo.MutationFunction<UpdatePackageMutation, UpdatePackageMutationVariables>;

/**
 * __useUpdatePackageMutation__
 *
 * To run a mutation, you first call `useUpdatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageMutation, { data, loading, error }] = useUpdatePackageMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      packageInput: // value for 'packageInput'
 *   },
 * });
 */
export function useUpdatePackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageMutation, UpdatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageMutation, UpdatePackageMutationVariables>(UpdatePackageDocument, options);
      }
export type UpdatePackageMutationHookResult = ReturnType<typeof useUpdatePackageMutation>;
export type UpdatePackageMutationResult = Apollo.MutationResult<UpdatePackageMutation>;
export type UpdatePackageMutationOptions = Apollo.BaseMutationOptions<UpdatePackageMutation, UpdatePackageMutationVariables>;
export const DeletePackageDocument = gql`
    mutation deletePackage($packageId: Int!) {
  deletePackage(packageId: $packageId)
}
    `;
export type DeletePackageMutationFn = Apollo.MutationFunction<DeletePackageMutation, DeletePackageMutationVariables>;

/**
 * __useDeletePackageMutation__
 *
 * To run a mutation, you first call `useDeletePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageMutation, { data, loading, error }] = useDeletePackageMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useDeletePackageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageMutation, DeletePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageMutation, DeletePackageMutationVariables>(DeletePackageDocument, options);
      }
export type DeletePackageMutationHookResult = ReturnType<typeof useDeletePackageMutation>;
export type DeletePackageMutationResult = Apollo.MutationResult<DeletePackageMutation>;
export type DeletePackageMutationOptions = Apollo.BaseMutationOptions<DeletePackageMutation, DeletePackageMutationVariables>;
export const CreateContractDocument = gql`
    mutation createContract($contractInput: CreateContractInput!) {
  createContract(contractInput: $contractInput) {
    id
    clientId
    insurerId
    contractTemplateId
    clientsInsurerId
    currency
    chronicPrice
    acutePrice
    startDate
    endDate
    packageEnabled
    partnershipId
    globalDailyEngagementCap
    contract {
      ... on EngagementContractType {
        educationalTypes
        activityTypes
        matchType
        engagementRules
      }
      ... on MilestonesType {
        name
        payment
        dateOfServiceOffset
        billableActivityTypes
        dayRange
        conditions {
          function
          threshold
        }
      }
      ... on IndividualMilestonesType {
        name
        payment
        billableActivityTypes
        conditions {
          function
          threshold
        }
      }
    }
    billableActivityTypes {
      id
      name
      engagementTypeId
    }
    contractPackages {
      billingEnabled
      billingModelId
      contractTemplateId
      price
      startDate
      void
    }
  }
}
    `;
export type CreateContractMutationFn = Apollo.MutationFunction<CreateContractMutation, CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      contractInput: // value for 'contractInput'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const CreatePackageContractDocument = gql`
    mutation createPackageContract($contractInput: CreateContractInput!) {
  createPackageContract(contractInput: $contractInput) {
    id
    clientId
    insurerId
    clientsInsurerId
    startDate
    endDate
    currency
    packageEnabled
    partnershipId
    globalDailyEngagementCap
    contractPackages {
      billingEnabled
      billingModelId
      contractTemplateId
      price
      startDate
      rules
      void
      billingTypeOverride
      costShareOptions {
        id
        contractPackageId
        deductionTiming
        cadence
      }
    }
  }
}
    `;
export type CreatePackageContractMutationFn = Apollo.MutationFunction<CreatePackageContractMutation, CreatePackageContractMutationVariables>;

/**
 * __useCreatePackageContractMutation__
 *
 * To run a mutation, you first call `useCreatePackageContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageContractMutation, { data, loading, error }] = useCreatePackageContractMutation({
 *   variables: {
 *      contractInput: // value for 'contractInput'
 *   },
 * });
 */
export function useCreatePackageContractMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageContractMutation, CreatePackageContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageContractMutation, CreatePackageContractMutationVariables>(CreatePackageContractDocument, options);
      }
export type CreatePackageContractMutationHookResult = ReturnType<typeof useCreatePackageContractMutation>;
export type CreatePackageContractMutationResult = Apollo.MutationResult<CreatePackageContractMutation>;
export type CreatePackageContractMutationOptions = Apollo.BaseMutationOptions<CreatePackageContractMutation, CreatePackageContractMutationVariables>;
export const UpdateContractDocument = gql`
    mutation updateContract($contractId: Int!, $contractInput: UpdateContractInput!) {
  updateContract(contractId: $contractId, contractInput: $contractInput) {
    id
    clientId
    insurerId
    contractTemplateId
    clientsInsurerId
    chronicPrice
    acutePrice
    startDate
    endDate
    void
    partnershipId
    globalDailyEngagementCap
    contract {
      ... on EngagementContractType {
        educationalTypes
        activityTypes
        matchType
        engagementRules
      }
      ... on MilestonesType {
        name
        payment
        dateOfServiceOffset
        billableActivityTypes
        dayRange
        conditions {
          function
          threshold
        }
      }
      ... on IndividualMilestonesType {
        name
        payment
        billableActivityTypes
        conditions {
          function
          threshold
        }
      }
    }
    billableActivityTypes {
      id
      name
      engagementTypeId
    }
    contractPackages {
      id
      packageId
      billingEnabled
      billingModelId
      contractTemplateId
      price
      startDate
      void
      billingTypeOverride
      costShareOptions {
        id
        contractPackageId
        deductionTiming
        cadence
      }
    }
  }
}
    `;
export type UpdateContractMutationFn = Apollo.MutationFunction<UpdateContractMutation, UpdateContractMutationVariables>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      contractInput: // value for 'contractInput'
 *   },
 * });
 */
export function useUpdateContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractMutation, UpdateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument, options);
      }
export type UpdateContractMutationHookResult = ReturnType<typeof useUpdateContractMutation>;
export type UpdateContractMutationResult = Apollo.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables>;
export const CreateBatchContractDocument = gql`
    mutation createBatchContract($batchContractInput: CreateBatchContractInput!) {
  createBatchContract(batchContractInput: $batchContractInput) {
    clientInsurerId
    newContract {
      startDate
      endDate
    }
    oldContract {
      startDate
      endDate
    }
    error
    success
  }
}
    `;
export type CreateBatchContractMutationFn = Apollo.MutationFunction<CreateBatchContractMutation, CreateBatchContractMutationVariables>;

/**
 * __useCreateBatchContractMutation__
 *
 * To run a mutation, you first call `useCreateBatchContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBatchContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBatchContractMutation, { data, loading, error }] = useCreateBatchContractMutation({
 *   variables: {
 *      batchContractInput: // value for 'batchContractInput'
 *   },
 * });
 */
export function useCreateBatchContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateBatchContractMutation, CreateBatchContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBatchContractMutation, CreateBatchContractMutationVariables>(CreateBatchContractDocument, options);
      }
export type CreateBatchContractMutationHookResult = ReturnType<typeof useCreateBatchContractMutation>;
export type CreateBatchContractMutationResult = Apollo.MutationResult<CreateBatchContractMutation>;
export type CreateBatchContractMutationOptions = Apollo.BaseMutationOptions<CreateBatchContractMutation, CreateBatchContractMutationVariables>;
export const BulkUpdateBillingTypeDocument = gql`
    mutation bulkUpdateBillingType($input: BulkUpdateBillingTypeInput!) {
  bulkUpdateBillingType(input: $input) {
    contractsUpdated
  }
}
    `;
export type BulkUpdateBillingTypeMutationFn = Apollo.MutationFunction<BulkUpdateBillingTypeMutation, BulkUpdateBillingTypeMutationVariables>;

/**
 * __useBulkUpdateBillingTypeMutation__
 *
 * To run a mutation, you first call `useBulkUpdateBillingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBillingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBillingTypeMutation, { data, loading, error }] = useBulkUpdateBillingTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateBillingTypeMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateBillingTypeMutation, BulkUpdateBillingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateBillingTypeMutation, BulkUpdateBillingTypeMutationVariables>(BulkUpdateBillingTypeDocument, options);
      }
export type BulkUpdateBillingTypeMutationHookResult = ReturnType<typeof useBulkUpdateBillingTypeMutation>;
export type BulkUpdateBillingTypeMutationResult = Apollo.MutationResult<BulkUpdateBillingTypeMutation>;
export type BulkUpdateBillingTypeMutationOptions = Apollo.BaseMutationOptions<BulkUpdateBillingTypeMutation, BulkUpdateBillingTypeMutationVariables>;
export const UpdateContractPackageDocument = gql`
    mutation updateContractPackage($contractPackageId: Int!, $contractPackageInput: ContractPackagesInput!) {
  updateContractPackage(
    contractPackageId: $contractPackageId
    contractPackageInput: $contractPackageInput
  ) {
    id
    packageId
    billingModelId
    price
    startDate
    billingEnabled
    void
    contractId
    billingTypeOverride
    costShareOptions {
      id
      contractPackageId
      deductionTiming
      cadence
    }
    package {
      id
      name
      packageOfferings {
        id
        packageId
        packageOffering
        productId
        programIndication
      }
    }
    billingModel {
      id
      name
    }
    billableActivityTypes {
      id
      name
      engagementTypeId
    }
  }
}
    `;
export type UpdateContractPackageMutationFn = Apollo.MutationFunction<UpdateContractPackageMutation, UpdateContractPackageMutationVariables>;

/**
 * __useUpdateContractPackageMutation__
 *
 * To run a mutation, you first call `useUpdateContractPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractPackageMutation, { data, loading, error }] = useUpdateContractPackageMutation({
 *   variables: {
 *      contractPackageId: // value for 'contractPackageId'
 *      contractPackageInput: // value for 'contractPackageInput'
 *   },
 * });
 */
export function useUpdateContractPackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractPackageMutation, UpdateContractPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractPackageMutation, UpdateContractPackageMutationVariables>(UpdateContractPackageDocument, options);
      }
export type UpdateContractPackageMutationHookResult = ReturnType<typeof useUpdateContractPackageMutation>;
export type UpdateContractPackageMutationResult = Apollo.MutationResult<UpdateContractPackageMutation>;
export type UpdateContractPackageMutationOptions = Apollo.BaseMutationOptions<UpdateContractPackageMutation, UpdateContractPackageMutationVariables>;
export const CreateCvsFeeScheduleDocument = gql`
    mutation createCvsFeeSchedule($cvsFeeScheduleInput: CreateCvsFeeScheduleInput!) {
  createCvsFeeSchedule(cvsFeeScheduleInput: $cvsFeeScheduleInput) {
    id
    paymentType
    price
    upc
    charge
    daysSupply
    description
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;
export type CreateCvsFeeScheduleMutationFn = Apollo.MutationFunction<CreateCvsFeeScheduleMutation, CreateCvsFeeScheduleMutationVariables>;

/**
 * __useCreateCvsFeeScheduleMutation__
 *
 * To run a mutation, you first call `useCreateCvsFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCvsFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCvsFeeScheduleMutation, { data, loading, error }] = useCreateCvsFeeScheduleMutation({
 *   variables: {
 *      cvsFeeScheduleInput: // value for 'cvsFeeScheduleInput'
 *   },
 * });
 */
export function useCreateCvsFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCvsFeeScheduleMutation, CreateCvsFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCvsFeeScheduleMutation, CreateCvsFeeScheduleMutationVariables>(CreateCvsFeeScheduleDocument, options);
      }
export type CreateCvsFeeScheduleMutationHookResult = ReturnType<typeof useCreateCvsFeeScheduleMutation>;
export type CreateCvsFeeScheduleMutationResult = Apollo.MutationResult<CreateCvsFeeScheduleMutation>;
export type CreateCvsFeeScheduleMutationOptions = Apollo.BaseMutationOptions<CreateCvsFeeScheduleMutation, CreateCvsFeeScheduleMutationVariables>;
export const UpdateCvsFeeScheduleDocument = gql`
    mutation updateCvsFeeSchedule($id: Int!, $cvsFeeScheduleInput: UpdateCvsFeeScheduleInput!) {
  updateCvsFeeSchedule(id: $id, cvsFeeScheduleInput: $cvsFeeScheduleInput) {
    id
    paymentType
    price
    upc
    charge
    daysSupply
    description
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;
export type UpdateCvsFeeScheduleMutationFn = Apollo.MutationFunction<UpdateCvsFeeScheduleMutation, UpdateCvsFeeScheduleMutationVariables>;

/**
 * __useUpdateCvsFeeScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateCvsFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCvsFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCvsFeeScheduleMutation, { data, loading, error }] = useUpdateCvsFeeScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cvsFeeScheduleInput: // value for 'cvsFeeScheduleInput'
 *   },
 * });
 */
export function useUpdateCvsFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCvsFeeScheduleMutation, UpdateCvsFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCvsFeeScheduleMutation, UpdateCvsFeeScheduleMutationVariables>(UpdateCvsFeeScheduleDocument, options);
      }
export type UpdateCvsFeeScheduleMutationHookResult = ReturnType<typeof useUpdateCvsFeeScheduleMutation>;
export type UpdateCvsFeeScheduleMutationResult = Apollo.MutationResult<UpdateCvsFeeScheduleMutation>;
export type UpdateCvsFeeScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateCvsFeeScheduleMutation, UpdateCvsFeeScheduleMutationVariables>;
export const DeleteCvsFeeScheduleDocument = gql`
    mutation deleteCvsFeeSchedule($id: Int!) {
  deleteCvsFeeSchedule(id: $id)
}
    `;
export type DeleteCvsFeeScheduleMutationFn = Apollo.MutationFunction<DeleteCvsFeeScheduleMutation, DeleteCvsFeeScheduleMutationVariables>;

/**
 * __useDeleteCvsFeeScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteCvsFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCvsFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCvsFeeScheduleMutation, { data, loading, error }] = useDeleteCvsFeeScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCvsFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCvsFeeScheduleMutation, DeleteCvsFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCvsFeeScheduleMutation, DeleteCvsFeeScheduleMutationVariables>(DeleteCvsFeeScheduleDocument, options);
      }
export type DeleteCvsFeeScheduleMutationHookResult = ReturnType<typeof useDeleteCvsFeeScheduleMutation>;
export type DeleteCvsFeeScheduleMutationResult = Apollo.MutationResult<DeleteCvsFeeScheduleMutation>;
export type DeleteCvsFeeScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteCvsFeeScheduleMutation, DeleteCvsFeeScheduleMutationVariables>;
export const CreateDiscountDocument = gql`
    mutation createDiscount($discountInput: CreateDiscountInput!) {
  createDiscount(discountInput: $discountInput) {
    clientId
    partnershipId
    discount
    discountType
    endDate
    scopes {
      scopeableType
      scopeableId
    }
    startDate
    suppressEmptyCharges
  }
}
    `;
export type CreateDiscountMutationFn = Apollo.MutationFunction<CreateDiscountMutation, CreateDiscountMutationVariables>;

/**
 * __useCreateDiscountMutation__
 *
 * To run a mutation, you first call `useCreateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountMutation, { data, loading, error }] = useCreateDiscountMutation({
 *   variables: {
 *      discountInput: // value for 'discountInput'
 *   },
 * });
 */
export function useCreateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscountMutation, CreateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscountMutation, CreateDiscountMutationVariables>(CreateDiscountDocument, options);
      }
export type CreateDiscountMutationHookResult = ReturnType<typeof useCreateDiscountMutation>;
export type CreateDiscountMutationResult = Apollo.MutationResult<CreateDiscountMutation>;
export type CreateDiscountMutationOptions = Apollo.BaseMutationOptions<CreateDiscountMutation, CreateDiscountMutationVariables>;
export const UpdateDiscountDocument = gql`
    mutation updateDiscount($discountInput: UpdateDiscountInput!) {
  updateDiscount(discountInput: $discountInput) {
    clientId
    partnershipId
    discountDefinitionId
    discount
    discountType
    endDate
    scopes {
      scopeableType
      scopeableId
    }
    startDate
    suppressEmptyCharges
  }
}
    `;
export type UpdateDiscountMutationFn = Apollo.MutationFunction<UpdateDiscountMutation, UpdateDiscountMutationVariables>;

/**
 * __useUpdateDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountMutation, { data, loading, error }] = useUpdateDiscountMutation({
 *   variables: {
 *      discountInput: // value for 'discountInput'
 *   },
 * });
 */
export function useUpdateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountMutation, UpdateDiscountMutationVariables>(UpdateDiscountDocument, options);
      }
export type UpdateDiscountMutationHookResult = ReturnType<typeof useUpdateDiscountMutation>;
export type UpdateDiscountMutationResult = Apollo.MutationResult<UpdateDiscountMutation>;
export type UpdateDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const CreateEsiFeeScheduleDocument = gql`
    mutation createEsiFeeSchedule($esiFeeScheduleInput: CreateEsiFeeScheduleInput!) {
  createEsiFeeSchedule(esiFeeScheduleInput: $esiFeeScheduleInput) {
    id
    program
    paymentType
    price
    upc
    description
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;
export type CreateEsiFeeScheduleMutationFn = Apollo.MutationFunction<CreateEsiFeeScheduleMutation, CreateEsiFeeScheduleMutationVariables>;

/**
 * __useCreateEsiFeeScheduleMutation__
 *
 * To run a mutation, you first call `useCreateEsiFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEsiFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEsiFeeScheduleMutation, { data, loading, error }] = useCreateEsiFeeScheduleMutation({
 *   variables: {
 *      esiFeeScheduleInput: // value for 'esiFeeScheduleInput'
 *   },
 * });
 */
export function useCreateEsiFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateEsiFeeScheduleMutation, CreateEsiFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEsiFeeScheduleMutation, CreateEsiFeeScheduleMutationVariables>(CreateEsiFeeScheduleDocument, options);
      }
export type CreateEsiFeeScheduleMutationHookResult = ReturnType<typeof useCreateEsiFeeScheduleMutation>;
export type CreateEsiFeeScheduleMutationResult = Apollo.MutationResult<CreateEsiFeeScheduleMutation>;
export type CreateEsiFeeScheduleMutationOptions = Apollo.BaseMutationOptions<CreateEsiFeeScheduleMutation, CreateEsiFeeScheduleMutationVariables>;
export const UpdateEsiFeeScheduleDocument = gql`
    mutation updateEsiFeeSchedule($id: Int!, $esiFeeScheduleInput: UpdateEsiFeeScheduleInput!) {
  updateEsiFeeSchedule(id: $id, esiFeeScheduleInput: $esiFeeScheduleInput) {
    id
    program
    paymentType
    price
    upc
    description
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;
export type UpdateEsiFeeScheduleMutationFn = Apollo.MutationFunction<UpdateEsiFeeScheduleMutation, UpdateEsiFeeScheduleMutationVariables>;

/**
 * __useUpdateEsiFeeScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateEsiFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsiFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsiFeeScheduleMutation, { data, loading, error }] = useUpdateEsiFeeScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      esiFeeScheduleInput: // value for 'esiFeeScheduleInput'
 *   },
 * });
 */
export function useUpdateEsiFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsiFeeScheduleMutation, UpdateEsiFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsiFeeScheduleMutation, UpdateEsiFeeScheduleMutationVariables>(UpdateEsiFeeScheduleDocument, options);
      }
export type UpdateEsiFeeScheduleMutationHookResult = ReturnType<typeof useUpdateEsiFeeScheduleMutation>;
export type UpdateEsiFeeScheduleMutationResult = Apollo.MutationResult<UpdateEsiFeeScheduleMutation>;
export type UpdateEsiFeeScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateEsiFeeScheduleMutation, UpdateEsiFeeScheduleMutationVariables>;
export const DeleteEsiFeeScheduleDocument = gql`
    mutation deleteEsiFeeSchedule($id: Int!) {
  deleteEsiFeeSchedule(id: $id)
}
    `;
export type DeleteEsiFeeScheduleMutationFn = Apollo.MutationFunction<DeleteEsiFeeScheduleMutation, DeleteEsiFeeScheduleMutationVariables>;

/**
 * __useDeleteEsiFeeScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteEsiFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEsiFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEsiFeeScheduleMutation, { data, loading, error }] = useDeleteEsiFeeScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEsiFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEsiFeeScheduleMutation, DeleteEsiFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEsiFeeScheduleMutation, DeleteEsiFeeScheduleMutationVariables>(DeleteEsiFeeScheduleDocument, options);
      }
export type DeleteEsiFeeScheduleMutationHookResult = ReturnType<typeof useDeleteEsiFeeScheduleMutation>;
export type DeleteEsiFeeScheduleMutationResult = Apollo.MutationResult<DeleteEsiFeeScheduleMutation>;
export type DeleteEsiFeeScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteEsiFeeScheduleMutation, DeleteEsiFeeScheduleMutationVariables>;
export const CreateFeeScheduleDocument = gql`
    mutation createFeeSchedule($feeScheduleInput: CreateFeeScheduleInput!) {
  createFeeSchedule(feeScheduleInput: $feeScheduleInput) {
    id
    entityType
    entityId
    paymentSystem
    paymentType
    price
    enabled
    notes
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;
export type CreateFeeScheduleMutationFn = Apollo.MutationFunction<CreateFeeScheduleMutation, CreateFeeScheduleMutationVariables>;

/**
 * __useCreateFeeScheduleMutation__
 *
 * To run a mutation, you first call `useCreateFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeeScheduleMutation, { data, loading, error }] = useCreateFeeScheduleMutation({
 *   variables: {
 *      feeScheduleInput: // value for 'feeScheduleInput'
 *   },
 * });
 */
export function useCreateFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeeScheduleMutation, CreateFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeeScheduleMutation, CreateFeeScheduleMutationVariables>(CreateFeeScheduleDocument, options);
      }
export type CreateFeeScheduleMutationHookResult = ReturnType<typeof useCreateFeeScheduleMutation>;
export type CreateFeeScheduleMutationResult = Apollo.MutationResult<CreateFeeScheduleMutation>;
export type CreateFeeScheduleMutationOptions = Apollo.BaseMutationOptions<CreateFeeScheduleMutation, CreateFeeScheduleMutationVariables>;
export const UpdateFeeScheduleDocument = gql`
    mutation updateFeeSchedule($id: Int!, $feeScheduleInput: UpdateFeeScheduleInput!) {
  updateFeeSchedule(id: $id, feeScheduleInput: $feeScheduleInput) {
    id
    entityType
    entityId
    paymentSystem
    paymentType
    price
    enabled
    notes
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;
export type UpdateFeeScheduleMutationFn = Apollo.MutationFunction<UpdateFeeScheduleMutation, UpdateFeeScheduleMutationVariables>;

/**
 * __useUpdateFeeScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeeScheduleMutation, { data, loading, error }] = useUpdateFeeScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      feeScheduleInput: // value for 'feeScheduleInput'
 *   },
 * });
 */
export function useUpdateFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeeScheduleMutation, UpdateFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeeScheduleMutation, UpdateFeeScheduleMutationVariables>(UpdateFeeScheduleDocument, options);
      }
export type UpdateFeeScheduleMutationHookResult = ReturnType<typeof useUpdateFeeScheduleMutation>;
export type UpdateFeeScheduleMutationResult = Apollo.MutationResult<UpdateFeeScheduleMutation>;
export type UpdateFeeScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateFeeScheduleMutation, UpdateFeeScheduleMutationVariables>;
export const DeleteFeeScheduleDocument = gql`
    mutation deleteFeeSchedule($id: Int!) {
  deleteFeeSchedule(id: $id)
}
    `;
export type DeleteFeeScheduleMutationFn = Apollo.MutationFunction<DeleteFeeScheduleMutation, DeleteFeeScheduleMutationVariables>;

/**
 * __useDeleteFeeScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeeScheduleMutation, { data, loading, error }] = useDeleteFeeScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeeScheduleMutation, DeleteFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeeScheduleMutation, DeleteFeeScheduleMutationVariables>(DeleteFeeScheduleDocument, options);
      }
export type DeleteFeeScheduleMutationHookResult = ReturnType<typeof useDeleteFeeScheduleMutation>;
export type DeleteFeeScheduleMutationResult = Apollo.MutationResult<DeleteFeeScheduleMutation>;
export type DeleteFeeScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteFeeScheduleMutation, DeleteFeeScheduleMutationVariables>;
export const GoogleFileUploadDocument = gql`
    mutation googleFileUpload($fileInput: GoogleFileInputType!) {
  googleFileUpload(fileInput: $fileInput) {
    taskId
  }
}
    `;
export type GoogleFileUploadMutationFn = Apollo.MutationFunction<GoogleFileUploadMutation, GoogleFileUploadMutationVariables>;

/**
 * __useGoogleFileUploadMutation__
 *
 * To run a mutation, you first call `useGoogleFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleFileUploadMutation, { data, loading, error }] = useGoogleFileUploadMutation({
 *   variables: {
 *      fileInput: // value for 'fileInput'
 *   },
 * });
 */
export function useGoogleFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<GoogleFileUploadMutation, GoogleFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleFileUploadMutation, GoogleFileUploadMutationVariables>(GoogleFileUploadDocument, options);
      }
export type GoogleFileUploadMutationHookResult = ReturnType<typeof useGoogleFileUploadMutation>;
export type GoogleFileUploadMutationResult = Apollo.MutationResult<GoogleFileUploadMutation>;
export type GoogleFileUploadMutationOptions = Apollo.BaseMutationOptions<GoogleFileUploadMutation, GoogleFileUploadMutationVariables>;
export const CreateIcdCodeDocument = gql`
    mutation createIcdCode($icdCodeInput: CreateIcdCodeInput!) {
  createIcdCode(icdCodeInput: $icdCodeInput) {
    id
    indication
    universalCode
    rightCode
    leftCode
    startDate
    endDate
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;
export type CreateIcdCodeMutationFn = Apollo.MutationFunction<CreateIcdCodeMutation, CreateIcdCodeMutationVariables>;

/**
 * __useCreateIcdCodeMutation__
 *
 * To run a mutation, you first call `useCreateIcdCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIcdCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIcdCodeMutation, { data, loading, error }] = useCreateIcdCodeMutation({
 *   variables: {
 *      icdCodeInput: // value for 'icdCodeInput'
 *   },
 * });
 */
export function useCreateIcdCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateIcdCodeMutation, CreateIcdCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIcdCodeMutation, CreateIcdCodeMutationVariables>(CreateIcdCodeDocument, options);
      }
export type CreateIcdCodeMutationHookResult = ReturnType<typeof useCreateIcdCodeMutation>;
export type CreateIcdCodeMutationResult = Apollo.MutationResult<CreateIcdCodeMutation>;
export type CreateIcdCodeMutationOptions = Apollo.BaseMutationOptions<CreateIcdCodeMutation, CreateIcdCodeMutationVariables>;
export const UpdateIcdCodeDocument = gql`
    mutation updateIcdCode($id: Int!, $icdCodeInput: UpdateIcdCodeInput!) {
  updateIcdCode(id: $id, icdCodeInput: $icdCodeInput) {
    id
    indication
    universalCode
    rightCode
    leftCode
    startDate
    endDate
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;
export type UpdateIcdCodeMutationFn = Apollo.MutationFunction<UpdateIcdCodeMutation, UpdateIcdCodeMutationVariables>;

/**
 * __useUpdateIcdCodeMutation__
 *
 * To run a mutation, you first call `useUpdateIcdCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIcdCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIcdCodeMutation, { data, loading, error }] = useUpdateIcdCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      icdCodeInput: // value for 'icdCodeInput'
 *   },
 * });
 */
export function useUpdateIcdCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIcdCodeMutation, UpdateIcdCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIcdCodeMutation, UpdateIcdCodeMutationVariables>(UpdateIcdCodeDocument, options);
      }
export type UpdateIcdCodeMutationHookResult = ReturnType<typeof useUpdateIcdCodeMutation>;
export type UpdateIcdCodeMutationResult = Apollo.MutationResult<UpdateIcdCodeMutation>;
export type UpdateIcdCodeMutationOptions = Apollo.BaseMutationOptions<UpdateIcdCodeMutation, UpdateIcdCodeMutationVariables>;
export const DeleteIcdCodeDocument = gql`
    mutation deleteIcdCode($id: Int!) {
  deleteIcdCode(id: $id)
}
    `;
export type DeleteIcdCodeMutationFn = Apollo.MutationFunction<DeleteIcdCodeMutation, DeleteIcdCodeMutationVariables>;

/**
 * __useDeleteIcdCodeMutation__
 *
 * To run a mutation, you first call `useDeleteIcdCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIcdCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIcdCodeMutation, { data, loading, error }] = useDeleteIcdCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIcdCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIcdCodeMutation, DeleteIcdCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIcdCodeMutation, DeleteIcdCodeMutationVariables>(DeleteIcdCodeDocument, options);
      }
export type DeleteIcdCodeMutationHookResult = ReturnType<typeof useDeleteIcdCodeMutation>;
export type DeleteIcdCodeMutationResult = Apollo.MutationResult<DeleteIcdCodeMutation>;
export type DeleteIcdCodeMutationOptions = Apollo.BaseMutationOptions<DeleteIcdCodeMutation, DeleteIcdCodeMutationVariables>;
export const CreateProcedureCodeDocument = gql`
    mutation createProcedureCode($procedureCodeInput: CreateProcedureCodeInput!) {
  createProcedureCode(procedureCodeInput: $procedureCodeInput) {
    id
    paymentTypeId
    cptCode
    modifier1
    modifier2
    partnershipId
    insurerId
    clientId
    lastModifiedBy
    createdAt
    updatedAt
  }
}
    `;
export type CreateProcedureCodeMutationFn = Apollo.MutationFunction<CreateProcedureCodeMutation, CreateProcedureCodeMutationVariables>;

/**
 * __useCreateProcedureCodeMutation__
 *
 * To run a mutation, you first call `useCreateProcedureCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureCodeMutation, { data, loading, error }] = useCreateProcedureCodeMutation({
 *   variables: {
 *      procedureCodeInput: // value for 'procedureCodeInput'
 *   },
 * });
 */
export function useCreateProcedureCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureCodeMutation, CreateProcedureCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureCodeMutation, CreateProcedureCodeMutationVariables>(CreateProcedureCodeDocument, options);
      }
export type CreateProcedureCodeMutationHookResult = ReturnType<typeof useCreateProcedureCodeMutation>;
export type CreateProcedureCodeMutationResult = Apollo.MutationResult<CreateProcedureCodeMutation>;
export type CreateProcedureCodeMutationOptions = Apollo.BaseMutationOptions<CreateProcedureCodeMutation, CreateProcedureCodeMutationVariables>;
export const UpdateProcedureCodeDocument = gql`
    mutation updateProcedureCode($id: Int!, $procedureCodeInput: UpdateProcedureCodeInput!) {
  updateProcedureCode(id: $id, procedureCodeInput: $procedureCodeInput) {
    id
    paymentTypeId
    cptCode
    modifier1
    modifier2
    partnershipId
    insurerId
    clientId
    lastModifiedBy
    createdAt
    updatedAt
  }
}
    `;
export type UpdateProcedureCodeMutationFn = Apollo.MutationFunction<UpdateProcedureCodeMutation, UpdateProcedureCodeMutationVariables>;

/**
 * __useUpdateProcedureCodeMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureCodeMutation, { data, loading, error }] = useUpdateProcedureCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      procedureCodeInput: // value for 'procedureCodeInput'
 *   },
 * });
 */
export function useUpdateProcedureCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureCodeMutation, UpdateProcedureCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureCodeMutation, UpdateProcedureCodeMutationVariables>(UpdateProcedureCodeDocument, options);
      }
export type UpdateProcedureCodeMutationHookResult = ReturnType<typeof useUpdateProcedureCodeMutation>;
export type UpdateProcedureCodeMutationResult = Apollo.MutationResult<UpdateProcedureCodeMutation>;
export type UpdateProcedureCodeMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureCodeMutation, UpdateProcedureCodeMutationVariables>;
export const DeleteProcedureCodeDocument = gql`
    mutation deleteProcedureCode($id: Int!) {
  deleteProcedureCode(id: $id)
}
    `;
export type DeleteProcedureCodeMutationFn = Apollo.MutationFunction<DeleteProcedureCodeMutation, DeleteProcedureCodeMutationVariables>;

/**
 * __useDeleteProcedureCodeMutation__
 *
 * To run a mutation, you first call `useDeleteProcedureCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcedureCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcedureCodeMutation, { data, loading, error }] = useDeleteProcedureCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProcedureCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcedureCodeMutation, DeleteProcedureCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcedureCodeMutation, DeleteProcedureCodeMutationVariables>(DeleteProcedureCodeDocument, options);
      }
export type DeleteProcedureCodeMutationHookResult = ReturnType<typeof useDeleteProcedureCodeMutation>;
export type DeleteProcedureCodeMutationResult = Apollo.MutationResult<DeleteProcedureCodeMutation>;
export type DeleteProcedureCodeMutationOptions = Apollo.BaseMutationOptions<DeleteProcedureCodeMutation, DeleteProcedureCodeMutationVariables>;
export const CreateProgramCapDocument = gql`
    mutation CreateProgramCap($createProgramCapInput: CreateProgramCapInput!) {
  createProgramCap(createProgramCapInput: $createProgramCapInput) {
    id
    clientId
    startDate
    endDate
    cap
    lockDate
    lockPrice
  }
}
    `;
export type CreateProgramCapMutationFn = Apollo.MutationFunction<CreateProgramCapMutation, CreateProgramCapMutationVariables>;

/**
 * __useCreateProgramCapMutation__
 *
 * To run a mutation, you first call `useCreateProgramCapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramCapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramCapMutation, { data, loading, error }] = useCreateProgramCapMutation({
 *   variables: {
 *      createProgramCapInput: // value for 'createProgramCapInput'
 *   },
 * });
 */
export function useCreateProgramCapMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramCapMutation, CreateProgramCapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramCapMutation, CreateProgramCapMutationVariables>(CreateProgramCapDocument, options);
      }
export type CreateProgramCapMutationHookResult = ReturnType<typeof useCreateProgramCapMutation>;
export type CreateProgramCapMutationResult = Apollo.MutationResult<CreateProgramCapMutation>;
export type CreateProgramCapMutationOptions = Apollo.BaseMutationOptions<CreateProgramCapMutation, CreateProgramCapMutationVariables>;
export const UpdateProgramCapDocument = gql`
    mutation UpdateProgramCap($updateProgramCapInput: UpdateProgramCapInput!) {
  updateProgramCap(updateProgramCapInput: $updateProgramCapInput) {
    id
    clientId
    startDate
    endDate
    cap
    lockDate
    lockPrice
  }
}
    `;
export type UpdateProgramCapMutationFn = Apollo.MutationFunction<UpdateProgramCapMutation, UpdateProgramCapMutationVariables>;

/**
 * __useUpdateProgramCapMutation__
 *
 * To run a mutation, you first call `useUpdateProgramCapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramCapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramCapMutation, { data, loading, error }] = useUpdateProgramCapMutation({
 *   variables: {
 *      updateProgramCapInput: // value for 'updateProgramCapInput'
 *   },
 * });
 */
export function useUpdateProgramCapMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramCapMutation, UpdateProgramCapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramCapMutation, UpdateProgramCapMutationVariables>(UpdateProgramCapDocument, options);
      }
export type UpdateProgramCapMutationHookResult = ReturnType<typeof useUpdateProgramCapMutation>;
export type UpdateProgramCapMutationResult = Apollo.MutationResult<UpdateProgramCapMutation>;
export type UpdateProgramCapMutationOptions = Apollo.BaseMutationOptions<UpdateProgramCapMutation, UpdateProgramCapMutationVariables>;
export const GenerateProgramCapReportDocument = gql`
    mutation GenerateProgramCapReport($generateProgramCapReportInput: GenerateProgramCapReportInput!) {
  generateProgramCapReport(
    generateProgramCapReportInput: $generateProgramCapReportInput
  )
}
    `;
export type GenerateProgramCapReportMutationFn = Apollo.MutationFunction<GenerateProgramCapReportMutation, GenerateProgramCapReportMutationVariables>;

/**
 * __useGenerateProgramCapReportMutation__
 *
 * To run a mutation, you first call `useGenerateProgramCapReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProgramCapReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProgramCapReportMutation, { data, loading, error }] = useGenerateProgramCapReportMutation({
 *   variables: {
 *      generateProgramCapReportInput: // value for 'generateProgramCapReportInput'
 *   },
 * });
 */
export function useGenerateProgramCapReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProgramCapReportMutation, GenerateProgramCapReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProgramCapReportMutation, GenerateProgramCapReportMutationVariables>(GenerateProgramCapReportDocument, options);
      }
export type GenerateProgramCapReportMutationHookResult = ReturnType<typeof useGenerateProgramCapReportMutation>;
export type GenerateProgramCapReportMutationResult = Apollo.MutationResult<GenerateProgramCapReportMutation>;
export type GenerateProgramCapReportMutationOptions = Apollo.BaseMutationOptions<GenerateProgramCapReportMutation, GenerateProgramCapReportMutationVariables>;
export const BatchCreateProgramCapDocument = gql`
    mutation BatchCreateProgramCap($batchCreateProgramCapInput: BatchCreateProgramCapInput!, $dryRun: Boolean) {
  batchCreateProgramCap(
    batchCreateProgramCapInput: $batchCreateProgramCapInput
    dryRun: $dryRun
  ) {
    clientId
    startDate
    endDate
    success
    error
    programCap {
      id
      clientId
      cap
      startDate
      endDate
      lastModifiedBy
    }
  }
}
    `;
export type BatchCreateProgramCapMutationFn = Apollo.MutationFunction<BatchCreateProgramCapMutation, BatchCreateProgramCapMutationVariables>;

/**
 * __useBatchCreateProgramCapMutation__
 *
 * To run a mutation, you first call `useBatchCreateProgramCapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateProgramCapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateProgramCapMutation, { data, loading, error }] = useBatchCreateProgramCapMutation({
 *   variables: {
 *      batchCreateProgramCapInput: // value for 'batchCreateProgramCapInput'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useBatchCreateProgramCapMutation(baseOptions?: Apollo.MutationHookOptions<BatchCreateProgramCapMutation, BatchCreateProgramCapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCreateProgramCapMutation, BatchCreateProgramCapMutationVariables>(BatchCreateProgramCapDocument, options);
      }
export type BatchCreateProgramCapMutationHookResult = ReturnType<typeof useBatchCreateProgramCapMutation>;
export type BatchCreateProgramCapMutationResult = Apollo.MutationResult<BatchCreateProgramCapMutation>;
export type BatchCreateProgramCapMutationOptions = Apollo.BaseMutationOptions<BatchCreateProgramCapMutation, BatchCreateProgramCapMutationVariables>;
export const CreateRevenueShareDocument = gql`
    mutation createRevenueShare($revenueShareInput: CreateRevenueShareInput!) {
  createRevenueShare(revenueShareInput: $revenueShareInput) {
    revenueShareDetailId
    revenueShareDefinitionId
    clientId
    partnershipId
    scopes {
      scopeableType
      scopeableId
    }
    name
    tier
    discount
    subscriptionTier
    applyToPrice
    effectiveYear
  }
}
    `;
export type CreateRevenueShareMutationFn = Apollo.MutationFunction<CreateRevenueShareMutation, CreateRevenueShareMutationVariables>;

/**
 * __useCreateRevenueShareMutation__
 *
 * To run a mutation, you first call `useCreateRevenueShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRevenueShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRevenueShareMutation, { data, loading, error }] = useCreateRevenueShareMutation({
 *   variables: {
 *      revenueShareInput: // value for 'revenueShareInput'
 *   },
 * });
 */
export function useCreateRevenueShareMutation(baseOptions?: Apollo.MutationHookOptions<CreateRevenueShareMutation, CreateRevenueShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRevenueShareMutation, CreateRevenueShareMutationVariables>(CreateRevenueShareDocument, options);
      }
export type CreateRevenueShareMutationHookResult = ReturnType<typeof useCreateRevenueShareMutation>;
export type CreateRevenueShareMutationResult = Apollo.MutationResult<CreateRevenueShareMutation>;
export type CreateRevenueShareMutationOptions = Apollo.BaseMutationOptions<CreateRevenueShareMutation, CreateRevenueShareMutationVariables>;
export const UpdateRevenueShareDocument = gql`
    mutation updateRevenueShare($revenueShareInput: UpdateRevenueShareInput!) {
  updateRevenueShare(revenueShareInput: $revenueShareInput) {
    revenueShareDetailId
    revenueShareDefinitionId
    clientId
    partnershipId
    scopes {
      scopeableType
      scopeableId
    }
    name
    tier
    discount
    subscriptionTier
    applyToPrice
    effectiveYear
  }
}
    `;
export type UpdateRevenueShareMutationFn = Apollo.MutationFunction<UpdateRevenueShareMutation, UpdateRevenueShareMutationVariables>;

/**
 * __useUpdateRevenueShareMutation__
 *
 * To run a mutation, you first call `useUpdateRevenueShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRevenueShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRevenueShareMutation, { data, loading, error }] = useUpdateRevenueShareMutation({
 *   variables: {
 *      revenueShareInput: // value for 'revenueShareInput'
 *   },
 * });
 */
export function useUpdateRevenueShareMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRevenueShareMutation, UpdateRevenueShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRevenueShareMutation, UpdateRevenueShareMutationVariables>(UpdateRevenueShareDocument, options);
      }
export type UpdateRevenueShareMutationHookResult = ReturnType<typeof useUpdateRevenueShareMutation>;
export type UpdateRevenueShareMutationResult = Apollo.MutationResult<UpdateRevenueShareMutation>;
export type UpdateRevenueShareMutationOptions = Apollo.BaseMutationOptions<UpdateRevenueShareMutation, UpdateRevenueShareMutationVariables>;
export const BulkVoidSubscriptionsDocument = gql`
    mutation bulkVoidSubscriptions($bulkVoidSubscriptionsInput: BulkVoidSubscriptionsInput!) {
  bulkVoidSubscriptions(bulkVoidSubscriptionsInput: $bulkVoidSubscriptionsInput)
}
    `;
export type BulkVoidSubscriptionsMutationFn = Apollo.MutationFunction<BulkVoidSubscriptionsMutation, BulkVoidSubscriptionsMutationVariables>;

/**
 * __useBulkVoidSubscriptionsMutation__
 *
 * To run a mutation, you first call `useBulkVoidSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkVoidSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkVoidSubscriptionsMutation, { data, loading, error }] = useBulkVoidSubscriptionsMutation({
 *   variables: {
 *      bulkVoidSubscriptionsInput: // value for 'bulkVoidSubscriptionsInput'
 *   },
 * });
 */
export function useBulkVoidSubscriptionsMutation(baseOptions?: Apollo.MutationHookOptions<BulkVoidSubscriptionsMutation, BulkVoidSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkVoidSubscriptionsMutation, BulkVoidSubscriptionsMutationVariables>(BulkVoidSubscriptionsDocument, options);
      }
export type BulkVoidSubscriptionsMutationHookResult = ReturnType<typeof useBulkVoidSubscriptionsMutation>;
export type BulkVoidSubscriptionsMutationResult = Apollo.MutationResult<BulkVoidSubscriptionsMutation>;
export type BulkVoidSubscriptionsMutationOptions = Apollo.BaseMutationOptions<BulkVoidSubscriptionsMutation, BulkVoidSubscriptionsMutationVariables>;
export const GetClaimsManualWebDagRunStatusDocument = gql`
    query getClaimsManualWebDagRunStatus($dagRunId: String!) {
  getClaimsManualWebDagRunStatus(dagRunId: $dagRunId) {
    dagId
    dagRunId
    note
    state
    logicalDate
  }
}
    `;

/**
 * __useGetClaimsManualWebDagRunStatusQuery__
 *
 * To run a query within a React component, call `useGetClaimsManualWebDagRunStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimsManualWebDagRunStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimsManualWebDagRunStatusQuery({
 *   variables: {
 *      dagRunId: // value for 'dagRunId'
 *   },
 * });
 */
export function useGetClaimsManualWebDagRunStatusQuery(baseOptions: Apollo.QueryHookOptions<GetClaimsManualWebDagRunStatusQuery, GetClaimsManualWebDagRunStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClaimsManualWebDagRunStatusQuery, GetClaimsManualWebDagRunStatusQueryVariables>(GetClaimsManualWebDagRunStatusDocument, options);
      }
export function useGetClaimsManualWebDagRunStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClaimsManualWebDagRunStatusQuery, GetClaimsManualWebDagRunStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClaimsManualWebDagRunStatusQuery, GetClaimsManualWebDagRunStatusQueryVariables>(GetClaimsManualWebDagRunStatusDocument, options);
        }
export type GetClaimsManualWebDagRunStatusQueryHookResult = ReturnType<typeof useGetClaimsManualWebDagRunStatusQuery>;
export type GetClaimsManualWebDagRunStatusLazyQueryHookResult = ReturnType<typeof useGetClaimsManualWebDagRunStatusLazyQuery>;
export type GetClaimsManualWebDagRunStatusQueryResult = Apollo.QueryResult<GetClaimsManualWebDagRunStatusQuery, GetClaimsManualWebDagRunStatusQueryVariables>;
export const GetBillingTypesDocument = gql`
    query getBillingTypes {
  getBillingTypes {
    value
  }
}
    `;

/**
 * __useGetBillingTypesQuery__
 *
 * To run a query within a React component, call `useGetBillingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingTypesQuery, GetBillingTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingTypesQuery, GetBillingTypesQueryVariables>(GetBillingTypesDocument, options);
      }
export function useGetBillingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingTypesQuery, GetBillingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingTypesQuery, GetBillingTypesQueryVariables>(GetBillingTypesDocument, options);
        }
export type GetBillingTypesQueryHookResult = ReturnType<typeof useGetBillingTypesQuery>;
export type GetBillingTypesLazyQueryHookResult = ReturnType<typeof useGetBillingTypesLazyQuery>;
export type GetBillingTypesQueryResult = Apollo.QueryResult<GetBillingTypesQuery, GetBillingTypesQueryVariables>;
export const GetBillsDocument = gql`
    query getBills($page: Int, $size: Int, $internalHoldTypes: [String!], $userIds: [Int!], $source: String, $sourceIds: [Int!], $startDate: String, $endDate: String, $contractIds: [Int!], $billStatuses: [BillStatusEnum!], $held: Boolean, $submitted: Boolean, $submissionStatuses: [SubmissionStatusEnum!], $sortBy: [[String!]!], $paymentTypes: [String!], $userUuids: [String!], $billIds: [Int!], $sourceStartDate: String, $sourceEndDate: String) {
  getBills(
    page: $page
    size: $size
    internalHoldTypes: $internalHoldTypes
    userIds: $userIds
    source: $source
    sourceIds: $sourceIds
    startDate: $startDate
    endDate: $endDate
    contractIds: $contractIds
    billStatuses: $billStatuses
    held: $held
    submitted: $submitted
    submissionStatuses: $submissionStatuses
    sortBy: $sortBy
    paymentTypes: $paymentTypes
    userUuids: $userUuids
    billIds: $billIds
    sourceStartDate: $sourceStartDate
    sourceEndDate: $sourceEndDate
  ) {
    items {
      baseCharge
      billId
      claimId
      billAmount
      status
      userId
      userUuid
      source
      sourceId
      dateOfService
      contractId
      paymentType
      netsuiteId
      submissionId
      submissionStatus
      submissionDate
      submissionAmount
      transactionId
      holdDetails {
        holdType
        note
        details
        clientId
        insurerId
        createdAt
        clearedAt
      }
      details
    }
    page
    pages
    total
    size
  }
}
    `;

/**
 * __useGetBillsQuery__
 *
 * To run a query within a React component, call `useGetBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      internalHoldTypes: // value for 'internalHoldTypes'
 *      userIds: // value for 'userIds'
 *      source: // value for 'source'
 *      sourceIds: // value for 'sourceIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      contractIds: // value for 'contractIds'
 *      billStatuses: // value for 'billStatuses'
 *      held: // value for 'held'
 *      submitted: // value for 'submitted'
 *      submissionStatuses: // value for 'submissionStatuses'
 *      sortBy: // value for 'sortBy'
 *      paymentTypes: // value for 'paymentTypes'
 *      userUuids: // value for 'userUuids'
 *      billIds: // value for 'billIds'
 *      sourceStartDate: // value for 'sourceStartDate'
 *      sourceEndDate: // value for 'sourceEndDate'
 *   },
 * });
 */
export function useGetBillsQuery(baseOptions?: Apollo.QueryHookOptions<GetBillsQuery, GetBillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillsQuery, GetBillsQueryVariables>(GetBillsDocument, options);
      }
export function useGetBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillsQuery, GetBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillsQuery, GetBillsQueryVariables>(GetBillsDocument, options);
        }
export type GetBillsQueryHookResult = ReturnType<typeof useGetBillsQuery>;
export type GetBillsLazyQueryHookResult = ReturnType<typeof useGetBillsLazyQuery>;
export type GetBillsQueryResult = Apollo.QueryResult<GetBillsQuery, GetBillsQueryVariables>;
export const GetAllInternalHoldTypesDocument = gql`
    query getAllInternalHoldTypes {
  getAllInternalHoldTypes {
    value
  }
}
    `;

/**
 * __useGetAllInternalHoldTypesQuery__
 *
 * To run a query within a React component, call `useGetAllInternalHoldTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInternalHoldTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInternalHoldTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllInternalHoldTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllInternalHoldTypesQuery, GetAllInternalHoldTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInternalHoldTypesQuery, GetAllInternalHoldTypesQueryVariables>(GetAllInternalHoldTypesDocument, options);
      }
export function useGetAllInternalHoldTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInternalHoldTypesQuery, GetAllInternalHoldTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInternalHoldTypesQuery, GetAllInternalHoldTypesQueryVariables>(GetAllInternalHoldTypesDocument, options);
        }
export type GetAllInternalHoldTypesQueryHookResult = ReturnType<typeof useGetAllInternalHoldTypesQuery>;
export type GetAllInternalHoldTypesLazyQueryHookResult = ReturnType<typeof useGetAllInternalHoldTypesLazyQuery>;
export type GetAllInternalHoldTypesQueryResult = Apollo.QueryResult<GetAllInternalHoldTypesQuery, GetAllInternalHoldTypesQueryVariables>;
export const GetUnbilledDocument = gql`
    query getUnbilled($page: Int, $size: Int, $startDate: String, $endDate: String, $contractIds: [Int!], $paymentTypes: [String!]) {
  getUnbilledBills(
    contractIds: $contractIds
    startDate: $startDate
    endDate: $endDate
    page: $page
    size: $size
    paymentTypes: $paymentTypes
  ) {
    items {
      contractId
      unbilled
      billsCount
    }
    page
    size
    total
    pages
  }
}
    `;

/**
 * __useGetUnbilledQuery__
 *
 * To run a query within a React component, call `useGetUnbilledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnbilledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnbilledQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      contractIds: // value for 'contractIds'
 *      paymentTypes: // value for 'paymentTypes'
 *   },
 * });
 */
export function useGetUnbilledQuery(baseOptions?: Apollo.QueryHookOptions<GetUnbilledQuery, GetUnbilledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnbilledQuery, GetUnbilledQueryVariables>(GetUnbilledDocument, options);
      }
export function useGetUnbilledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnbilledQuery, GetUnbilledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnbilledQuery, GetUnbilledQueryVariables>(GetUnbilledDocument, options);
        }
export type GetUnbilledQueryHookResult = ReturnType<typeof useGetUnbilledQuery>;
export type GetUnbilledLazyQueryHookResult = ReturnType<typeof useGetUnbilledLazyQuery>;
export type GetUnbilledQueryResult = Apollo.QueryResult<GetUnbilledQuery, GetUnbilledQueryVariables>;
export const GetBillDetailsByIdDocument = gql`
    query getBillDetailsById($billId: Int!) {
  getBillById(billId: $billId) {
    __typename
    baseCharge
    billAmount
    claimIdentifier
    contractId
    coverageId
    createdAt
    engagementEvent {
      id
      eventId
      eventUuid
      eventType
      occurredAt
      userUuid
      pathwayUuid
      programId
      programIndication
      sourceType
      billableCount
      details
      queuedAt
      createdAt
    }
    eventUuid
    fromDate
    id
    internalHolds {
      billId
      createdAt
      clearedAt
      holdType
      note
      details
    }
    pathwayId
    paymentType
    source
    sourceId
    status
    submissions {
      id
      billId
      transactionId
      status
      submissionAmount
      submissionDate
      createdAt
      remits {
        id
        patientPaymentAmount
        paymentAmount
        payer
        sourceOfRecord
        paymentDate
        icn
        responseDate
        createdAt
      }
      corrections {
        correctionAmount
        createdAt
        correctionsType
        netsuiteId
        lastModifiedBy
      }
    }
    subscriptionPackageId
    toDate
    updatedAt
    details
  }
}
    `;

/**
 * __useGetBillDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetBillDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillDetailsByIdQuery({
 *   variables: {
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function useGetBillDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBillDetailsByIdQuery, GetBillDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillDetailsByIdQuery, GetBillDetailsByIdQueryVariables>(GetBillDetailsByIdDocument, options);
      }
export function useGetBillDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillDetailsByIdQuery, GetBillDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillDetailsByIdQuery, GetBillDetailsByIdQueryVariables>(GetBillDetailsByIdDocument, options);
        }
export type GetBillDetailsByIdQueryHookResult = ReturnType<typeof useGetBillDetailsByIdQuery>;
export type GetBillDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetBillDetailsByIdLazyQuery>;
export type GetBillDetailsByIdQueryResult = Apollo.QueryResult<GetBillDetailsByIdQuery, GetBillDetailsByIdQueryVariables>;
export const GetFileDetailsDocument = gql`
    query getFileDetails {
  getFileDetails {
    schemas
  }
}
    `;

/**
 * __useGetFileDetailsQuery__
 *
 * To run a query within a React component, call `useGetFileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFileDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetFileDetailsQuery, GetFileDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileDetailsQuery, GetFileDetailsQueryVariables>(GetFileDetailsDocument, options);
      }
export function useGetFileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileDetailsQuery, GetFileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileDetailsQuery, GetFileDetailsQueryVariables>(GetFileDetailsDocument, options);
        }
export type GetFileDetailsQueryHookResult = ReturnType<typeof useGetFileDetailsQuery>;
export type GetFileDetailsLazyQueryHookResult = ReturnType<typeof useGetFileDetailsLazyQuery>;
export type GetFileDetailsQueryResult = Apollo.QueryResult<GetFileDetailsQuery, GetFileDetailsQueryVariables>;
export const GetFileUploadStatusDocument = gql`
    query getFileUploadStatus($taskId: String!) {
  getFileUploadStatus(taskId: $taskId) {
    status
  }
}
    `;

/**
 * __useGetFileUploadStatusQuery__
 *
 * To run a query within a React component, call `useGetFileUploadStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileUploadStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileUploadStatusQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetFileUploadStatusQuery(baseOptions: Apollo.QueryHookOptions<GetFileUploadStatusQuery, GetFileUploadStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileUploadStatusQuery, GetFileUploadStatusQueryVariables>(GetFileUploadStatusDocument, options);
      }
export function useGetFileUploadStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileUploadStatusQuery, GetFileUploadStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileUploadStatusQuery, GetFileUploadStatusQueryVariables>(GetFileUploadStatusDocument, options);
        }
export type GetFileUploadStatusQueryHookResult = ReturnType<typeof useGetFileUploadStatusQuery>;
export type GetFileUploadStatusLazyQueryHookResult = ReturnType<typeof useGetFileUploadStatusLazyQuery>;
export type GetFileUploadStatusQueryResult = Apollo.QueryResult<GetFileUploadStatusQuery, GetFileUploadStatusQueryVariables>;
export const GetAggregateHoldsV2Document = gql`
    query getAggregateHoldsV2($contractIds: [Int!], $holdTypes: [String!], $fromDate: String, $toDate: String, $minHeldAmount: Float, $page: Int, $size: Int) {
  aggregateHoldsV2(
    contractIds: $contractIds
    holdTypes: $holdTypes
    fromDate: $fromDate
    toDate: $toDate
    minHeldAmount: $minHeldAmount
    page: $page
    size: $size
  ) {
    items {
      contractId
      holds
      minFromDate
      maxFromDate
      maxLastSeenAt
      holdsCount
      heldAmount
    }
    total
    page
    size
    pages
  }
}
    `;

/**
 * __useGetAggregateHoldsV2Query__
 *
 * To run a query within a React component, call `useGetAggregateHoldsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregateHoldsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregateHoldsV2Query({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *      holdTypes: // value for 'holdTypes'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      minHeldAmount: // value for 'minHeldAmount'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetAggregateHoldsV2Query(baseOptions?: Apollo.QueryHookOptions<GetAggregateHoldsV2Query, GetAggregateHoldsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregateHoldsV2Query, GetAggregateHoldsV2QueryVariables>(GetAggregateHoldsV2Document, options);
      }
export function useGetAggregateHoldsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregateHoldsV2Query, GetAggregateHoldsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregateHoldsV2Query, GetAggregateHoldsV2QueryVariables>(GetAggregateHoldsV2Document, options);
        }
export type GetAggregateHoldsV2QueryHookResult = ReturnType<typeof useGetAggregateHoldsV2Query>;
export type GetAggregateHoldsV2LazyQueryHookResult = ReturnType<typeof useGetAggregateHoldsV2LazyQuery>;
export type GetAggregateHoldsV2QueryResult = Apollo.QueryResult<GetAggregateHoldsV2Query, GetAggregateHoldsV2QueryVariables>;
export const GetTaskDocument = gql`
    query getTask($taskId: String!) {
  getTask(taskId: $taskId) {
    status
    name
    result
  }
}
    `;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions: Apollo.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskQueryResult = Apollo.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const GetContractTermSummaryDocument = gql`
    query getContractTermSummary($contractId: Int!, $startDate: String!, $endDate: String!) {
  getContractTermSummary(
    contractId: $contractId
    startDate: $startDate
    endDate: $endDate
  ) {
    numSubscriptions
    numSubmissions
    numFeeForServiceEvents
    numAdminFeeClaims
    sumSubmissionAmount
  }
}
    `;

/**
 * __useGetContractTermSummaryQuery__
 *
 * To run a query within a React component, call `useGetContractTermSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTermSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTermSummaryQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetContractTermSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetContractTermSummaryQuery, GetContractTermSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractTermSummaryQuery, GetContractTermSummaryQueryVariables>(GetContractTermSummaryDocument, options);
      }
export function useGetContractTermSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractTermSummaryQuery, GetContractTermSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractTermSummaryQuery, GetContractTermSummaryQueryVariables>(GetContractTermSummaryDocument, options);
        }
export type GetContractTermSummaryQueryHookResult = ReturnType<typeof useGetContractTermSummaryQuery>;
export type GetContractTermSummaryLazyQueryHookResult = ReturnType<typeof useGetContractTermSummaryLazyQuery>;
export type GetContractTermSummaryQueryResult = Apollo.QueryResult<GetContractTermSummaryQuery, GetContractTermSummaryQueryVariables>;
export const GetSubmissionsDocument = gql`
    query getSubmissions($page: Int, $size: Int, $submissionIds: [Int!], $billIds: [Int!], $userIds: [Int!], $transactionIds: [String!], $netsuiteIds: [String!], $creditMemoIds: [String!], $submissionStatuses: [SubmissionStatusEnum!], $submissionStartDate: String, $submissionEndDate: String, $contractIds: [Int!], $source: String, $sourceIds: [Int!], $sourceStartDate: String, $sourceEndDate: String) {
  getSubmissions(
    page: $page
    size: $size
    submissionIds: $submissionIds
    billIds: $billIds
    userIds: $userIds
    transactionIds: $transactionIds
    netsuiteIds: $netsuiteIds
    creditMemoIds: $creditMemoIds
    submissionStatuses: $submissionStatuses
    submissionStartDate: $submissionStartDate
    submissionEndDate: $submissionEndDate
    contractIds: $contractIds
    source: $source
    sourceIds: $sourceIds
    sourceStartDate: $sourceStartDate
    sourceEndDate: $sourceEndDate
  ) {
    items {
      baseCharge
      submissionId
      billId
      userId
      userUuid
      transactionId
      netsuiteId
      submissionStatus
      submissionAmount
      submissionDate
      clientPrice
      coverageId
      source
      sourceId
      dateOfService
      contractId
      paymentType
      billAmount
      details
    }
    page
    size
    total
    pages
  }
}
    `;

/**
 * __useGetSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      submissionIds: // value for 'submissionIds'
 *      billIds: // value for 'billIds'
 *      userIds: // value for 'userIds'
 *      transactionIds: // value for 'transactionIds'
 *      netsuiteIds: // value for 'netsuiteIds'
 *      creditMemoIds: // value for 'creditMemoIds'
 *      submissionStatuses: // value for 'submissionStatuses'
 *      submissionStartDate: // value for 'submissionStartDate'
 *      submissionEndDate: // value for 'submissionEndDate'
 *      contractIds: // value for 'contractIds'
 *      source: // value for 'source'
 *      sourceIds: // value for 'sourceIds'
 *      sourceStartDate: // value for 'sourceStartDate'
 *      sourceEndDate: // value for 'sourceEndDate'
 *   },
 * });
 */
export function useGetSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubmissionsQuery, GetSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionsQuery, GetSubmissionsQueryVariables>(GetSubmissionsDocument, options);
      }
export function useGetSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionsQuery, GetSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionsQuery, GetSubmissionsQueryVariables>(GetSubmissionsDocument, options);
        }
export type GetSubmissionsQueryHookResult = ReturnType<typeof useGetSubmissionsQuery>;
export type GetSubmissionsLazyQueryHookResult = ReturnType<typeof useGetSubmissionsLazyQuery>;
export type GetSubmissionsQueryResult = Apollo.QueryResult<GetSubmissionsQuery, GetSubmissionsQueryVariables>;
export const GetTemporalWorkflowDocument = gql`
    query getTemporalWorkflow($workflowId: String!) {
  getTemporalWorkflow(workflowId: $workflowId) {
    status
    workflowId
    workflowType
    failureMessage
    result
  }
}
    `;

/**
 * __useGetTemporalWorkflowQuery__
 *
 * To run a query within a React component, call `useGetTemporalWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemporalWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemporalWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetTemporalWorkflowQuery(baseOptions: Apollo.QueryHookOptions<GetTemporalWorkflowQuery, GetTemporalWorkflowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemporalWorkflowQuery, GetTemporalWorkflowQueryVariables>(GetTemporalWorkflowDocument, options);
      }
export function useGetTemporalWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemporalWorkflowQuery, GetTemporalWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemporalWorkflowQuery, GetTemporalWorkflowQueryVariables>(GetTemporalWorkflowDocument, options);
        }
export type GetTemporalWorkflowQueryHookResult = ReturnType<typeof useGetTemporalWorkflowQuery>;
export type GetTemporalWorkflowLazyQueryHookResult = ReturnType<typeof useGetTemporalWorkflowLazyQuery>;
export type GetTemporalWorkflowQueryResult = Apollo.QueryResult<GetTemporalWorkflowQuery, GetTemporalWorkflowQueryVariables>;
export const GetClientInsurerByIdDocument = gql`
    query getClientInsurerById($id: Int!) {
  getClientInsurerById(id: $id) {
    billingType
    client {
      id
      identifier
      name
    }
    coreContractRule
    id
    insurer {
      eligibilityRef
      id
      identifier
      name
    }
    isActive
    termDate
    partnerships {
      allowCohortExpansion
      id
      name
      partnershipType
      requiresStateCredentials
    }
  }
}
    `;

/**
 * __useGetClientInsurerByIdQuery__
 *
 * To run a query within a React component, call `useGetClientInsurerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientInsurerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientInsurerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientInsurerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetClientInsurerByIdQuery, GetClientInsurerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientInsurerByIdQuery, GetClientInsurerByIdQueryVariables>(GetClientInsurerByIdDocument, options);
      }
export function useGetClientInsurerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientInsurerByIdQuery, GetClientInsurerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientInsurerByIdQuery, GetClientInsurerByIdQueryVariables>(GetClientInsurerByIdDocument, options);
        }
export type GetClientInsurerByIdQueryHookResult = ReturnType<typeof useGetClientInsurerByIdQuery>;
export type GetClientInsurerByIdLazyQueryHookResult = ReturnType<typeof useGetClientInsurerByIdLazyQuery>;
export type GetClientInsurerByIdQueryResult = Apollo.QueryResult<GetClientInsurerByIdQuery, GetClientInsurerByIdQueryVariables>;
export const GetClientInsurersByIdsDocument = gql`
    query getClientInsurersByIds($billingType: String, $billingTypes: [String!], $clientIdentifier: String, $clientIds: [Int!], $ids: [Int!], $insurerIds: [Int!], $scope: ScopeType, $partnershipIds: [Int!]) {
  getClientInsurersByIds(
    ids: $ids
    clientIds: $clientIds
    billingType: $billingType
    billingTypes: $billingTypes
    clientIdentifier: $clientIdentifier
    insurerIds: $insurerIds
    scope: $scope
    partnershipIds: $partnershipIds
  ) {
    id
    billingType
    isActive
    termDate
    coreContractRule
    effectiveDate
    insurer {
      id
      identifier
      name
      eligibilityRef
    }
    client {
      id
      identifier
      name
    }
    partnerships {
      id
      name
      partnershipType
      allowCohortExpansion
      requiresStateCredentials
    }
  }
}
    `;

/**
 * __useGetClientInsurersByIdsQuery__
 *
 * To run a query within a React component, call `useGetClientInsurersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientInsurersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientInsurersByIdsQuery({
 *   variables: {
 *      billingType: // value for 'billingType'
 *      billingTypes: // value for 'billingTypes'
 *      clientIdentifier: // value for 'clientIdentifier'
 *      clientIds: // value for 'clientIds'
 *      ids: // value for 'ids'
 *      insurerIds: // value for 'insurerIds'
 *      scope: // value for 'scope'
 *      partnershipIds: // value for 'partnershipIds'
 *   },
 * });
 */
export function useGetClientInsurersByIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientInsurersByIdsQuery, GetClientInsurersByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientInsurersByIdsQuery, GetClientInsurersByIdsQueryVariables>(GetClientInsurersByIdsDocument, options);
      }
export function useGetClientInsurersByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientInsurersByIdsQuery, GetClientInsurersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientInsurersByIdsQuery, GetClientInsurersByIdsQueryVariables>(GetClientInsurersByIdsDocument, options);
        }
export type GetClientInsurersByIdsQueryHookResult = ReturnType<typeof useGetClientInsurersByIdsQuery>;
export type GetClientInsurersByIdsLazyQueryHookResult = ReturnType<typeof useGetClientInsurersByIdsLazyQuery>;
export type GetClientInsurersByIdsQueryResult = Apollo.QueryResult<GetClientInsurersByIdsQuery, GetClientInsurersByIdsQueryVariables>;
export const GetClientInsurersByClientDocument = gql`
    query getClientInsurersByClient($id: String!) {
  getClientInsurersByClient(id: $id) {
    id
    identifier
    name
    clientsInsurers {
      id
      billingType
      client {
        id
        identifier
        name
      }
      insurer {
        eligibilityRef
        id
        identifier
        name
      }
      isActive
      partnerships {
        allowCohortExpansion
        id
        name
        partnershipType
        requiresStateCredentials
      }
      termDate
    }
  }
}
    `;

/**
 * __useGetClientInsurersByClientQuery__
 *
 * To run a query within a React component, call `useGetClientInsurersByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientInsurersByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientInsurersByClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientInsurersByClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientInsurersByClientQuery, GetClientInsurersByClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientInsurersByClientQuery, GetClientInsurersByClientQueryVariables>(GetClientInsurersByClientDocument, options);
      }
export function useGetClientInsurersByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientInsurersByClientQuery, GetClientInsurersByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientInsurersByClientQuery, GetClientInsurersByClientQueryVariables>(GetClientInsurersByClientDocument, options);
        }
export type GetClientInsurersByClientQueryHookResult = ReturnType<typeof useGetClientInsurersByClientQuery>;
export type GetClientInsurersByClientLazyQueryHookResult = ReturnType<typeof useGetClientInsurersByClientLazyQuery>;
export type GetClientInsurersByClientQueryResult = Apollo.QueryResult<GetClientInsurersByClientQuery, GetClientInsurersByClientQueryVariables>;
export const GetAllClientsDocument = gql`
    query getAllClients {
  getAllClients {
    id
    identifier
    name
  }
}
    `;

/**
 * __useGetAllClientsQuery__
 *
 * To run a query within a React component, call `useGetAllClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
      }
export function useGetAllClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
        }
export type GetAllClientsQueryHookResult = ReturnType<typeof useGetAllClientsQuery>;
export type GetAllClientsLazyQueryHookResult = ReturnType<typeof useGetAllClientsLazyQuery>;
export type GetAllClientsQueryResult = Apollo.QueryResult<GetAllClientsQuery, GetAllClientsQueryVariables>;
export const GetAllEngagementTypesDocument = gql`
    query getAllEngagementTypes {
  getAllEngagementTypes {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAllEngagementTypesQuery__
 *
 * To run a query within a React component, call `useGetAllEngagementTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEngagementTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEngagementTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEngagementTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEngagementTypesQuery, GetAllEngagementTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEngagementTypesQuery, GetAllEngagementTypesQueryVariables>(GetAllEngagementTypesDocument, options);
      }
export function useGetAllEngagementTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEngagementTypesQuery, GetAllEngagementTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEngagementTypesQuery, GetAllEngagementTypesQueryVariables>(GetAllEngagementTypesDocument, options);
        }
export type GetAllEngagementTypesQueryHookResult = ReturnType<typeof useGetAllEngagementTypesQuery>;
export type GetAllEngagementTypesLazyQueryHookResult = ReturnType<typeof useGetAllEngagementTypesLazyQuery>;
export type GetAllEngagementTypesQueryResult = Apollo.QueryResult<GetAllEngagementTypesQuery, GetAllEngagementTypesQueryVariables>;
export const GetAllPackagesDocument = gql`
    query getAllPackages {
  getAllPackages {
    id
    name
    isEditable
    createdAt
    updatedAt
    lastModifiedBy
    packageOfferings {
      id
      programIndication
      packageId
      packageOffering
      productId
      createdAt
      updatedAt
      lastModifiedBy
    }
  }
}
    `;

/**
 * __useGetAllPackagesQuery__
 *
 * To run a query within a React component, call `useGetAllPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPackagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPackagesQuery, GetAllPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPackagesQuery, GetAllPackagesQueryVariables>(GetAllPackagesDocument, options);
      }
export function useGetAllPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPackagesQuery, GetAllPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPackagesQuery, GetAllPackagesQueryVariables>(GetAllPackagesDocument, options);
        }
export type GetAllPackagesQueryHookResult = ReturnType<typeof useGetAllPackagesQuery>;
export type GetAllPackagesLazyQueryHookResult = ReturnType<typeof useGetAllPackagesLazyQuery>;
export type GetAllPackagesQueryResult = Apollo.QueryResult<GetAllPackagesQuery, GetAllPackagesQueryVariables>;
export const GetAllProductsDocument = gql`
    query getAllProducts {
  getAllProducts {
    id
    name
  }
}
    `;

/**
 * __useGetAllProductsQuery__
 *
 * To run a query within a React component, call `useGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
      }
export function useGetAllProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
export type GetAllProductsQueryHookResult = ReturnType<typeof useGetAllProductsQuery>;
export type GetAllProductsLazyQueryHookResult = ReturnType<typeof useGetAllProductsLazyQuery>;
export type GetAllProductsQueryResult = Apollo.QueryResult<GetAllProductsQuery, GetAllProductsQueryVariables>;
export const GetBillingModelsDocument = gql`
    query getBillingModels {
  getBillingModels {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetBillingModelsQuery__
 *
 * To run a query within a React component, call `useGetBillingModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingModelsQuery, GetBillingModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingModelsQuery, GetBillingModelsQueryVariables>(GetBillingModelsDocument, options);
      }
export function useGetBillingModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingModelsQuery, GetBillingModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingModelsQuery, GetBillingModelsQueryVariables>(GetBillingModelsDocument, options);
        }
export type GetBillingModelsQueryHookResult = ReturnType<typeof useGetBillingModelsQuery>;
export type GetBillingModelsLazyQueryHookResult = ReturnType<typeof useGetBillingModelsLazyQuery>;
export type GetBillingModelsQueryResult = Apollo.QueryResult<GetBillingModelsQuery, GetBillingModelsQueryVariables>;
export const GetCurrencyCodesDocument = gql`
    query getCurrencyCodes {
  getCurrencyCodes {
    value
  }
}
    `;

/**
 * __useGetCurrencyCodesQuery__
 *
 * To run a query within a React component, call `useGetCurrencyCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrencyCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>(GetCurrencyCodesDocument, options);
      }
export function useGetCurrencyCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>(GetCurrencyCodesDocument, options);
        }
export type GetCurrencyCodesQueryHookResult = ReturnType<typeof useGetCurrencyCodesQuery>;
export type GetCurrencyCodesLazyQueryHookResult = ReturnType<typeof useGetCurrencyCodesLazyQuery>;
export type GetCurrencyCodesQueryResult = Apollo.QueryResult<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>;
export const GetCostShareSetupOptionsDocument = gql`
    query getCostShareSetupOptions {
  getCostShareSetupOptions {
    deductionTiming
    cadence
  }
}
    `;

/**
 * __useGetCostShareSetupOptionsQuery__
 *
 * To run a query within a React component, call `useGetCostShareSetupOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCostShareSetupOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCostShareSetupOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCostShareSetupOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCostShareSetupOptionsQuery, GetCostShareSetupOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCostShareSetupOptionsQuery, GetCostShareSetupOptionsQueryVariables>(GetCostShareSetupOptionsDocument, options);
      }
export function useGetCostShareSetupOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCostShareSetupOptionsQuery, GetCostShareSetupOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCostShareSetupOptionsQuery, GetCostShareSetupOptionsQueryVariables>(GetCostShareSetupOptionsDocument, options);
        }
export type GetCostShareSetupOptionsQueryHookResult = ReturnType<typeof useGetCostShareSetupOptionsQuery>;
export type GetCostShareSetupOptionsLazyQueryHookResult = ReturnType<typeof useGetCostShareSetupOptionsLazyQuery>;
export type GetCostShareSetupOptionsQueryResult = Apollo.QueryResult<GetCostShareSetupOptionsQuery, GetCostShareSetupOptionsQueryVariables>;
export const GetContractTemplatesDocument = gql`
    query getContractTemplates {
  getContractTemplates {
    id
    isActive
    name
    partnershipId
    contract {
      ... on EngagementContractType {
        educationalTypes
        activityTypes
        matchType
        engagementRules
      }
      ... on MilestonesType {
        name
        payment
        dateOfServiceOffset
        billableActivityTypes
        dayRange
        conditions {
          function
          threshold
        }
      }
      ... on IndividualMilestonesType {
        name
        payment
        billableActivityTypes
        conditions {
          function
          threshold
        }
      }
    }
    createdAt
    updatedAt
    contractType
  }
}
    `;

/**
 * __useGetContractTemplatesQuery__
 *
 * To run a query within a React component, call `useGetContractTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetContractTemplatesQuery, GetContractTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractTemplatesQuery, GetContractTemplatesQueryVariables>(GetContractTemplatesDocument, options);
      }
export function useGetContractTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractTemplatesQuery, GetContractTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractTemplatesQuery, GetContractTemplatesQueryVariables>(GetContractTemplatesDocument, options);
        }
export type GetContractTemplatesQueryHookResult = ReturnType<typeof useGetContractTemplatesQuery>;
export type GetContractTemplatesLazyQueryHookResult = ReturnType<typeof useGetContractTemplatesLazyQuery>;
export type GetContractTemplatesQueryResult = Apollo.QueryResult<GetContractTemplatesQuery, GetContractTemplatesQueryVariables>;
export const GetContractsV2Document = gql`
    query getContractsV2($contractIds: [Int!], $clientsInsurerIds: [Int!], $clientIds: [Int!], $insurerIds: [Int!], $startDate: String, $endDate: String, $includeVoided: Boolean, $contractType: String, $packageEnabled: Boolean, $billingTypes: [String!], $partnershipIds: [Int!], $requireBillingTypeOverrideMatch: Boolean, $page: Int, $size: Int) {
  getContractsV2(
    contractIds: $contractIds
    clientsInsurerIds: $clientsInsurerIds
    clientIds: $clientIds
    insurerIds: $insurerIds
    startDate: $startDate
    endDate: $endDate
    includeVoided: $includeVoided
    partnershipIds: $partnershipIds
    contractType: $contractType
    packageEnabled: $packageEnabled
    billingTypes: $billingTypes
    requireBillingTypeOverrideMatch: $requireBillingTypeOverrideMatch
    page: $page
    size: $size
  ) {
    total
    page
    size
    items {
      id
      clientId
      insurerId
      contractTemplateId
      userAnnualCap
      currency
      clientsInsurerId
      chronicPrice
      acutePrice
      startDate
      endDate
      void
      contractType
      packageEnabled
      partnershipId
      lastModifiedBy
      billingType
      globalDailyEngagementCap
      contract {
        ... on EngagementContractType {
          educationalTypes
          activityTypes
          matchType
          engagementRules
        }
        ... on MilestonesType {
          name
          payment
          dateOfServiceOffset
          billableActivityTypes
          dayRange
          conditions {
            function
            threshold
          }
        }
        ... on IndividualMilestonesType {
          name
          payment
          billableActivityTypes
          conditions {
            function
            threshold
          }
        }
      }
      billableActivityTypes {
        id
        name
        createdAt
        updatedAt
        details
        engagementTypeId
      }
      createdAt
      updatedAt
      contractPackages {
        id
        packageId
        billingModelId
        contractTemplateId
        price
        startDate
        billingEnabled
        createdAt
        updatedAt
        lastModifiedBy
        billingTypeOverride
        billableActivityTypes {
          id
          name
          createdAt
          updatedAt
          details
          engagementTypeId
        }
        rules
        void
        contractId
        package {
          id
          name
          createdAt
          updatedAt
          lastModifiedBy
          packageOfferings {
            id
            packageId
            packageOffering
            productId
            programIndication
            createdAt
            updatedAt
            lastModifiedBy
          }
        }
        billingModel {
          id
          name
          createdAt
          updatedAt
        }
        billableActivityTypes {
          id
          name
          createdAt
          updatedAt
          details
          engagementTypeId
        }
        costShareOptions {
          id
          contractPackageId
          deductionTiming
          cadence
          updatedAt
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetContractsV2Query__
 *
 * To run a query within a React component, call `useGetContractsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsV2Query({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *      clientsInsurerIds: // value for 'clientsInsurerIds'
 *      clientIds: // value for 'clientIds'
 *      insurerIds: // value for 'insurerIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      includeVoided: // value for 'includeVoided'
 *      contractType: // value for 'contractType'
 *      packageEnabled: // value for 'packageEnabled'
 *      billingTypes: // value for 'billingTypes'
 *      partnershipIds: // value for 'partnershipIds'
 *      requireBillingTypeOverrideMatch: // value for 'requireBillingTypeOverrideMatch'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetContractsV2Query(baseOptions?: Apollo.QueryHookOptions<GetContractsV2Query, GetContractsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractsV2Query, GetContractsV2QueryVariables>(GetContractsV2Document, options);
      }
export function useGetContractsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractsV2Query, GetContractsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractsV2Query, GetContractsV2QueryVariables>(GetContractsV2Document, options);
        }
export type GetContractsV2QueryHookResult = ReturnType<typeof useGetContractsV2Query>;
export type GetContractsV2LazyQueryHookResult = ReturnType<typeof useGetContractsV2LazyQuery>;
export type GetContractsV2QueryResult = Apollo.QueryResult<GetContractsV2Query, GetContractsV2QueryVariables>;
export const GetValidContractsForHoldReleaseDocument = gql`
    query getValidContractsForHoldRelease($clientsInsurerId: Int!, $minDateOfService: String!, $maxDateOfService: String!) {
  getValidContractsForHoldRelease(
    clientsInsurerId: $clientsInsurerId
    minDateOfService: $minDateOfService
    maxDateOfService: $maxDateOfService
  ) {
    id
    clientsInsurerId
    partnershipId
    billingType
    startDate
    endDate
    void
  }
}
    `;

/**
 * __useGetValidContractsForHoldReleaseQuery__
 *
 * To run a query within a React component, call `useGetValidContractsForHoldReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidContractsForHoldReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidContractsForHoldReleaseQuery({
 *   variables: {
 *      clientsInsurerId: // value for 'clientsInsurerId'
 *      minDateOfService: // value for 'minDateOfService'
 *      maxDateOfService: // value for 'maxDateOfService'
 *   },
 * });
 */
export function useGetValidContractsForHoldReleaseQuery(baseOptions: Apollo.QueryHookOptions<GetValidContractsForHoldReleaseQuery, GetValidContractsForHoldReleaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidContractsForHoldReleaseQuery, GetValidContractsForHoldReleaseQueryVariables>(GetValidContractsForHoldReleaseDocument, options);
      }
export function useGetValidContractsForHoldReleaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidContractsForHoldReleaseQuery, GetValidContractsForHoldReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidContractsForHoldReleaseQuery, GetValidContractsForHoldReleaseQueryVariables>(GetValidContractsForHoldReleaseDocument, options);
        }
export type GetValidContractsForHoldReleaseQueryHookResult = ReturnType<typeof useGetValidContractsForHoldReleaseQuery>;
export type GetValidContractsForHoldReleaseLazyQueryHookResult = ReturnType<typeof useGetValidContractsForHoldReleaseLazyQuery>;
export type GetValidContractsForHoldReleaseQueryResult = Apollo.QueryResult<GetValidContractsForHoldReleaseQuery, GetValidContractsForHoldReleaseQueryVariables>;
export const GetContractIdsDocument = gql`
    query getContractIds($clientsInsurerIds: [Int!], $clientIds: [Int!], $insurerIds: [Int!], $startDate: String, $endDate: String, $includeVoided: Boolean, $billingTypes: [String!], $partnershipIds: [Int!]) {
  getContractIds(
    clientsInsurerIds: $clientsInsurerIds
    clientIds: $clientIds
    insurerIds: $insurerIds
    startDate: $startDate
    endDate: $endDate
    includeVoided: $includeVoided
    partnershipIds: $partnershipIds
    billingTypes: $billingTypes
  )
}
    `;

/**
 * __useGetContractIdsQuery__
 *
 * To run a query within a React component, call `useGetContractIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractIdsQuery({
 *   variables: {
 *      clientsInsurerIds: // value for 'clientsInsurerIds'
 *      clientIds: // value for 'clientIds'
 *      insurerIds: // value for 'insurerIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      includeVoided: // value for 'includeVoided'
 *      billingTypes: // value for 'billingTypes'
 *      partnershipIds: // value for 'partnershipIds'
 *   },
 * });
 */
export function useGetContractIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractIdsQuery, GetContractIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractIdsQuery, GetContractIdsQueryVariables>(GetContractIdsDocument, options);
      }
export function useGetContractIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractIdsQuery, GetContractIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractIdsQuery, GetContractIdsQueryVariables>(GetContractIdsDocument, options);
        }
export type GetContractIdsQueryHookResult = ReturnType<typeof useGetContractIdsQuery>;
export type GetContractIdsLazyQueryHookResult = ReturnType<typeof useGetContractIdsLazyQuery>;
export type GetContractIdsQueryResult = Apollo.QueryResult<GetContractIdsQuery, GetContractIdsQueryVariables>;
export const GetCvsFeeSchedulesDocument = gql`
    query getCvsFeeSchedules {
  getCvsFeeSchedules {
    id
    paymentType
    price
    upc
    charge
    daysSupply
    description
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;

/**
 * __useGetCvsFeeSchedulesQuery__
 *
 * To run a query within a React component, call `useGetCvsFeeSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCvsFeeSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCvsFeeSchedulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCvsFeeSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<GetCvsFeeSchedulesQuery, GetCvsFeeSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCvsFeeSchedulesQuery, GetCvsFeeSchedulesQueryVariables>(GetCvsFeeSchedulesDocument, options);
      }
export function useGetCvsFeeSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCvsFeeSchedulesQuery, GetCvsFeeSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCvsFeeSchedulesQuery, GetCvsFeeSchedulesQueryVariables>(GetCvsFeeSchedulesDocument, options);
        }
export type GetCvsFeeSchedulesQueryHookResult = ReturnType<typeof useGetCvsFeeSchedulesQuery>;
export type GetCvsFeeSchedulesLazyQueryHookResult = ReturnType<typeof useGetCvsFeeSchedulesLazyQuery>;
export type GetCvsFeeSchedulesQueryResult = Apollo.QueryResult<GetCvsFeeSchedulesQuery, GetCvsFeeSchedulesQueryVariables>;
export const GetDiscountsPaginatedDocument = gql`
    query getDiscountsPaginated($clientId: Int, $discountDetailId: Int, $discountType: String, $inquiryDate: String, $partnershipId: Int, $partnershipIds: [Int!], $scopeType: ScopeType, $page: Int, $size: Int) {
  getDiscountsPaginated(
    clientId: $clientId
    discountDetailId: $discountDetailId
    discountType: $discountType
    inquiryDate: $inquiryDate
    partnershipId: $partnershipId
    partnershipIds: $partnershipIds
    scopeType: $scopeType
    page: $page
    size: $size
  ) {
    total
    page
    size
    items {
      id
      clientId
      insurerId
      partnershipId
      scopes {
        scopeableType
        scopeableId
      }
      discountType
      suppressEmptyCharges
      startDate
      endDate
      discountDetails {
        id
        name
        tier
        milestoneDiscount
        discount
        subscriptionTier
      }
    }
  }
}
    `;

/**
 * __useGetDiscountsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetDiscountsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountsPaginatedQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      discountDetailId: // value for 'discountDetailId'
 *      discountType: // value for 'discountType'
 *      inquiryDate: // value for 'inquiryDate'
 *      partnershipId: // value for 'partnershipId'
 *      partnershipIds: // value for 'partnershipIds'
 *      scopeType: // value for 'scopeType'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetDiscountsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscountsPaginatedQuery, GetDiscountsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountsPaginatedQuery, GetDiscountsPaginatedQueryVariables>(GetDiscountsPaginatedDocument, options);
      }
export function useGetDiscountsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountsPaginatedQuery, GetDiscountsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountsPaginatedQuery, GetDiscountsPaginatedQueryVariables>(GetDiscountsPaginatedDocument, options);
        }
export type GetDiscountsPaginatedQueryHookResult = ReturnType<typeof useGetDiscountsPaginatedQuery>;
export type GetDiscountsPaginatedLazyQueryHookResult = ReturnType<typeof useGetDiscountsPaginatedLazyQuery>;
export type GetDiscountsPaginatedQueryResult = Apollo.QueryResult<GetDiscountsPaginatedQuery, GetDiscountsPaginatedQueryVariables>;
export const GetDiscountUsageDocument = gql`
    query getDiscountUsage($clientId: Int, $discountDetailIds: [Int!], $partnershipId: Int) {
  getDiscountUsage(
    clientId: $clientId
    discountDetailIds: $discountDetailIds
    partnershipId: $partnershipId
  ) {
    discountDetailId
    discountSum
    discountPercent
    totalCount
  }
}
    `;

/**
 * __useGetDiscountUsageQuery__
 *
 * To run a query within a React component, call `useGetDiscountUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountUsageQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      discountDetailIds: // value for 'discountDetailIds'
 *      partnershipId: // value for 'partnershipId'
 *   },
 * });
 */
export function useGetDiscountUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscountUsageQuery, GetDiscountUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountUsageQuery, GetDiscountUsageQueryVariables>(GetDiscountUsageDocument, options);
      }
export function useGetDiscountUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountUsageQuery, GetDiscountUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountUsageQuery, GetDiscountUsageQueryVariables>(GetDiscountUsageDocument, options);
        }
export type GetDiscountUsageQueryHookResult = ReturnType<typeof useGetDiscountUsageQuery>;
export type GetDiscountUsageLazyQueryHookResult = ReturnType<typeof useGetDiscountUsageLazyQuery>;
export type GetDiscountUsageQueryResult = Apollo.QueryResult<GetDiscountUsageQuery, GetDiscountUsageQueryVariables>;
export const GetEngagementsByUserUuidDocument = gql`
    query getEngagementsByUserUuid($uuid: String!, $startDate: String!, $endDate: String, $page: Int, $size: Int) {
  getEngagementsByUserUuid(
    uuid: $uuid
    startDate: $startDate
    endDate: $endDate
    page: $page
    size: $size
  ) {
    items {
      id
      eventId
      programId
      billableCount
      eventUuid
      eventType
      userUuid
      programIndication
      sourceType
      details
      queuedAt
      occurredAt
      createdAt
    }
    page
    pages
    size
    total
  }
}
    `;

/**
 * __useGetEngagementsByUserUuidQuery__
 *
 * To run a query within a React component, call `useGetEngagementsByUserUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementsByUserUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementsByUserUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetEngagementsByUserUuidQuery(baseOptions: Apollo.QueryHookOptions<GetEngagementsByUserUuidQuery, GetEngagementsByUserUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEngagementsByUserUuidQuery, GetEngagementsByUserUuidQueryVariables>(GetEngagementsByUserUuidDocument, options);
      }
export function useGetEngagementsByUserUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngagementsByUserUuidQuery, GetEngagementsByUserUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEngagementsByUserUuidQuery, GetEngagementsByUserUuidQueryVariables>(GetEngagementsByUserUuidDocument, options);
        }
export type GetEngagementsByUserUuidQueryHookResult = ReturnType<typeof useGetEngagementsByUserUuidQuery>;
export type GetEngagementsByUserUuidLazyQueryHookResult = ReturnType<typeof useGetEngagementsByUserUuidLazyQuery>;
export type GetEngagementsByUserUuidQueryResult = Apollo.QueryResult<GetEngagementsByUserUuidQuery, GetEngagementsByUserUuidQueryVariables>;
export const GetEsiFeeSchedulesDocument = gql`
    query getEsiFeeSchedules {
  getEsiFeeSchedules {
    id
    program
    paymentType
    price
    upc
    description
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;

/**
 * __useGetEsiFeeSchedulesQuery__
 *
 * To run a query within a React component, call `useGetEsiFeeSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsiFeeSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsiFeeSchedulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEsiFeeSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<GetEsiFeeSchedulesQuery, GetEsiFeeSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsiFeeSchedulesQuery, GetEsiFeeSchedulesQueryVariables>(GetEsiFeeSchedulesDocument, options);
      }
export function useGetEsiFeeSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEsiFeeSchedulesQuery, GetEsiFeeSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsiFeeSchedulesQuery, GetEsiFeeSchedulesQueryVariables>(GetEsiFeeSchedulesDocument, options);
        }
export type GetEsiFeeSchedulesQueryHookResult = ReturnType<typeof useGetEsiFeeSchedulesQuery>;
export type GetEsiFeeSchedulesLazyQueryHookResult = ReturnType<typeof useGetEsiFeeSchedulesLazyQuery>;
export type GetEsiFeeSchedulesQueryResult = Apollo.QueryResult<GetEsiFeeSchedulesQuery, GetEsiFeeSchedulesQueryVariables>;
export const GetFeeForServiceEventsDocument = gql`
    query getFeeForServiceEvents($userIds: [Int!], $userUuids: [String!], $includeVoid: Boolean) {
  getFeeForServiceEvents(
    userIds: $userIds
    userUuids: $userUuids
    includeVoid: $includeVoid
  ) {
    items {
      id
      userId
      userUuid
      pathwayUuid
      contractPackageId
      contractId
      engagementEventId
      occurredAt
      createdAt
      updatedAt
      void
      adminUuid
    }
    page
    pages
    size
    total
  }
}
    `;

/**
 * __useGetFeeForServiceEventsQuery__
 *
 * To run a query within a React component, call `useGetFeeForServiceEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeeForServiceEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeeForServiceEventsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      userUuids: // value for 'userUuids'
 *      includeVoid: // value for 'includeVoid'
 *   },
 * });
 */
export function useGetFeeForServiceEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeeForServiceEventsQuery, GetFeeForServiceEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeeForServiceEventsQuery, GetFeeForServiceEventsQueryVariables>(GetFeeForServiceEventsDocument, options);
      }
export function useGetFeeForServiceEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeeForServiceEventsQuery, GetFeeForServiceEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeeForServiceEventsQuery, GetFeeForServiceEventsQueryVariables>(GetFeeForServiceEventsDocument, options);
        }
export type GetFeeForServiceEventsQueryHookResult = ReturnType<typeof useGetFeeForServiceEventsQuery>;
export type GetFeeForServiceEventsLazyQueryHookResult = ReturnType<typeof useGetFeeForServiceEventsLazyQuery>;
export type GetFeeForServiceEventsQueryResult = Apollo.QueryResult<GetFeeForServiceEventsQuery, GetFeeForServiceEventsQueryVariables>;
export const GetBillsByFeeForServiceEventIdDocument = gql`
    query getBillsByFeeForServiceEventId($feeForServiceEventId: Int, $sourceId: Int, $source: String) {
  getBillsByFeeForServiceEventId(
    feeForServiceEventId: $feeForServiceEventId
    sourceId: $sourceId
    source: $source
  ) {
    baseCharge
    billAmount
    claimIdentifier
    details
    coverageId
    createdAt
    fromDate
    id
    pathwayId
    paymentType
    source
    sourceId
    status
    toDate
    updatedAt
    submissions {
      billId
      coverageId
      createdAt
      id
      netsuiteId
      status
      submissionAmount
      submissionDate
      transactionId
      updatedAt
      corrections {
        correctionAmount
        correctionsType
        createdAt
        lastModifiedBy
        netsuiteId
        submissionId
      }
      remits {
        createdAt
        icn
        id
        patientPaymentAmount
        payer
        paymentAmount
        paymentDate
        paymentNumber
        paymentType
        responseDate
        sourceOfRecord
      }
    }
    internalHolds {
      billId
      holdType
      note
      clearedAt
      createdAt
    }
  }
}
    `;

/**
 * __useGetBillsByFeeForServiceEventIdQuery__
 *
 * To run a query within a React component, call `useGetBillsByFeeForServiceEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillsByFeeForServiceEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillsByFeeForServiceEventIdQuery({
 *   variables: {
 *      feeForServiceEventId: // value for 'feeForServiceEventId'
 *      sourceId: // value for 'sourceId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGetBillsByFeeForServiceEventIdQuery(baseOptions?: Apollo.QueryHookOptions<GetBillsByFeeForServiceEventIdQuery, GetBillsByFeeForServiceEventIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillsByFeeForServiceEventIdQuery, GetBillsByFeeForServiceEventIdQueryVariables>(GetBillsByFeeForServiceEventIdDocument, options);
      }
export function useGetBillsByFeeForServiceEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillsByFeeForServiceEventIdQuery, GetBillsByFeeForServiceEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillsByFeeForServiceEventIdQuery, GetBillsByFeeForServiceEventIdQueryVariables>(GetBillsByFeeForServiceEventIdDocument, options);
        }
export type GetBillsByFeeForServiceEventIdQueryHookResult = ReturnType<typeof useGetBillsByFeeForServiceEventIdQuery>;
export type GetBillsByFeeForServiceEventIdLazyQueryHookResult = ReturnType<typeof useGetBillsByFeeForServiceEventIdLazyQuery>;
export type GetBillsByFeeForServiceEventIdQueryResult = Apollo.QueryResult<GetBillsByFeeForServiceEventIdQuery, GetBillsByFeeForServiceEventIdQueryVariables>;
export const GetFeeForServiceEngagementsDocument = gql`
    query getFeeForServiceEngagements($feeForServiceEventId: Int!, $page: Int, $size: Int) {
  getFeeForServiceEngagements(
    feeForServiceEventId: $feeForServiceEventId
    page: $page
    size: $size
  ) {
    items {
      id
      eventId
      programId
      billableCount
      eventUuid
      eventType
      userUuid
      programIndication
      sourceType
      details
      queuedAt
      occurredAt
      createdAt
    }
    page
    pages
    size
    total
  }
}
    `;

/**
 * __useGetFeeForServiceEngagementsQuery__
 *
 * To run a query within a React component, call `useGetFeeForServiceEngagementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeeForServiceEngagementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeeForServiceEngagementsQuery({
 *   variables: {
 *      feeForServiceEventId: // value for 'feeForServiceEventId'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetFeeForServiceEngagementsQuery(baseOptions: Apollo.QueryHookOptions<GetFeeForServiceEngagementsQuery, GetFeeForServiceEngagementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeeForServiceEngagementsQuery, GetFeeForServiceEngagementsQueryVariables>(GetFeeForServiceEngagementsDocument, options);
      }
export function useGetFeeForServiceEngagementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeeForServiceEngagementsQuery, GetFeeForServiceEngagementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeeForServiceEngagementsQuery, GetFeeForServiceEngagementsQueryVariables>(GetFeeForServiceEngagementsDocument, options);
        }
export type GetFeeForServiceEngagementsQueryHookResult = ReturnType<typeof useGetFeeForServiceEngagementsQuery>;
export type GetFeeForServiceEngagementsLazyQueryHookResult = ReturnType<typeof useGetFeeForServiceEngagementsLazyQuery>;
export type GetFeeForServiceEngagementsQueryResult = Apollo.QueryResult<GetFeeForServiceEngagementsQuery, GetFeeForServiceEngagementsQueryVariables>;
export const GetFeeSchedulesDocument = gql`
    query getFeeSchedules($entityType: FeeScheduleEntityType!, $entityIds: [Int!], $paymentSystems: [PaymentSystemType!], $paymentTypes: [String!], $priceMin: Float, $priceMax: Float, $enabled: Boolean, $page: Int, $size: Int) {
  getFeeSchedules(
    entityType: $entityType
    entityIds: $entityIds
    paymentSystems: $paymentSystems
    paymentTypes: $paymentTypes
    priceMin: $priceMin
    priceMax: $priceMax
    enabled: $enabled
    page: $page
    size: $size
  ) {
    total
    page
    size
    pages
    items {
      id
      entityType
      entityId
      paymentSystem
      paymentType
      price
      enabled
      notes
      createdAt
      updatedAt
      lastModifiedBy
    }
  }
}
    `;

/**
 * __useGetFeeSchedulesQuery__
 *
 * To run a query within a React component, call `useGetFeeSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeeSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeeSchedulesQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityIds: // value for 'entityIds'
 *      paymentSystems: // value for 'paymentSystems'
 *      paymentTypes: // value for 'paymentTypes'
 *      priceMin: // value for 'priceMin'
 *      priceMax: // value for 'priceMax'
 *      enabled: // value for 'enabled'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetFeeSchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetFeeSchedulesQuery, GetFeeSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeeSchedulesQuery, GetFeeSchedulesQueryVariables>(GetFeeSchedulesDocument, options);
      }
export function useGetFeeSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeeSchedulesQuery, GetFeeSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeeSchedulesQuery, GetFeeSchedulesQueryVariables>(GetFeeSchedulesDocument, options);
        }
export type GetFeeSchedulesQueryHookResult = ReturnType<typeof useGetFeeSchedulesQuery>;
export type GetFeeSchedulesLazyQueryHookResult = ReturnType<typeof useGetFeeSchedulesLazyQuery>;
export type GetFeeSchedulesQueryResult = Apollo.QueryResult<GetFeeSchedulesQuery, GetFeeSchedulesQueryVariables>;
export const GetFeeScheduleByIdDocument = gql`
    query getFeeScheduleById($id: Int!) {
  getFeeScheduleById(id: $id) {
    id
    entityType
    entityId
    paymentSystem
    paymentType
    price
    enabled
    notes
    createdAt
    updatedAt
    lastModifiedBy
  }
}
    `;

/**
 * __useGetFeeScheduleByIdQuery__
 *
 * To run a query within a React component, call `useGetFeeScheduleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeeScheduleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeeScheduleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFeeScheduleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFeeScheduleByIdQuery, GetFeeScheduleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeeScheduleByIdQuery, GetFeeScheduleByIdQueryVariables>(GetFeeScheduleByIdDocument, options);
      }
export function useGetFeeScheduleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeeScheduleByIdQuery, GetFeeScheduleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeeScheduleByIdQuery, GetFeeScheduleByIdQueryVariables>(GetFeeScheduleByIdDocument, options);
        }
export type GetFeeScheduleByIdQueryHookResult = ReturnType<typeof useGetFeeScheduleByIdQuery>;
export type GetFeeScheduleByIdLazyQueryHookResult = ReturnType<typeof useGetFeeScheduleByIdLazyQuery>;
export type GetFeeScheduleByIdQueryResult = Apollo.QueryResult<GetFeeScheduleByIdQuery, GetFeeScheduleByIdQueryVariables>;
export const GetIcdCodesDocument = gql`
    query getIcdCodes($page: Int, $size: Int) {
  getIcdCodes(page: $page, size: $size) {
    items {
      id
      indication
      universalCode
      rightCode
      leftCode
      startDate
      endDate
      createdAt
    }
    total
    page
    size
    pages
  }
}
    `;

/**
 * __useGetIcdCodesQuery__
 *
 * To run a query within a React component, call `useGetIcdCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIcdCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIcdCodesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetIcdCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetIcdCodesQuery, GetIcdCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIcdCodesQuery, GetIcdCodesQueryVariables>(GetIcdCodesDocument, options);
      }
export function useGetIcdCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIcdCodesQuery, GetIcdCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIcdCodesQuery, GetIcdCodesQueryVariables>(GetIcdCodesDocument, options);
        }
export type GetIcdCodesQueryHookResult = ReturnType<typeof useGetIcdCodesQuery>;
export type GetIcdCodesLazyQueryHookResult = ReturnType<typeof useGetIcdCodesLazyQuery>;
export type GetIcdCodesQueryResult = Apollo.QueryResult<GetIcdCodesQuery, GetIcdCodesQueryVariables>;
export const GetAllInsurersDocument = gql`
    query getAllInsurers {
  getAllInsurers {
    id
    identifier
    name
  }
}
    `;

/**
 * __useGetAllInsurersQuery__
 *
 * To run a query within a React component, call `useGetAllInsurersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInsurersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInsurersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllInsurersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllInsurersQuery, GetAllInsurersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInsurersQuery, GetAllInsurersQueryVariables>(GetAllInsurersDocument, options);
      }
export function useGetAllInsurersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInsurersQuery, GetAllInsurersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInsurersQuery, GetAllInsurersQueryVariables>(GetAllInsurersDocument, options);
        }
export type GetAllInsurersQueryHookResult = ReturnType<typeof useGetAllInsurersQuery>;
export type GetAllInsurersLazyQueryHookResult = ReturnType<typeof useGetAllInsurersLazyQuery>;
export type GetAllInsurersQueryResult = Apollo.QueryResult<GetAllInsurersQuery, GetAllInsurersQueryVariables>;
export const GetPackageRulesDocument = gql`
    query getPackageRules {
  getPackageRules {
    billingModels
  }
}
    `;

/**
 * __useGetPackageRulesQuery__
 *
 * To run a query within a React component, call `useGetPackageRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPackageRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetPackageRulesQuery, GetPackageRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageRulesQuery, GetPackageRulesQueryVariables>(GetPackageRulesDocument, options);
      }
export function useGetPackageRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageRulesQuery, GetPackageRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageRulesQuery, GetPackageRulesQueryVariables>(GetPackageRulesDocument, options);
        }
export type GetPackageRulesQueryHookResult = ReturnType<typeof useGetPackageRulesQuery>;
export type GetPackageRulesLazyQueryHookResult = ReturnType<typeof useGetPackageRulesLazyQuery>;
export type GetPackageRulesQueryResult = Apollo.QueryResult<GetPackageRulesQuery, GetPackageRulesQueryVariables>;
export const GetPartnershipsDocument = gql`
    query getPartnerships($id: Int, $type: String) {
  getPartnerships(id: $id, type: $type) {
    id
    name
    partnershipType
    allowCohortExpansion
    requiresStateCredentials
  }
}
    `;

/**
 * __useGetPartnershipsQuery__
 *
 * To run a query within a React component, call `useGetPartnershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnershipsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPartnershipsQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnershipsQuery, GetPartnershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnershipsQuery, GetPartnershipsQueryVariables>(GetPartnershipsDocument, options);
      }
export function useGetPartnershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnershipsQuery, GetPartnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnershipsQuery, GetPartnershipsQueryVariables>(GetPartnershipsDocument, options);
        }
export type GetPartnershipsQueryHookResult = ReturnType<typeof useGetPartnershipsQuery>;
export type GetPartnershipsLazyQueryHookResult = ReturnType<typeof useGetPartnershipsLazyQuery>;
export type GetPartnershipsQueryResult = Apollo.QueryResult<GetPartnershipsQuery, GetPartnershipsQueryVariables>;
export const GetPaymentTypesDocument = gql`
    query getPaymentTypes {
  getPaymentTypes {
    id
    code
    name
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetPaymentTypesQuery__
 *
 * To run a query within a React component, call `useGetPaymentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentTypesQuery, GetPaymentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentTypesQuery, GetPaymentTypesQueryVariables>(GetPaymentTypesDocument, options);
      }
export function useGetPaymentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentTypesQuery, GetPaymentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentTypesQuery, GetPaymentTypesQueryVariables>(GetPaymentTypesDocument, options);
        }
export type GetPaymentTypesQueryHookResult = ReturnType<typeof useGetPaymentTypesQuery>;
export type GetPaymentTypesLazyQueryHookResult = ReturnType<typeof useGetPaymentTypesLazyQuery>;
export type GetPaymentTypesQueryResult = Apollo.QueryResult<GetPaymentTypesQuery, GetPaymentTypesQueryVariables>;
export const GetProcedureCodesDocument = gql`
    query getProcedureCodes($partnershipId: Int, $insurerId: Int, $clientId: Int, $code: String, $paymentType: String, $page: Int, $size: Int) {
  getProcedureCodes(
    partnershipId: $partnershipId
    insurerId: $insurerId
    clientId: $clientId
    code: $code
    paymentType: $paymentType
    page: $page
    size: $size
  ) {
    total
    page
    size
    pages
    items {
      id
      paymentTypeId
      cptCode
      modifier1
      modifier2
      partnershipId
      insurerId
      clientId
      lastModifiedBy
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetProcedureCodesQuery__
 *
 * To run a query within a React component, call `useGetProcedureCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcedureCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcedureCodesQuery({
 *   variables: {
 *      partnershipId: // value for 'partnershipId'
 *      insurerId: // value for 'insurerId'
 *      clientId: // value for 'clientId'
 *      code: // value for 'code'
 *      paymentType: // value for 'paymentType'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetProcedureCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetProcedureCodesQuery, GetProcedureCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcedureCodesQuery, GetProcedureCodesQueryVariables>(GetProcedureCodesDocument, options);
      }
export function useGetProcedureCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcedureCodesQuery, GetProcedureCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcedureCodesQuery, GetProcedureCodesQueryVariables>(GetProcedureCodesDocument, options);
        }
export type GetProcedureCodesQueryHookResult = ReturnType<typeof useGetProcedureCodesQuery>;
export type GetProcedureCodesLazyQueryHookResult = ReturnType<typeof useGetProcedureCodesLazyQuery>;
export type GetProcedureCodesQueryResult = Apollo.QueryResult<GetProcedureCodesQuery, GetProcedureCodesQueryVariables>;
export const ProductOfferingsDocument = gql`
    query productOfferings {
  productOfferings {
    id
    name
    productId
  }
}
    `;

/**
 * __useProductOfferingsQuery__
 *
 * To run a query within a React component, call `useProductOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductOfferingsQuery(baseOptions?: Apollo.QueryHookOptions<ProductOfferingsQuery, ProductOfferingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductOfferingsQuery, ProductOfferingsQueryVariables>(ProductOfferingsDocument, options);
      }
export function useProductOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductOfferingsQuery, ProductOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductOfferingsQuery, ProductOfferingsQueryVariables>(ProductOfferingsDocument, options);
        }
export type ProductOfferingsQueryHookResult = ReturnType<typeof useProductOfferingsQuery>;
export type ProductOfferingsLazyQueryHookResult = ReturnType<typeof useProductOfferingsLazyQuery>;
export type ProductOfferingsQueryResult = Apollo.QueryResult<ProductOfferingsQuery, ProductOfferingsQueryVariables>;
export const GetProgramCapsDocument = gql`
    query GetProgramCaps($clientId: Int, $programCapIds: [Int!], $page: Int!, $size: Int) {
  getProgramCaps(
    clientId: $clientId
    programCapIds: $programCapIds
    page: $page
    size: $size
  ) {
    items {
      id
      clientId
      cap
      startDate
      endDate
      lockDate
      lockPrice
      correctedUserBasedLockPrice
    }
    page
    pages
    size
    total
  }
}
    `;

/**
 * __useGetProgramCapsQuery__
 *
 * To run a query within a React component, call `useGetProgramCapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramCapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramCapsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      programCapIds: // value for 'programCapIds'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetProgramCapsQuery(baseOptions: Apollo.QueryHookOptions<GetProgramCapsQuery, GetProgramCapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramCapsQuery, GetProgramCapsQueryVariables>(GetProgramCapsDocument, options);
      }
export function useGetProgramCapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramCapsQuery, GetProgramCapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramCapsQuery, GetProgramCapsQueryVariables>(GetProgramCapsDocument, options);
        }
export type GetProgramCapsQueryHookResult = ReturnType<typeof useGetProgramCapsQuery>;
export type GetProgramCapsLazyQueryHookResult = ReturnType<typeof useGetProgramCapsLazyQuery>;
export type GetProgramCapsQueryResult = Apollo.QueryResult<GetProgramCapsQuery, GetProgramCapsQueryVariables>;
export const GetProgramCapRefundByIdDocument = gql`
    query GetProgramCapRefundById($programCapId: Int!) {
  getProgramCapRefundById(programCapId: $programCapId) {
    clientId
    cap
    sumAmount
    numMembers
    averageStickerPrice
    refundPerMember
    totalRefundAmount
    startDate
    endDate
    lockDate
    lockPrice
    programCapId
    reportLink
  }
}
    `;

/**
 * __useGetProgramCapRefundByIdQuery__
 *
 * To run a query within a React component, call `useGetProgramCapRefundByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramCapRefundByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramCapRefundByIdQuery({
 *   variables: {
 *      programCapId: // value for 'programCapId'
 *   },
 * });
 */
export function useGetProgramCapRefundByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProgramCapRefundByIdQuery, GetProgramCapRefundByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramCapRefundByIdQuery, GetProgramCapRefundByIdQueryVariables>(GetProgramCapRefundByIdDocument, options);
      }
export function useGetProgramCapRefundByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramCapRefundByIdQuery, GetProgramCapRefundByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramCapRefundByIdQuery, GetProgramCapRefundByIdQueryVariables>(GetProgramCapRefundByIdDocument, options);
        }
export type GetProgramCapRefundByIdQueryHookResult = ReturnType<typeof useGetProgramCapRefundByIdQuery>;
export type GetProgramCapRefundByIdLazyQueryHookResult = ReturnType<typeof useGetProgramCapRefundByIdLazyQuery>;
export type GetProgramCapRefundByIdQueryResult = Apollo.QueryResult<GetProgramCapRefundByIdQuery, GetProgramCapRefundByIdQueryVariables>;
export const GetAllProgramIndicationsDocument = gql`
    query getAllProgramIndications {
  getProgramIndicationsById {
    id
    identifier
    indicationName
    programName
    programId
  }
}
    `;

/**
 * __useGetAllProgramIndicationsQuery__
 *
 * To run a query within a React component, call `useGetAllProgramIndicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProgramIndicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProgramIndicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProgramIndicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProgramIndicationsQuery, GetAllProgramIndicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProgramIndicationsQuery, GetAllProgramIndicationsQueryVariables>(GetAllProgramIndicationsDocument, options);
      }
export function useGetAllProgramIndicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProgramIndicationsQuery, GetAllProgramIndicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProgramIndicationsQuery, GetAllProgramIndicationsQueryVariables>(GetAllProgramIndicationsDocument, options);
        }
export type GetAllProgramIndicationsQueryHookResult = ReturnType<typeof useGetAllProgramIndicationsQuery>;
export type GetAllProgramIndicationsLazyQueryHookResult = ReturnType<typeof useGetAllProgramIndicationsLazyQuery>;
export type GetAllProgramIndicationsQueryResult = Apollo.QueryResult<GetAllProgramIndicationsQuery, GetAllProgramIndicationsQueryVariables>;
export const GetResolvedProcedureCodesDocument = gql`
    query getResolvedProcedureCodes($partnershipId: Int, $insurerId: Int, $clientId: Int) {
  getResolvedProcedureCodes(
    partnershipId: $partnershipId
    insurerId: $insurerId
    clientId: $clientId
  ) {
    id
    paymentTypeId
    cptCode
    modifier1
    modifier2
    partnershipId
    insurerId
    clientId
    lastModifiedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetResolvedProcedureCodesQuery__
 *
 * To run a query within a React component, call `useGetResolvedProcedureCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolvedProcedureCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolvedProcedureCodesQuery({
 *   variables: {
 *      partnershipId: // value for 'partnershipId'
 *      insurerId: // value for 'insurerId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetResolvedProcedureCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetResolvedProcedureCodesQuery, GetResolvedProcedureCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResolvedProcedureCodesQuery, GetResolvedProcedureCodesQueryVariables>(GetResolvedProcedureCodesDocument, options);
      }
export function useGetResolvedProcedureCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResolvedProcedureCodesQuery, GetResolvedProcedureCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResolvedProcedureCodesQuery, GetResolvedProcedureCodesQueryVariables>(GetResolvedProcedureCodesDocument, options);
        }
export type GetResolvedProcedureCodesQueryHookResult = ReturnType<typeof useGetResolvedProcedureCodesQuery>;
export type GetResolvedProcedureCodesLazyQueryHookResult = ReturnType<typeof useGetResolvedProcedureCodesLazyQuery>;
export type GetResolvedProcedureCodesQueryResult = Apollo.QueryResult<GetResolvedProcedureCodesQuery, GetResolvedProcedureCodesQueryVariables>;
export const GetRevenueSharesDocument = gql`
    query getRevenueShares($clientId: Int, $partnershipId: Int, $partnershipIds: [Int!], $effectiveYear: Int, $revenueShareDefinitionId: Int, $scopeType: ScopeType) {
  getRevenueShares(
    clientId: $clientId
    partnershipId: $partnershipId
    partnershipIds: $partnershipIds
    effectiveYear: $effectiveYear
    revenueShareDefinitionId: $revenueShareDefinitionId
    scopeType: $scopeType
  ) {
    revenueShareDetailId
    revenueShareDefinitionId
    clientId
    partnershipId
    scopes {
      scopeableType
      scopeableId
    }
    name
    tier
    discount
    subscriptionTier
    applyToPrice
    effectiveYear
  }
}
    `;

/**
 * __useGetRevenueSharesQuery__
 *
 * To run a query within a React component, call `useGetRevenueSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueSharesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      partnershipId: // value for 'partnershipId'
 *      partnershipIds: // value for 'partnershipIds'
 *      effectiveYear: // value for 'effectiveYear'
 *      revenueShareDefinitionId: // value for 'revenueShareDefinitionId'
 *      scopeType: // value for 'scopeType'
 *   },
 * });
 */
export function useGetRevenueSharesQuery(baseOptions?: Apollo.QueryHookOptions<GetRevenueSharesQuery, GetRevenueSharesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueSharesQuery, GetRevenueSharesQueryVariables>(GetRevenueSharesDocument, options);
      }
export function useGetRevenueSharesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueSharesQuery, GetRevenueSharesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueSharesQuery, GetRevenueSharesQueryVariables>(GetRevenueSharesDocument, options);
        }
export type GetRevenueSharesQueryHookResult = ReturnType<typeof useGetRevenueSharesQuery>;
export type GetRevenueSharesLazyQueryHookResult = ReturnType<typeof useGetRevenueSharesLazyQuery>;
export type GetRevenueSharesQueryResult = Apollo.QueryResult<GetRevenueSharesQuery, GetRevenueSharesQueryVariables>;
export const GetSubscriptionsDocument = gql`
    query getSubscriptions($userId: Int, $userUuid: String, $ids: [Int!], $page: Int, $size: Int, $includeVoid: Boolean) {
  getSubscriptions(
    userId: $userId
    userUuid: $userUuid
    ids: $ids
    page: $page
    size: $size
    includeVoid: $includeVoid
  ) {
    items {
      contractId
      createdAt
      endsAt
      id
      pathwayId
      pathwayUuid
      programId
      startsAt
      termDate
      userId
      userUuid
      void
      yearCount
      subscriptionPackages {
        id
        contractPackageId
        subscriptionId
        packageCap
        startsAt
        eventUuid
        createdAt
        updatedAt
      }
    }
    page
    pages
    size
    total
  }
}
    `;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      userUuid: // value for 'userUuid'
 *      ids: // value for 'ids'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      includeVoid: // value for 'includeVoid'
 *   },
 * });
 */
export function useGetSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
      }
export function useGetSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export type GetSubscriptionsQueryHookResult = ReturnType<typeof useGetSubscriptionsQuery>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsLazyQuery>;
export type GetSubscriptionsQueryResult = Apollo.QueryResult<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>;
export const GetSubscriptionEngagementsDocument = gql`
    query getSubscriptionEngagements($subscriptionId: Int!, $page: Int, $size: Int) {
  getSubscriptionEngagements(
    subscriptionId: $subscriptionId
    page: $page
    size: $size
  ) {
    items {
      id
      eventId
      programId
      billableCount
      eventUuid
      eventType
      userUuid
      programIndication
      sourceType
      details
      queuedAt
      occurredAt
      createdAt
    }
    page
    pages
    size
    total
  }
}
    `;

/**
 * __useGetSubscriptionEngagementsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionEngagementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionEngagementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionEngagementsQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetSubscriptionEngagementsQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionEngagementsQuery, GetSubscriptionEngagementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionEngagementsQuery, GetSubscriptionEngagementsQueryVariables>(GetSubscriptionEngagementsDocument, options);
      }
export function useGetSubscriptionEngagementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionEngagementsQuery, GetSubscriptionEngagementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionEngagementsQuery, GetSubscriptionEngagementsQueryVariables>(GetSubscriptionEngagementsDocument, options);
        }
export type GetSubscriptionEngagementsQueryHookResult = ReturnType<typeof useGetSubscriptionEngagementsQuery>;
export type GetSubscriptionEngagementsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionEngagementsLazyQuery>;
export type GetSubscriptionEngagementsQueryResult = Apollo.QueryResult<GetSubscriptionEngagementsQuery, GetSubscriptionEngagementsQueryVariables>;
export const GetSubscriptionHoldsByUserDocument = gql`
    query getSubscriptionHoldsByUser($userId: Int, $userUuid: String) {
  getSubscriptionHoldsByUser(userId: $userId, userUuid: $userUuid) {
    id
    clearedAt
    firstSeenAt
    hitCount
    lastSeenAt
    programId
    reason
    userId
    userUuid
    details
  }
}
    `;

/**
 * __useGetSubscriptionHoldsByUserQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionHoldsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionHoldsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionHoldsByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useGetSubscriptionHoldsByUserQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionHoldsByUserQuery, GetSubscriptionHoldsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionHoldsByUserQuery, GetSubscriptionHoldsByUserQueryVariables>(GetSubscriptionHoldsByUserDocument, options);
      }
export function useGetSubscriptionHoldsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionHoldsByUserQuery, GetSubscriptionHoldsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionHoldsByUserQuery, GetSubscriptionHoldsByUserQueryVariables>(GetSubscriptionHoldsByUserDocument, options);
        }
export type GetSubscriptionHoldsByUserQueryHookResult = ReturnType<typeof useGetSubscriptionHoldsByUserQuery>;
export type GetSubscriptionHoldsByUserLazyQueryHookResult = ReturnType<typeof useGetSubscriptionHoldsByUserLazyQuery>;
export type GetSubscriptionHoldsByUserQueryResult = Apollo.QueryResult<GetSubscriptionHoldsByUserQuery, GetSubscriptionHoldsByUserQueryVariables>;
export const GetBillsBySubscriptionIdDocument = gql`
    query getBillsBySubscriptionId($source: String!, $sourceId: Int!) {
  getBillsBySubscriptionId(source: $source, sourceId: $sourceId) {
    baseCharge
    billAmount
    claimIdentifier
    details
    coverageId
    createdAt
    fromDate
    id
    pathwayId
    paymentType
    source
    sourceId
    status
    toDate
    updatedAt
    submissions {
      billId
      coverageId
      createdAt
      id
      netsuiteId
      status
      submissionAmount
      submissionDate
      transactionId
      updatedAt
      corrections {
        correctionAmount
        correctionsType
        createdAt
        lastModifiedBy
        netsuiteId
        submissionId
      }
      remits {
        createdAt
        icn
        id
        patientPaymentAmount
        payer
        paymentAmount
        paymentDate
        paymentNumber
        paymentType
        responseDate
        sourceOfRecord
      }
    }
    internalHolds {
      billId
      holdType
      note
      clearedAt
      createdAt
    }
  }
}
    `;

/**
 * __useGetBillsBySubscriptionIdQuery__
 *
 * To run a query within a React component, call `useGetBillsBySubscriptionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillsBySubscriptionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillsBySubscriptionIdQuery({
 *   variables: {
 *      source: // value for 'source'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useGetBillsBySubscriptionIdQuery(baseOptions: Apollo.QueryHookOptions<GetBillsBySubscriptionIdQuery, GetBillsBySubscriptionIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillsBySubscriptionIdQuery, GetBillsBySubscriptionIdQueryVariables>(GetBillsBySubscriptionIdDocument, options);
      }
export function useGetBillsBySubscriptionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillsBySubscriptionIdQuery, GetBillsBySubscriptionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillsBySubscriptionIdQuery, GetBillsBySubscriptionIdQueryVariables>(GetBillsBySubscriptionIdDocument, options);
        }
export type GetBillsBySubscriptionIdQueryHookResult = ReturnType<typeof useGetBillsBySubscriptionIdQuery>;
export type GetBillsBySubscriptionIdLazyQueryHookResult = ReturnType<typeof useGetBillsBySubscriptionIdLazyQuery>;
export type GetBillsBySubscriptionIdQueryResult = Apollo.QueryResult<GetBillsBySubscriptionIdQuery, GetBillsBySubscriptionIdQueryVariables>;
export const GetUserUuidByIdDocument = gql`
    query getUserUuidById($id: Int!) {
  getUserUuidById(id: $id) {
    uuid
  }
}
    `;

/**
 * __useGetUserUuidByIdQuery__
 *
 * To run a query within a React component, call `useGetUserUuidByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserUuidByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserUuidByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserUuidByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserUuidByIdQuery, GetUserUuidByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserUuidByIdQuery, GetUserUuidByIdQueryVariables>(GetUserUuidByIdDocument, options);
      }
export function useGetUserUuidByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserUuidByIdQuery, GetUserUuidByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserUuidByIdQuery, GetUserUuidByIdQueryVariables>(GetUserUuidByIdDocument, options);
        }
export type GetUserUuidByIdQueryHookResult = ReturnType<typeof useGetUserUuidByIdQuery>;
export type GetUserUuidByIdLazyQueryHookResult = ReturnType<typeof useGetUserUuidByIdLazyQuery>;
export type GetUserUuidByIdQueryResult = Apollo.QueryResult<GetUserUuidByIdQuery, GetUserUuidByIdQueryVariables>;